const fr: Record<string, string> = {
  // --- LEA-319 Trust-Redesign (variant '50credits-trust'). FR gate copy
  //     translated from the approved DE/EN mockups (Om signs off wording in QA).
  //     Testimonial names/quotes/roles + photos are verbatim from the Webflow
  //     CMS (Janik 2026-06-11).
  'og.title.trust.lead': 'Essayez Leadscraper ',
  'og.title.trust.grad': '3 jours gratuits',
  'og.title.trust.tail': ' avec 50 leads réels.',
  'og.subtitle.trust':
    "Aucun débit aujourd'hui. Vous testez avec de vrais leads issus de votre cible, et si cela ne vous convient pas, vous arrêtez l'essai en un clic. Sans appel, sans préavis.",
  'og.trust.demo.tag': 'Démo en direct · pas une vidéo marketing',
  'og.trust.demo.title': 'Découvrez comment Leadscraper trouve vos leads',
  'og.trust.demo.body':
    "Vraie recherche, vrai tableau de bord, vrais résultats : le fondateur Janik vous montre l'ensemble du processus, de la description de votre cible jusqu'à la liste de leads finalisée.",
  'og.trust.demo.play': 'Lancer la vidéo de démo',
  'og.trust.demo.close': 'Fermer',
  'og.trust.timeline.1.when': "Aujourd'hui",
  'og.trust.timeline.1.body':
    'Choisissez un plan, ajoutez un moyen de paiement. {s}. Vos 50 crédits sont immédiatement disponibles.',
  'og.trust.timeline.1.strong': '0 € débité',
  'og.trust.timeline.2.when': 'Jours 1 à 3',
  'og.trust.timeline.2.body':
    "Vous testez avec de vrais leads. Pas convaincu ? {s} met fin à l'essai instantanément, sans contact, sans justification.",
  'og.trust.timeline.2.strong': 'Un clic dans votre compte',
  'og.trust.timeline.3.when': 'À partir du jour 3',
  'og.trust.timeline.3.body':
    "Ce n'est qu'à ce moment-là que votre abonnement démarre, dans le plan choisi. {s}, sans durée minimale.",
  'og.trust.timeline.3.strong': 'Résiliable chaque mois',
  'og.trust.ctaNote': "0 € aujourd'hui · Résiliation = 1 clic",
  'og.trust.proof.head': 'Des équipes commerciales qui ont déjà fait le pas',
  // Nachfolger des geloeschten og.trust.proof.pill (behauptete Google & OMR ohne Beleg; LEA-619). Nur aus
  // lib/verifiedReviews gerendert, {platform} = Plattformen der gezeigten Bewertungen.
  'og.trust.proof.pillVerified': 'Avis sur {platform}',
  'og.trust.bar.card.title': "0 € aujourd'hui",
  'og.trust.bar.card.body': 'Carte, PayPal ou prélèvement SEPA · sécurisé via Stripe',
  'og.trust.bar.cancel.title': 'Résilié en 5 secondes',
  'og.trust.bar.cancel.body': '1 clic dans votre compte, sans contact, effet immédiat',
  'og.trust.bar.gdpr.title': 'Uniquement des données publiques',
  'og.trust.bar.gdpr.body': "RGPD by design · serveurs dans l'UE · sources publiques uniquement",
  'og.trust.founderLine.title': 'Conçu à Hambourg, en Allemagne',
  'og.trust.founderLine.name': ' · Janik Deimann, Fondateur',
  'og.trust.founderLine.sub':
    "Ingénierie allemande, protection des données conforme à l'UE, et quand vous nous écrivez, c'est un humain qui vous répond.",
  'og.trust.founderLine.ask':
    'Encore hésitant ? Écrivez-nous : support@leadscraper.eu. Un humain vous répondra.',

  // --- Paywall révision 19 (validée par Janik le 11/09/2026) ---
  // L'allemand est l'original validé : conservez le « jusqu'à 50 » nuancé et
  // la mention des crédits supplémentaires dans toutes les traductions.
  'og.r19.accountReady': 'Compte créé · Activez votre essai',
  'og.r19.headline.lead': "Trouvez jusqu'à",
  'og.r19.headline.grad': '50 leads gratuits.',
  'og.r19.lead':
    "Commencez dès aujourd'hui avec des entreprises qui correspondent à votre offre. Votre essai comprend {credits} crédits pour jusqu'à {credits} leads d'entreprises.",
  'og.r19.offerNote':
    "Les contacts et la recherche d'entreprise consomment des crédits supplémentaires. Les crédits utilisés pour cela réduisent le nombre d'entreprises.",
  'og.r19.rating.value': '4,8 / 5',
  'og.r19.rating.caption': 'Excellents retours utilisateurs',
  'og.r19.rating.aria': 'Note des clients : 4,8 sur 5 étoiles',
  'og.r19.product.footnote': 'Vous décidez sur quelles entreprises approfondir vos recherches.',
  'og.r19.picker.title': 'Commencez gratuitement.',
  'og.r19.picker.trialCredits': "{credits} crédits d'essai",
  'og.r19.picker.trialPlan': '{plan} · {days} jours à 0 €, puis {renewal}, résiliable chaque mois',
  'og.r19.picker.trialPlanAll': '{plan} · essai à 0 €, puis {renewal}, résiliable chaque mois',
  'og.r19.picker.today': '0 €',
  'og.r19.picker.todayLabel': "aujourd'hui",
  'og.r19.picker.description': "Choisissez votre forfait pour la période après l'essai.",
  'og.r19.credits.title': 'Trouver 1 entreprise',
  'og.r19.credits.equals': '=',
  'og.r19.credits.unit': '1 crédit',
  'og.r19.credits.note':
    "Les contacts et la recherche d'entreprise coûtent des crédits supplémentaires.",
  'og.r19.credits.info': 'Voir un exemple de consommation de crédits',
  'og.r19.credits.example':
    "Exemple : vous trouvez 20 entreprises et ajoutez des contacts et une recherche d'entreprise pour 10 d'entre elles. Cela fait 40 crédits.",
  'og.r19.credits.exampleRest': "Il vous reste {rest} de vos {credits} crédits d'essai.",
  'og.r19.credits.disclaimer':
    '{credits} crédits ne sont pas automatiquement {credits} contacts entièrement recherchés.',
  'og.r19.plans.legend': "Choisissez votre forfait pour après l'essai",
  'og.r19.plans.creditsPerMonth': '{credits} crédits / mois',
  'og.r19.plans.perMonth': '/ mois',
  'og.r19.plans.caption.basic': 'Pour bien démarrer',
  'og.r19.plans.caption.starter': 'Pour une prospection régulière',
  'og.r19.plans.caption.growth': 'Pour une équipe commerciale plus grande',
  'og.r19.cta': 'Commencer gratuitement',
  'og.r19.renewal': 'Ensuite {s} pour {credits} crédits.',
  'og.r19.renewal.strong': '{price} € / mois',
  'og.r19.renewal.cancel': "Résiliez avant la fin de l'essai et vous ne payez rien.",
  'og.r19.security': "Moyen de paiement à l'étape suivante",
  'og.r19.help.faq': 'Essai et résiliation',
  'og.r19.help.features': 'Forfaits en détail',
  // MCP self-service token UI (LEA-269)
  'mcp.live': 'En ligne',
  'mcp.tok.generate': 'Générer un token',
  'mcp.tok.title': 'Connecter un client IA',
  'mcp.tok.intro':
    "Générez un token personnel pour connecter Claude, Cursor ou votre propre agent à votre compte Leadscraper. Le token n'est affiché qu'une seule fois.",
  'mcp.tok.name': 'Nom du token',
  'mcp.tok.generating': 'Génération…',
  'mcp.tok.once':
    'Copiez ce token maintenant : pour des raisons de sécurité, il ne sera plus jamais affiché.',
  'mcp.tok.yourToken': 'Votre token',
  'mcp.tok.copy': 'Copier',
  'mcp.tok.copied': 'Copié',
  'mcp.tok.claudeConfig': 'Configuration Claude Desktop',
  'mcp.tok.copyConfig': 'Copier la configuration',
  'mcp.tok.done': 'Terminé',
  'mcp.tok.limit': "Limite de tokens atteinte : révoquez-en un ancien d'abord.",
  'mcp.tok.mintFailed': 'Impossible de générer le token. Veuillez réessayer.',
  'mcp.tok.revoked': 'Token « {name} » révoqué',
  'mcp.tok.revokeFailed': 'Impossible de révoquer le token.',
  'mcp.tok.expires': 'expire',
  'mcp.tok.lastUsed': 'dernière utilisation',
  'mcp.tok.neverUsed': 'jamais utilisé',
  'mcp.tok.revoke': 'Révoquer',
  // LEA-349 Phase 3: Claude.ai (web) OAuth connect path
  'mcp.claude.connect': 'Connecter à Claude',
  'mcp.claude.cardHint':
    'Claude.ai (web) se connecte en un clic via OAuth, aucun token nécessaire.',
  'mcp.claude.intro':
    "Ajoute Leadscraper à Claude.ai comme connecteur personnalisé. Tu autorises l'accès une seule fois, aucun token à copier-coller.",
  'mcp.claude.cta': 'Ouvrir les connecteurs Claude',
  'mcp.claude.urlLabel': "L'URL de ton serveur MCP",
  'mcp.claude.step1':
    'Clique sur « Ouvrir les connecteurs Claude », puis sur « Add custom connector ».',
  'mcp.claude.step2': "Colle l'URL ci-dessus et continue.",
  'mcp.claude.step3': "Autorise l'accès (« Allow »). Claude peut désormais utiliser tes leads.",
  'mcp.claude.desktopNote': 'Tu utilises Claude Desktop, Cursor ou ton propre agent ?',
  'mcp.claude.desktopCta': 'Générer un token à la place',
  'acct.bill.addMethod': 'Ajouter une méthode de paiement',
  'acct.bill.cardEnds': 'Visa se terminant par •• 4242',
  'acct.bill.cardExpHolder': 'Expiration 08/2028 · Janik Deimann',
  'acct.bill.col.amount': 'Montant',
  'acct.bill.col.credits': 'Credits',
  'acct.bill.col.date': 'Date',
  'acct.bill.col.desc': 'Description',
  'acct.bill.col.invoice': 'Facture',
  'acct.bill.col.status': 'Statut',
  'acct.bill.descSub': 'Abonnement {plan} · {month} {year}',
  'acct.bill.empty': 'Aucune transaction trouvée',
  'acct.bill.emptySub': "Votre historique de paiement s'affichera ici après votre premier achat.",
  'acct.bill.filter.30': '30 derniers jours',
  'acct.bill.filter.90': '90 derniers jours',
  'acct.bill.filter.all': 'Toujours',
  'acct.bill.history': 'Historique des transactions',
  'acct.bill.manageCards': 'Gérer les cartes',
  'acct.bill.manageViaStripe': 'Gestion via le portail client Stripe',
  'acct.bill.methodAutoAdded': "Sera automatiquement ajouté après le début de la phase d'essai.",
  'acct.bill.methodOnFile': 'Moyen de paiement enregistré',
  'acct.bill.methods': 'Méthodes de paiement',
  'acct.bill.noMethods': 'Aucune méthode de paiement trouvée',
  'acct.bill.paid': 'Payé',
  'acct.bill.pdfUnavailable': 'Cette facture ne peut pas être chargée en PDF ici pour le moment. Vous pouvez l’ouvrir et la télécharger sur Stripe.',
  'acct.bill.pdfOpenStripe': 'Ouvrir la facture sur Stripe',
  'acct.bill.primary': 'Primaire',
  'acct.dataAccount': 'Données & Compte',
  'acct.deleteAccount.btn': 'Supprimer le compte',
  'acct.deleteAccount.confirmBtn': 'Supprimer définitivement le compte',
  'acct.deleteAccount.confirmPwLabel': 'Saisissez votre mot de passe pour confirmer',
  'acct.deleteAccount.deleting': 'Suppression en cours …',
  'acct.deleteAccount.errFailed': 'Échec de la suppression.',
  'acct.deleteAccount.errPwRequired': 'Veuillez saisir le mot de passe.',
  'acct.deleteAccount.modalBody':
    'Votre compte sera désactivé et définitivement supprimé après 30 jours. Vous pouvez le réactiver dans ce délai avec email + mot de passe. Tous vos leads, profils et évaluations seront alors supprimés de manière irrévocable.',
  'acct.deleteAccount.modalTitle': 'Supprimer le compte',
  'acct.deleteAccount.title': 'Supprimer le compte',
  'acct.deleteAccount.warn':
    'Votre compte sera définitivement supprimé dans 30 jours. Vous pouvez le réactiver pendant cette période.',
  'acct.seedimport.title': 'Importer la liste de clients existants',
  'acct.seedimport.desc':
    'Téléchargez un fichier CSV ou texte de vos clients existants — un domaine ou une URL par ligne (ou une colonne de domaines). Ces entreprises ne sont jamais livrées comme nouveau lead sur AUCUNE audience.',
  'acct.seedimport.hint': 'CSV ou .txt · max 5 Mo',
  'acct.seedimport.cta': 'Importer un CSV',
  'acct.seedimport.uploading': 'Importation …',
  'acct.seedimport.report':
    '{rows} lignes · {resolved} domaines reconnus · {added} nouveaux · {total} dans votre liste',
  'acct.seedimport.unresolved': '{n} lignes ignorées (aucun domaine reconnaissable)',
  'acct.seedimport.capped': "Limite d'import atteinte — tous les domaines n'ont pas été ajoutés.",
  'acct.seedimport.failed': "Échec de l'import. Vérifiez le fichier et réessayez.",
  'acct.export.btn': 'Exporter',
  'acct.export.failed': "Échec de l'export. Veuillez réessayer.",
  'acct.export.preparing':
    "Préparation de l'export, peut prendre du temps avec beaucoup de données.",
  'acct.export.ready': 'Téléchargement démarré.',
  'acct.export.sub': 'RGPD Art. 20 : toutes vos données en téléchargement JSON.',
  'acct.export.title': 'Exporter les données',
  'acct.int.apiKey': 'Clé API',
  'acct.int.apiKeyP': 'Depuis les paramètres développeur de ton CRM',
  'acct.int.autoPush': 'Auto-Push si « Correspond »',
  'acct.int.autoPushSub':
    'Les Leads sont automatiquement poussés dans le CRM dès que tu les confirmes.',
  'acct.int.bulkPush': 'Envoyer {n} au CRM',
  // LEA-282: HubSpot OAuth strings (Wave 2)
  'acct.int.oauthFail': 'Échec de la connexion OAuth',
  'acct.int.reconnect': 'Reconnecter',
  'acct.int.reconnectRequired': 'Reconnexion requise',
  'acct.int.connectedVia': 'Connecté via OAuth',
  // LEA-268 backfill: CRM-button strings missing from the initial deploy
  // (Om bug-report 2026-05-26 — keys rendered as bracketed [det.crmOpenRecord]).
  'det.crmPushing': 'Envoi en cours…',
  'det.crmPushFail': "Échec de l'envoi au CRM",
  'det.crmSubRequired': "L'envoi au CRM nécessite un plan payant.",
  'det.crmDuplicate': 'Déjà dans le CRM',
  'det.crmNotConnected': 'Aucun CRM connecté : configurez-en un dans Compte → Intégrations',
  'det.crmOpenRecord': "Voir l'enregistrement",
  'acct.int.pushFail': "Échec de l'envoi au CRM",
  'acct.int.pushDuplicate': 'Déjà dans le CRM',
  'acct.int.pushSubRequired': "L'envoi au CRM nécessite un plan payant.",
  'acct.int.bulkSummary': '{pushed} envoyés · {skipped} ignorés · {failed} échecs',
  'leads.bulkPushBtn': 'Envoyer {n} vers {crm}',
  'leads.bulkPushPickBtn': 'Envoyer {n} vers CRM ▾',
  'leads.bulkPushTitle': 'Envoyez les leads actuellement visibles (max 50) vers votre CRM',
  'acct.int.cancel': 'Annuler',
  'acct.int.connect': 'Connecter',
  // LEA-317
  'acct.int.subRequired':
    'Les intégrations CRM sont disponibles uniquement sur les forfaits payants. Passez à un forfait supérieur pour connecter votre CRM.',
  'acct.int.upgradeTitle': 'Passez à un forfait supérieur pour connecter votre CRM',
  'acct.int.upgradeCta': 'Mettre à niveau',
  'acct.int.connectFirst':
    'Connecte ton CRM dans les paramètres du compte pour pousser automatiquement les Leads.',
  'acct.int.connectSuccess': 'Connecté à {name}',
  'acct.int.connected': 'Connecté',
  'acct.int.disconnect': 'Déconnecter',
  'acct.int.disconnectSuccess': 'Connexion à {name} supprimée',
  'acct.int.manage': 'Gérer',
  'acct.int.mapping': 'Mapping des champs',
  'acct.int.mappingSub': 'Champs Leadscraper → Champs CRM',
  'acct.int.none': 'Aucun CRM connecté',
  'acct.int.notConnected': 'Non connecté',
  'acct.int.notPushedYet': 'Pas encore poussé',
  'acct.int.object': "Type d'objet",
  'acct.int.openInCRM': 'Ouvrir dans {name}',
  'acct.int.owner': 'Responsable (Owner)',
  'acct.int.pipeline': 'Pipeline',
  'acct.int.pushSuccess': '{n} Lead(s) envoyé(s) à {name}',
  'acct.int.pushToCRM': 'Envoyer au CRM',
  'acct.int.pushedAt': 'Poussé {when}',
  'acct.int.pushedTo': 'Dans {name}',
  'acct.int.save': 'Enregistrer la connexion',
  'acct.int.sectionLead': 'Statut CRM',
  'acct.int.stage': 'Étape pour les nouveaux Leads',
  'acct.int.sub':
    'Connecte ton CRM et pousse automatiquement les Leads correspondants – ou manuellement par Lead.',
  // LEA-334: webhook signing secret + verification handshake
  'acct.int.whsec.title': 'Secret de signature du webhook',
  'acct.int.whsec.sub':
    "Nous signons chaque envoi de webhook avec HMAC-SHA256 pour que ton endpoint puisse vérifier qu'il provient bien de Leadscraper.",
  'acct.int.whsec.revealed': "Copie-le maintenant : il ne s'affiche qu'une seule fois.",
  'acct.int.whsec.copy': 'Copier',
  'acct.int.whsec.copied': 'Copié',
  'acct.int.whsec.rotate': 'Renouveler et afficher le secret',
  'acct.int.whsec.rotating': 'Renouvellement…',
  'acct.int.whsec.rotateHint':
    "Le renouvellement génère un nouveau secret et l'affiche une seule fois. Pense à mettre à jour ton endpoint ensuite.",
  'acct.int.whsec.fail': 'Impossible de renouveler le secret de signature.',
  'acct.int.whsec.docs':
    'Vérification : en-tête X-Leadscraper-Signature: t=<unix>,v1=<hex>, où hex = HMAC-SHA256(secret, "<t>.<rawBody>"). Rejette la requête si la signature ne correspond pas ou si l\'horodatage est périmé.',
  'acct.int.webhookUrl': 'URL du webhook',
  'acct.int.webhookUrlP': 'https://your-endpoint.example.com/leadscraper',
  'acct.int.autoPushSubWebhook':
    'Les nouveaux leads sont envoyés automatiquement vers ton webhook une fois leurs contacts enrichis.',
  'acct.int.whverify.title': 'Vérifie ton endpoint',
  'acct.int.whverify.sub':
    "Un endpoint joignable (qui renvoie un 2xx) n'est pas pour autant vérifié. Confirme un code à usage unique pour qu'on soit sûrs que les leads arrivent vraiment. Sans ça, aucun n'est livré.",
  'acct.int.whverify.verified': '✓ Vérifié',
  'acct.int.whverify.unverified': 'Non vérifié',
  'acct.int.whverify.send': 'Envoyer un événement test',
  'acct.int.whverify.sending': 'Envoi…',
  'acct.int.whverify.resend': "Renvoyer l'événement test",
  'acct.int.whverify.sent': 'Événement test envoyé : récupère le code sur ton endpoint.',
  'acct.int.whverify.sendFail': "Impossible d'envoyer l'événement test.",
  'acct.int.whverify.enter': 'Saisis le code (LSWH-…) reçu sur ton endpoint :',
  'acct.int.whverify.confirm': 'Confirmer',
  'acct.int.whverify.ok': 'Webhook vérifié : les leads peuvent maintenant être livrés.',
  'acct.int.whverify.mismatch': 'Ce code ne correspond pas. Vérifie ton endpoint et réessaie.',
  'acct.int.whverify.expired': 'Ce code a expiré : envoie un nouvel événement test.',
  'acct.int.testing': 'Test de connexion…',
  'acct.int.title': 'Intégrations CRM',
  'acct.menu.logout': 'Se déconnecter',
  'acct.menu.settings': 'Paramètres du compte',
  'acct.plan.active': 'Actif',
  'acct.plan.canceled': 'Annulé',
  'acct.plan.refundedEnded':
    'Abonnement remboursé, forfait terminé. Choisissez un forfait pour continuer.',
  'acct.plan.addOneOff': 'Ajouter un pack unique',
  'acct.plan.afterTrial': "Après l'essai",
  'acct.plan.bonusCredits': 'Credits du pack',
  'acct.plan.bonusCreditsTip':
    "Credits payés issus de packs uniques, crédités en plus du quota mensuel et n'expirent pas.",
  'acct.plan.dayLeft':
    "Encore 1 jour d'essai gratuit. Votre abonnement continuera automatiquement ensuite.",
  // LEA-561: Abbuchungsdatum + Ein-Klick-Kuendigung im Trial. Bewusst OHNE
  // Erinnerungs-Versprechen — die Reminder-Mail ist gebaut, aber noch von
  // keinem Scheduler aufgerufen; eine Zusage, die das System nicht halten
  // kann, ist genau der Vertrauensbruch, den LEA-553 abstellen soll.
  'acct.plan.trialFirstCharge': 'Premier prélèvement le {date}. Résilie à tout moment en un clic.',
  'acct.plan.daysLeft':
    "Encore {n} jours d'essai gratuit. Votre abonnement continuera automatiquement ensuite.",
  'acct.plan.endsToday':
    "La phase d'essai se termine aujourd'hui. Votre abonnement démarre automatiquement.",
  'acct.plan.leftOf': 'sur {total} restants',
  'acct.plan.monthUsage': 'Leads ce mois',
  'acct.plan.nextBill': 'Prochaine facturation le {date} · {leads} Leads/mois',
  'acct.plan.cancelsOn': 'Se termine le {date}',
  'acct.plan.cancelNote': 'Aucun nouveau prélèvement, actif jusqu’au {date}.',
  'acct.plan.perMonth': '/ mois',
  'acct.plan.secureSub': "Sécuriser l'abonnement",
  'acct.plan.switch': 'Changer de plan',
  'acct.plan.trial': "Phase d'essai",
  'acct.plan.trialCredits': "Credits d'essai",
  'acct.plan.trialCreditsTip':
    "Credits d'essai offerts lors de votre inscription, crédités en plus du quota mensuel et n'expirent pas.",
  // LEA-704: surplus of a migrated account = the balance carried over, not trial credits.
  'acct.plan.carriedOverCredits': 'Credits reportés',
  'acct.plan.carriedOverCreditsTip':
    "Votre solde d'avant le passage à la facturation par contact, crédité en plus du quota mensuel et sans expiration.",
  'acct.plan.trialUsage': "Leads d'essai cette phase",
  'acct.plan.usedThisMonth': '{used} / {total} utilisés ce mois · Remise à zéro le {date}',
  'acct.plan.your': 'Votre plan',
  'acct.prof.avatarErr': "L'image n'a pas pu être téléchargée. Veuillez réessayer.",
  'acct.prof.avatarMime': 'Veuillez choisir un fichier JPG, PNG ou WebP.',
  'acct.prof.avatarSize': 'Fichier trop volumineux (max. 2 MB).',
  'acct.prof.avatarUpdated': 'Photo de profil mise à jour.',
  'acct.prof.email': 'Adresse e-mail',
  'acct.prof.first': 'Prénom',
  'acct.prof.lang': 'Langue',
  'acct.prof.last': 'Nom',
  'acct.prof.save': 'Enregistrer',
  'acct.prof.title': 'Informations du profil',
  'acct.prof.upload': 'Télécharger une image',
  'acct.prof.uploadHint': 'JPG, PNG ou WebP. Max. 2 MB.',
  'acct.pw.changing': 'Modification en cours…',
  'acct.pw.complexity':
    'Le nouveau mot de passe doit contenir au moins 8 caractères, des majuscules et minuscules, un chiffre et un caractère spécial (@$!%*?&).',
  'acct.pw.confirm': 'Confirmer le nouveau mot de passe',
  'acct.pw.cta': 'Modifier le mot de passe',
  'acct.pw.current': 'Mot de passe actuel',
  'acct.pw.failed': "Le mot de passe n'a pas pu être modifié.",
  'acct.pw.minErr': 'Au moins 8 caractères.',
  'acct.pw.minHint': 'Au moins 8 caractères',
  'acct.pw.mismatch': 'Les mots de passe ne correspondent pas.',
  'acct.pw.new': 'Nouveau mot de passe',
  'acct.pw.sameAsCurrent': "Le nouveau mot de passe doit être différent de l'actuel.",
  'acct.pw.success': 'Mot de passe modifié ✓',
  'acct.pw.title': 'Changer le mot de passe',
  'acct.pw.wrongCurrent': 'Le mot de passe actuel est incorrect.',
  'acct.sec.active': 'Actif',
  'acct.sec.change': 'Modifier',
  'acct.sec.inactive': 'Inactif',
  'acct.sec.pw': 'Changer le mot de passe',
  'acct.sec.pwSub': 'Modifiez ici le mot de passe de votre compte',
  'acct.sec.title': 'Paramètres de sécurité',
  'acct.sec.twofa': 'Authentification à deux facteurs',
  'acct.sec.twofaActivate': 'Activer 2FA',
  'acct.sec.twofaDeactivate': 'Désactiver 2FA',
  'acct.sec.twofaSoon':
    "L'authentification à deux facteurs (app d'authentification) n'est pas encore connectée ici. Le bouton n'était jusqu'à présent que local. La vraie 2FA arrive prochainement.",
  'acct.sec.twofaSub':
    "L'authentification est désactivée. Activez-la pour ajouter une couche de sécurité supplémentaire à votre compte.",
  'acct.sub':
    'Gérez les paramètres du profil, modifiez les méthodes de paiement et téléchargez les factures des transactions passées.',
  'acct.tab.billing': 'Facturation',
  'acct.tab.integrations': 'Intégrations',
  'acct.tab.profile': 'Profil',
  'acct.founder.title': 'Une ligne directe avec le fondateur',
  'acct.founder.body':
    'Un retour, une question, un problème ? Ton message arrive directement chez Janik, pas dans un système de tickets.',
  'acct.founder.cta': 'Écrire à Janik',
  'acct.title': 'Profil',
  'acct.toast.failed': "Échec de l'enregistrement. Veuillez réessayer.",
  'acct.toast.saved': 'Profil enregistré.',

  'ai.collapse': 'Réduire',
  'ai.cortex': 'Leadscraper',
  'ai.dismiss': 'Masquer',
  'ai.errorReply':
    "Je n'arrive pas à accéder à mes données pour le moment. Réessayez dans un instant, ou formulez la question plus brièvement.",
  'ai.footer': 'Leadscraper ne connaît que vos audiences et vos retours, aucune donnée externe.',
  'ai.greeting':
    'Salut 👋 Je suis votre assistant Leadscraper. Je vois votre profil actif "{profile}" et tous les modèles que le système a appris. De quoi s\'agit-il ?',
  'ai.inputP': "Demandez quelque chose à l'assistant …",
  'ai.ins.edge.cta': 'Examiner le lead',
  'ai.ins.edge.fallback':
    'Leadscraper est incertain ici : votre jugement aide à affiner le modèle.',
  'ai.ins.edge.title': 'Cas limite : {company}',
  'ai.ins.pattern.cta': 'Vérifier le modèle',
  'ai.ins.pattern.title': 'Nouveau modèle dans "{profile}"',
  'ai.ins.tune.body':
    'Taux de correspondance à {rate} %. Je peux vous aider à formuler la prochaine recherche de manière plus ciblée.',
  'ai.ins.tune.cta': 'Affiner la recherche',
  'ai.ins.tune.title': '"{profile}" est encore en apprentissage',
  'ai.intro':
    "Je surveille vos profils en permanence et vous aide à formuler des recherches plus précises et des signaux d'apprentissage fiables.",
  'ai.langHint':
    'Répondez en français. Maximum 3-4 phrases courtes par réponse, sauf pour des instructions concrètes.',
  'ai.moreN': '+{n} autres',
  'ai.now': 'maintenant',
  'ai.onlinePrefix': 'En ligne · connaît vos {n} audiences',
  'ai.openChat': 'Ouvrir le chat',
  'ai.quickStart': 'Démarrage rapide',
  'ai.seedRefine': 'Proposez-moi une recherche affinée pour mon audience « {profile} ».',
  'ai.send': 'Envoyer',
  'ai.sp1.label': 'Où en est mon audience active ?',
  'ai.sp1.prompt':
    "Résumez-moi en 3 phrases à quel point Leadscraper a déjà compris mon profil actif : qu'est-ce qui est appris, qu'est-ce qui ne l'est pas ?",
  'ai.sp2.label': 'Quels modèles devrais-je confirmer ?',
  'ai.sp2.prompt':
    'Quels modèles appris devrais-je confirmer ou rejeter ensuite pour que le système apprenne plus rapidement ?',
  'ai.sp3.label': 'Suggérer une recherche',
  'ai.sp3.prompt':
    'Proposez-moi une prochaine recherche précise basée sur mon profil actif, avec secteur, localisation, taille et extras.',
  'ai.sp4.label': 'Où est-ce que je perds en qualité ?',
  'ai.sp4.prompt':
    'Où dans mes profils voyez-vous un potentiel pour de meilleurs taux de correspondance ? Que devrais-je ajuster ?',
  'ai.tag.confirmed': 'confirmé',
  'ai.tag.uncertain': 'incertain',
  'ai.tag.unconfirmed': 'non confirmé',
  'ai.thinkingAbout': 'Ce à quoi je pense en ce moment',

  'api.confidence.cautiously_optimistic': 'prudemment optimiste',
  'api.confidence.fairly_sure': 'moyennement sûr',
  'api.confidence.uncertain': 'incertain',
  'api.confidence.very_sure': 'très sûr',

  'apierr.intentParseTimeout': "Notre IA a mis trop de temps à lire votre description — réessayez dans un instant.",

  'auth.login.docTitle': 'Se connecter · Leadscraper',
  'auth.login.email': 'E-mail',
  'auth.login.errCredentials': 'E-mail ou mot de passe incorrect.',
  'auth.login.errEmail': 'Adresse e-mail invalide.',
  'auth.login.errEmpty': 'Veuillez remplir tous les champs.',
  'auth.login.errGeneric': 'Connexion échouée. Veuillez réessayer.',
  'auth.login.errUnverified': "Veuillez d'abord confirmer votre adresse e-mail.",
  'auth.login.forgot': 'Mot de passe oublié ?',
  'auth.login.google': 'Se connecter avec Google',
  'auth.login.googleBusy': 'Connexion avec Google …',
  'auth.login.hidePassword': 'Masquer le mot de passe',
  'auth.login.microsoft': 'Se connecter avec Microsoft',
  'auth.login.microsoftBusy': 'Connexion avec Microsoft …',
  'auth.login.noAccount': 'Pas encore de compte ?',
  'auth.login.or': 'Ou',
  'auth.login.password': 'Mot de passe',
  'auth.login.remember': 'Rester connecté',
  'auth.login.showPassword': 'Afficher le mot de passe',
  'auth.login.signUp': "S'inscrire",
  'auth.login.sub': 'Connectez-vous à votre compte pour accéder à votre espace.',
  'auth.login.submit': 'Se connecter',
  'auth.login.submitting': 'Connexion …',
  'auth.login.title': 'Bon retour',
  'auth.register.docTitle': "S'inscrire · Leadscraper",
  'auth.register.email': 'E-mail',
  'auth.register.errEmail': 'Adresse e-mail invalide.',
  'auth.register.errEmpty': 'Veuillez remplir tous les champs.',
  'auth.register.errBotCheck': 'Veuillez terminer la vérification anti-robot.',
  'auth.register.errPwMismatch': 'Les mots de passe ne correspondent pas.',
  'auth.register.errPwShort': 'Le mot de passe doit contenir au moins 8 caractères.',
  'auth.register.firstName': 'Prénom',
  'auth.register.google': "S'inscrire avec Google",
  'auth.register.googleBusy': 'Inscription avec Google …',
  'auth.register.haveAccount': 'Vous avez déjà un compte ?',
  'auth.register.hidePassword': 'Masquer le mot de passe',
  'auth.register.lastName': 'Nom',
  'auth.register.microsoft': "S'inscrire avec Microsoft",
  'auth.register.microsoftBusy': 'Inscription avec Microsoft …',
  'auth.register.or': 'Ou',
  'auth.register.password': 'Mot de passe',
  'auth.register.passwordConfirm': 'Confirmer le mot de passe',
  'auth.register.showPassword': 'Afficher le mot de passe',
  'auth.register.signIn': 'Se connecter',
  'auth.register.sub':
    "Testez à quel point il est simple de générer des listes de Leads précises aujourd'hui grâce aux agents IA.",
  'auth.register.submit': 'Créer un compte',
  'auth.register.submitting': 'Création en cours …',
  'auth.register.title': 'Créer un compte gratuit',
  'auth.reset.backToLogin': 'Retour à la connexion',
  'auth.reset.confirmLabel': 'Confirmer le mot de passe*',
  'auth.reset.confirmPlaceholder': 'Saisissez à nouveau le mot de passe',
  'auth.reset.docTitle': 'Réinitialiser le mot de passe · Leadscraper',
  'auth.reset.doneSub': 'Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.',
  'auth.reset.doneTitle': 'Mot de passe modifié avec succès',
  'auth.reset.emailLabel': 'E-mail*',
  'auth.reset.emailPlaceholder': 'Entrez votre adresse e-mail',
  'auth.reset.errInvalidEmail': 'Veuillez entrer une adresse e-mail valide.',
  'auth.reset.errPwMismatch': 'Les mots de passe ne correspondent pas.',
  'auth.reset.errPwShort': 'Le mot de passe doit contenir au moins 8 caractères.',
  'auth.reset.errPwWeak':
    'Le mot de passe doit contenir des majuscules et des minuscules, un chiffre et un caractère spécial.',
  'auth.reset.pwRules':
    'Au moins 8 caractères, avec des majuscules et des minuscules, un chiffre et un caractère spécial.',
  'auth.reset.errRequest': 'Demande échouée. Veuillez réessayer.',
  'auth.reset.goToLogin': 'Aller à la connexion',
  'auth.reset.haveAccount': 'Vous avez déjà un compte ?',
  'auth.reset.hidePassword': 'Masquer le mot de passe',
  'auth.reset.invalidSub':
    "Ce lien de réinitialisation n'est plus valide. Veuillez en demander un nouveau.",
  'auth.reset.invalidTitle': 'Lien invalide ou expiré',
  'auth.reset.newPwLabel': 'Nouveau mot de passe*',
  'auth.reset.newPwPlaceholder': 'Au moins 8 caractères',
  'auth.reset.newPwSub': 'Choisissez un nouveau mot de passe pour votre compte.',
  'auth.reset.newPwTitle': 'Définir un nouveau mot de passe',
  'auth.reset.requestNew': 'Demander un nouveau lien',
  'auth.reset.oauthTitle': 'Ce compte utilise la connexion {provider}',
  'auth.reset.oauthSub':
    "Aucun mot de passe n'est associé à ce compte. Connectez-vous plutôt avec {provider}.",
  'auth.reset.resetBtn': 'Réinitialiser le mot de passe',
  'auth.reset.saving': 'Enregistrement …',
  'auth.reset.send': 'Envoyer le lien',
  'auth.reset.sending': 'Envoi en cours …',
  'auth.reset.sentSub':
    'Si un compte existe avec cette adresse e-mail, nous vous avons envoyé un lien de réinitialisation. Vérifiez votre boîte de réception (et vos spams).',
  'auth.reset.sentTitle': 'E-mail envoyé',
  'auth.reset.showPassword': 'Afficher le mot de passe',
  'auth.reset.signIn': 'Se connecter',
  'auth.reset.sub':
    'Entrez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
  'auth.reset.title': 'Réinitialiser le mot de passe',
  'auth.shell.nextSlide': 'Diapositive suivante',
  // LEA-285: auth slide carousel — mirrors apps/auth/src/lib/i18n.ts.
  'auth.slides.1.headline':
    'Des agents IA identifient les entreprises B2B correspondant exactement à votre profil client cible.',
  'auth.slides.2.headline':
    'Chaque liste de leads est générée à partir de sources publiques, aucune donnée obsolète ou revendue.',
  'auth.slides.3.headline':
    'Chaque lead inclut les décideurs pertinents, des liens sources et une justification claire de sa pertinence.',
  'auth.slides.aria.region': 'Points forts du produit',
  'auth.slides.aria.slide': 'Diapositive {n} sur {total}',
  'auth.slides.aria.goTo': 'Aller à la diapositive {n}',

  // --- Login + Registrierung, Revision 19 (Janik 17.09.2026) ---
  // Uebersetzung; das deutsche Original ist die Referenz.
  'auth.r19.skip': 'Aller au contenu',
  'auth.r19.header.haveAccount': 'Déjà inscrit ?',
  'auth.r19.hero.titleLead': 'Trouvez les',
  'auth.r19.hero.titleGrad': 'clients',
  'auth.r19.hero.titleTail': 'pour qui votre offre est faite.',
  'auth.r19.hero.lead':
    'Décrivez qui vous voulez atteindre. Leadscraper trouve les entreprises adaptées, recherche les interlocuteurs et vous montre par où commencer la conversation.',
  'auth.r19.demo.caption': 'Votre recherche. Étape par étape.',
  'auth.r19.demo.play': 'Voir le déroulé',
  'auth.r19.form.title': 'Commencez avec Leadscraper.',
  'auth.r19.form.google': 'Avec Google',
  'auth.r19.form.microsoft': 'Avec Microsoft',
  'auth.r19.form.separator': 'ou avec votre e-mail',
  'auth.r19.form.businessEmail': 'E-mail professionnel',
  'auth.r19.form.emailPlaceholder': 'vous@entreprise.fr',
  'auth.r19.form.show': 'Afficher',
  'auth.r19.form.hide': 'Masquer',
  'auth.r19.legal.accept':
    'En vous inscrivant, vous acceptez nos {terms}. Vous trouverez des informations sur vos données dans notre {privacy}.',
  'auth.r19.legal.privacyLink': 'politique de confidentialité',
  'auth.r19.proof.founderTitle': 'Accompagnement personnel par le fondateur.',
  'auth.r19.proof.founderBody': 'Janik est votre interlocuteur direct.',
  'auth.r19.confidence.eyebrow': 'Avant votre premier échange',
  'auth.r19.confidence.title1': 'Vous savez à qui vous vous adressez.',
  'auth.r19.confidence.title2': 'Et pourquoi.',
  'auth.r19.confidence.p1.title': 'Les sources sont incluses.',
  'auth.r19.confidence.p1.body':
    'Vous voyez sur quoi repose la recherche et pouvez vérifier les informations vous-même.',
  'auth.r19.confidence.p2.title': 'Les zones d’ombre restent visibles.',
  'auth.r19.confidence.p2.body':
    "S'il manque une information, cela se voit. Vous décidez ainsi comment poursuivre la recherche.",
  'auth.r19.confidence.p3.title': "Vous obtenez un angle d'approche.",
  'auth.r19.confidence.p3.body':
    "La connaissance de l'entreprise vous aide à préparer le premier contact autour d'un motif concret.",
  'auth.r19.founder.eyebrow': 'Personnellement à vos côtés',
  'auth.r19.founder.role': 'Fondateur de Leadscraper',
  'auth.r19.founder.photoAlt': 'Janik Deimann, fondateur de Leadscraper',
  'auth.r19.founder.body':
    'Je vous aide personnellement dans votre recherche et pour vos questions sur Leadscraper.',
  'auth.r19.founder.contact': 'Poser une question dans le chat',
  'auth.r19.footer.copyright': '© Leadscraper · Deimann Com GmbH',
  'auth.r19.footer.privacy': 'Confidentialité',
  'auth.r19.footer.imprint': 'Mentions légales',
  // Geprueft 17.09.2026: HTTP 200.
  'auth.r19.footer.imprintUrl': 'https://www.leadscraper.de/fr/mentions-legales',
  'auth.r19.footer.navLabel': 'Informations légales',
  'auth.verify.defaultError': "Une erreur s'est produite.",
  'auth.verify.docTitle': "Confirmer l'e-mail · Leadscraper",
  'auth.verify.error': 'Échec de la confirmation',
  'auth.verify.goToDashboard': 'Aller directement au tableau de bord',
  'auth.verify.noToken': 'Lien de confirmation manquant',
  'auth.verify.noTokenSub':
    "Cliquez sur le lien dans l'e-mail que nous vous avons envoyé. Si vous n'avez pas reçu d'e-mail, vous pouvez en demander un nouveau.",
  'auth.verify.resendError': 'Demander un nouvel e-mail de confirmation',
  'auth.verify.resendFailed': "L'e-mail n'a pas pu être renvoyé.",
  'auth.verify.resendNoToken': "Renvoyer l'e-mail de confirmation",
  'auth.verify.resending': 'Envoi en cours …',
  'auth.verify.resent': 'E-mail renvoyé ✓',
  'auth.verify.success': 'Réussi !',
  'auth.verify.successSub':
    'Votre adresse e-mail a été confirmée. Redirection vers le tableau de bord …',
  'auth.verify.title': "Confirmer l'e-mail",
  'auth.verify.toLogin': 'Aller à la connexion',
  'auth.verify.verifying': "Confirmation de l'e-mail en cours …",
  'auth.verify.verifyingSub': "Un instant s'il vous plaît.",

  'bill.ret.cancelBody':
    "Rien n'a été débité. Vous pouvez relancer le processus de paiement à tout moment.",
  'bill.ret.cancelCta': 'Retour au tableau de bord',
  'bill.ret.cancelTitle': 'Opération annulée',
  'bill.ret.cta': 'Vers le tableau de bord',
  'bill.ret.docTitleCancel': 'Opération annulée · Leadscraper',
  'bill.ret.docTitleSuccess': 'Paiement réussi · Leadscraper',
  'bill.ret.errorBody':
    'Votre paiement a peut-être réussi. Nous n\'avons pas pu charger le statut actuellement. Veuillez vérifier dans votre compte sous "Facturation".',
  'bill.ret.errorTitle': 'Statut non disponible',
  'bill.ret.rowCredits': 'Credits',
  'bill.ret.rowCreditsAvail': '{n} disponibles',
  'bill.ret.rowNextRenewal': 'Prochaine facturation',
  'bill.ret.rowPlan': 'Forfait',
  'bill.ret.seedCta': 'Vers mes leads',
  'bill.ret.seedDone': 'Les {delivered} leads sont là. C’est parti.',
  'bill.ret.seedPartial':
    '{delivered} leads sont là. Le reste de ton solde reste disponible pour tes propres recherches.',
  'bill.ret.seedWorking':
    '{delivered} sur {total} leads sont terminés, le reste est en cours d’enrichissement. Au total, cela prend 10 à 30 minutes.',
  'bill.ret.seedWorkingCreated':
    'Tes {created} leads sont créés. La recherche des contacts prend 10 à 30 minutes. Exporte de préférence quand ils sont tous là.',
  'bill.ret.seedWorkingZero':
    'Tes leads sont en train d’être créés. La recherche des contacts prend 10 à 30 minutes. Exporte de préférence quand ils sont tous là.',
  'bill.ret.successBodyCredits': 'Vos Credits ont été crédités.',
  'bill.ret.successBodySub': 'Votre abonnement est actif. Vous avez maintenant accès à vos Leads.',
  'bill.ret.successTitle': 'Paiement réussi',
  'bill.ret.verifying': 'Paiement en cours de traitement …',
  'bill.ret.verifyingSub': "Nous mettons à jour votre compte. Cela ne prendra qu'un instant.",

  'billing.disabled':
    'Les paiements ne sont actuellement pas disponibles. Veuillez réessayer plus tard.',
  'billing.errorClose': 'Fermer',
  'billing.errorTitle': "Quelque chose s'est mal passé",
  'billing.portalNoCustomer':
    "La gestion des abonnements n'est disponible qu'après le premier achat.",
  'billing.trialStarted': "Bienvenue dans l'abonnement {plan}, période d'essai en cours.",
  // LEA-546: der Tarifwechsel wurde serverseitig abgelehnt, weil das Abo
  // gerade nicht änderbar ist (Kündigung vorgemerkt bzw. Zahlung offen).
  'billing.reactivateFirst':
    "Votre abonnement est programmé pour se terminer. Réactivez-le d'abord, puis vous pourrez changer de forfait.",
  'billing.manageInPortal':
    'Cet abonnement ne peut pas être modifié pour le moment. Ouvrez le portail de facturation pour régler le paiement.',
  'billing.unknownError': 'Erreur inconnue lors du processus de paiement.',
  'billing.alreadySubscribed': 'Vous avez déjà cet abonnement. Votre forfait actuel se trouve sous Facturation.',

  'boot.connectionError': 'Erreur de connexion',
  'boot.connectionErrorDesc': "Impossible d'établir une connexion au serveur : {msg}",
  'boot.retry': 'Réessayer',
  'boot.reconnecting': 'Reconnexion… (tentative {n})',

  'common.cancel': 'Annuler',
  'common.collapse': 'Réduire',
  'common.edit': 'Modifier',
  'common.hide': 'Masquer',
  'common.loading': 'Chargement …',
  'common.month.apr': 'Avril',
  'common.month.aug': 'Août',
  'common.month.dec': 'Décembre',
  'common.month.feb': 'Février',
  'common.month.jan': 'Janvier',
  'common.month.jul': 'Juillet',
  'common.month.jun': 'Juin',
  'common.month.mar': 'Mars',
  'common.month.may': 'Mai',
  'common.month.nov': 'Novembre',
  'common.month.oct': 'Octobre',
  'common.month.sep': 'Septembre',
  'common.refresh': 'Actualiser',
  'common.save': 'Enregistrer',
  'common.saving': 'Enregistrement en cours …',

  'cortex.activeSince': 'Audience active depuis',
  'cortex.confirm': 'Confirmer',
  'cortex.confirmed': 'confirmé par vous',
  'cortex.correct': 'Corriger',
  'cortex.ctaRate': 'Évaluer les premiers Leads maintenant',
  'cortex.feedbacks': 'Feedbacks',
  'cortex.fits': 'Convient',
  'cortex.fitsNot': 'Ne convient pas',
  'cortex.footer':
    'Si vous corrigez ou oubliez une déclaration, elle ne sera plus utilisée pour trier vos Leads.',
  'cortex.forget': 'Oublier',
  'cortex.hero': 'Voici ce que Leadscraper a appris de vos {n} évaluations.',
  'cortex.heroEmpty':
    'Encore vide. Leadscraper commence à apprendre dès que vous évaluez vos premiers Leads.',
  'cortex.heroEmptySub':
    'Leadscraper est la mémoire de votre profil : ce que vous préférez, ce que vous rejetez et où le système est encore incertain.',
  'cortex.heroSub':
    "Vous pouvez confirmer, corriger ou faire oublier chaque déclaration. Les modifications s'appliquent dès le prochain tri.",
  'cortex.learned': 'Ce que Leadscraper a appris',
  'cortex.matchRate': 'Taux de correspondance',
  'cortex.medium': 'moyen',
  'cortex.mediumNote': 'observation continue',
  'cortex.patterns': 'Schémas appris',
  'cortex.patternsPending': 'Encore à confirmer',
  'cortex.perWeek': 'par semaine',
  'cortex.plain': 'En clair, comme vous le liriez.',
  'cortex.roi.avgOrder': 'Ø Volume de commande',
  'cortex.roi.disclaimer':
    'Valeur calculée, basée sur votre taux de correspondance actuel. Plus Leadscraper mûrit, plus les chiffres deviennent réalistes.',
  'cortex.roi.expectedFits': 'Leads compatibles attendus',
  'cortex.roi.leads': 'Leads',
  'cortex.roi.newCustomers': 'Nouveaux clients',
  'cortex.roi.revenue': 'CA prévisionnel',
  'cortex.roi.revenueSub': 'avec la situation actuelle',
  'cortex.roi.sub': 'Ce que pourrait valoir votre situation actuelle.',
  'cortex.roi.title': 'Estimation ROI',
  'cortex.roi.viaRate': 'Ø Taux de correspondance',
  'cortex.roi.winLabel': 'Taux de conversion',
  'cortex.roi.winRate': 'Taux de conversion',
  'cortex.runs.col.action': 'Action',
  'cortex.runs.col.date': 'Date',
  'cortex.runs.col.leads': 'Leads',
  'cortex.runs.col.matchrate': 'Taux de correspondance',
  'cortex.runs.col.params': 'Paramètres de recherche',
  'cortex.runs.count': 'Exécutions',
  'cortex.runs.repeat': 'Répéter',
  'cortex.runs.sub': 'Toutes les requêtes que vous avez lancées pour cette audience.',
  'cortex.runs.title': 'Recherches',
  'cortex.sinceStart': 'depuis le début',
  'cortex.step': 'Étape',
  'cortex.step1': 'Ouvrir Leads',
  'cortex.step1d': 'Regardez les premières cartes de votre liste.',
  'cortex.step2': 'Convient / Ne convient pas',
  'cortex.step2d': 'Évaluez chaque Lead. Donnez brièvement une raison lors du rejet.',
  'cortex.step3': 'Lire ici',
  'cortex.step3d': 'Après ~20 feedbacks, les premières déclarations claires apparaissent ici.',
  'cortex.strong': 'fort',
  'cortex.strongNote': 'schémas fiables',
  'cortex.tierMedium': 'Moyen',
  'cortex.tierStrong': 'Fort',
  'cortex.tierWeak': 'Faible',
  'cortex.title': 'Memory',
  'cortex.uncertain': "Leadscraper n'est pas sûr ici",
  'cortex.weak': 'faible',
  'cortex.weakNote': "Leadscraper n'est pas sûr ici",

  'crm.bald': 'BIENTÔT',
  'crm.comingSoon': 'Bientôt disponible',
  'crm.customAgent': 'Agent personnalisé',
  'crm.history.duplicate': 'Déjà dans le CRM',
  'crm.history.empty':
    "Aucun envoi pour l'instant. Utilisez « Envoyer vers CRM » sur un Lead pour commencer.",
  'crm.history.failed': 'Échec',
  'crm.history.loading': 'Chargement…',
  'crm.picker.title': 'Vers quel CRM ?',
  'crm.picker.subtitle': 'Choisissez où ce lead doit atterrir. Vous pouvez changer à tout moment.',
  'crm.history.sent': 'Envoyé',
  'crm.history.sub': 'Les 50 derniers Leads envoyés vers votre CRM, les plus récents en premier.',
  'crm.history.title': 'Historique des envois',
  'crm.mcpComingSoon': 'Disponible dès que le serveur MCP sera lancé.',
  'crm.mcpSub':
    'Connectez Leadscraper directement avec Claude, ChatGPT, Cursor ou votre propre agent via le Model Context Protocol. Vos Leads, profils et Memory sont disponibles nativement comme outils.',
  'crm.mcpTitle': 'Leadscraper comme serveur MCP',
  'crm.preview.bulkBody':
    "Crée {n} entrées d'organisation (et des personnes pour les Leads avec coordonnées). Les doublons déjà présents dans votre CRM seront ignorés. Vos entrées existantes restent intactes.",
  'crm.preview.bulkSub': '{n} Leads seront envoyés vers votre CRM',
  'crm.preview.dedupNote':
    "Si ce Lead existe déjà dans votre CRM (correspondance par domaine), l'envoi sera enregistré, mais aucune nouvelle entrée ne sera créée. Vous conservez ce que vous avez.",
  'crm.preview.noContact': 'Org seulement',
  'crm.preview.plusMore': '+ {n} autres…',
  'crm.preview.pushBtn': 'Envoyer maintenant',
  'crm.preview.pushNBtn': 'Envoyer {n} maintenant',
  'crm.preview.pushing': 'Envoi en cours…',
  'crm.preview.singleSub': 'Ceci sera créé dans votre CRM',
  'crm.preview.skipPerson': "· ignoré (pas d'e-mail ou téléphone pour ce Lead)",
  'crm.preview.title': 'Aperçu : Envoi vers {crm}',
  'crm.preview.willCreate': 'Sera créé',
  'crm.preview.willCreatePerson': '· contact principal avec e-mail/téléphone',
  'crm.preview.withContact': 'Org + Personne',
  'crm.section.available': 'Disponible',
  'crm.section.comingNext': 'Bientôt',
  'crm.section.comingNextLabel': 'Bientôt',
  'crm.section.connected': 'Connecté',
  'crm.section.morePlanned': 'Autres intégrations prévues',
  'crm.tooltipComingSoon':
    "L'intégration {name} arrive bientôt. Vous serez notifié dès qu'elle sera disponible.",

  'dash.actNow': 'Ouvrir',
  'dash.action': 'Action',
  'dash.activeRuns.run': 'recherche',
  'dash.activeRuns.runs': 'recherches',
  'dash.activeRuns.title': 'Leadscraper travaille actuellement pour vous',
  'dash.avgOrder': '⌀ Volume de commande',
  'dash.cadence.daily': 'quotidien',
  'dash.cadence.hourly': 'horaire',
  'dash.cadence.manual': 'manuel',
  'dash.cadence.monthly': 'mensuel',
  'dash.cadence.weekly': 'hebdomadaire',
  'dash.close': 'Fermer',
  'dash.col.lastRun': 'Dernière exécution',
  'dash.col.leads': 'Leads',
  'dash.col.matchrate': 'Taux de correspondance',
  'dash.col.profile': 'Audience',
  'dash.col.profileH': 'Audience',
  'dash.col.query': 'Groupe cible',
  'dash.col.queryName': 'Requête',
  'dash.col.statusH': 'Statut',
  'dash.col.trained': 'Entraîné',
  'dash.col.whenH': 'Quand',
  'dash.company.analyzeBtn': 'Analyser',
  'dash.company.analyzeFresh': '✨ Former Leadscraper',
  'dash.company.analyzing': 'Leadscraper lit…',
  'dash.company.cachedToast': 'Profil chargé depuis la mémoire.',
  'dash.company.collapsed':
    'Leadscraper connaît votre entreprise : toutes les justifications sont personnalisées pour vous.',
  'dash.company.doneToast': '✓ Leadscraper vous connaît maintenant.',
  'dash.company.editBody':
    'Saisissez votre site web d\'entreprise. Leadscraper le lit et retient définitivement ce que vous proposez, à qui vous vendez, et quels arguments vous utilisez, pour que chaque justification de vos Leads devienne une stratégie d\'approche sur mesure au lieu de juste "correspond au secteur".',
  'dash.company.editTitle':
    'Pour que Leadscraper affine vos arguments : dites-nous ce que vous vendez',
  'dash.company.emptyBody':
    'Saisissez votre site web d\'entreprise et Leadscraper comprend en 10 secondes ce que vous vendez. Dès lors, chaque justification de Lead explique concrètement pourquoi VOTRE offre correspond à CE Lead, au lieu de juste "correspond au secteur". C\'est le déclic.',
  'dash.company.emptyTitle': 'Leadscraper ne vous connaît pas encore',
  'dash.company.errorFallback': "Échec de l'analyse : veuillez réessayer.",
  'dash.company.setupBadge': 'Configuration nécessaire',
  'dash.company.stage1': 'Chargement de votre site web…',
  'dash.company.stage2': 'Comprendre ce que vous proposez…',
  'dash.company.stage3': 'Identifier votre public cible…',
  'dash.company.stage4': 'Connecter tout avec votre valeur…',
  'dash.company.stage5': 'Presque terminé…',
  'dash.company.urlHint':
    "Saisissez votre site web. Dès que l'URL est renseignée, vous pourrez former Leadscraper.",
  'dash.company.urlPlaceholder': 'https://mon-entreprise.fr',
  'dash.cortex.reanalyze': 'Analyser à nouveau : Leadscraper examine la page avec un œil neuf',
  'dash.cortex.reanalyzeKeepTitle': 'Conserver vos modifications manuelles ?',
  'dash.cortex.reanalyzeKeepBody':
    "Vous avez modifié ce profil d'entreprise manuellement. La nouvelle analyse peut conserver vos modifications et n'actualiser que le reste, ou tout réinitialiser avec de nouvelles suggestions de l'IA.",
  'dash.cortex.reanalyzeKeepCta': 'Conserver mes modifications',
  'dash.cortex.reanalyzeResetCta': "Réinitialiser aux suggestions de l'IA",
  'dash.cortex.sells': 'Ce que vous vendez',
  'dash.cortex.title': 'Ce que Leadscraper sait de votre entreprise',
  'dash.cortex.toWhom': 'À qui',
  'dash.cortex.valueProps': 'Propositions de valeur',
  'dash.date': 'Date',
  'dash.done': 'Terminé',
  'dash.empty.defineAudience': "+ Définir l'audience maintenant",
  'dash.empty.noFiltered': 'Aucune requête dans ce filtre.',
  'dash.empty.noProfile': 'Aucune audience créée pour le moment.',
  'dash.empty.noQueryStartedAll':
    'Aucune requête de leads lancée sur toutes les audiences pour le moment.',
  'dash.empty.noQueryStartedForProfile': 'Aucune requête de Leads lancée pour "{profile}".',
  'dash.empty.showAll': 'Tout afficher ({n})',
  'dash.empty.startHint':
    'Cliquez sur "Lancer une recherche" pour définir une requête (type d\'entreprise, région, rôle, …).',
  'dash.filter.all': 'Tous',
  'dash.filter.oneshot': 'Ponctuelles',
  'dash.filter.running': 'En cours',
  'dash.filter.scheduled': 'Programmées',
  'dash.fmtNext.inDays': 'dans {n}j',
  'dash.fmtNext.inH': 'dans {n}h',
  'dash.fmtNext.inMin': 'dans {n}m',
  'dash.fmtNext.soon': 'démarre bientôt',
  'dash.fmtNext.tomorrow': 'demain',
  'dash.funnel.deepened': 'Approfondis',
  'dash.funnel.evaluated': 'Évalués',
  'dash.funnel.identified': 'Identifiés',
  'dash.funnel.ready': 'Prêts',
  'dash.inProgress': 'En cours',
  'dash.inbox.edge': 'Cas limite',
  'dash.inbox.edges': 'Cas limites',
  'dash.inbox.hint': 'Conseil',
  'dash.inbox.leadsFrom': '{leads} Leads de {profiles} {profileWord}',
  'dash.inbox.less': 'Afficher moins',
  'dash.inbox.more': '+ {n} de plus',
  'dash.inbox.profileWord': 'audience',
  'dash.inbox.profilesWord': 'audiences',
  'dash.inbox.showAll': 'Afficher les {n}',
  'dash.inbox.title': "À faire aujourd'hui",
  'dash.lastQueries.subAll':
    'Vos dernières recherches lancées sur tous les profils. Cliquez pour ouvrir les détails et relancer la recherche.',
  'dash.lastQueries.subForProfile':
    'Vos dernières recherches lancées pour "{profile}". Cliquez pour ouvrir les détails et relancer la recherche.',
  'dash.lastQueries.title': 'Dernières requêtes de Leads',
  'dash.lastSearch': 'Dernière recherche : {result}',
  'dash.lastSearch.error': 'Erreur',
  'dash.lastSearch.zero': '0 Leads',
  'dash.lastYear': 'Année dernière',
  'dash.leads': 'Leads',
  'dash.leadsGen': 'Leads générés',
  'dash.leadsGenerated': 'Leads générés',
  'dash.learning.body':
    'Avec chaque ✓ "correspond" ou ✗ "ne correspond pas" {scope}, Leadscraper affine sa compréhension de votre Lead idéal, et filtre les prochains résultats en conséquence.',
  'dash.learning.cta': 'Évaluer {n} Leads',
  'dash.learning.hint':
    'Lancez une recherche ci-dessus. Dès que des Leads arrivent, vous pourrez les évaluer.',
  'dash.learning.scopeAll': 'dans vos audiences',
  'dash.learning.scopeProfile': 'pour "{name}"',
  'dash.learning.title': 'Leadscraper attend votre premier retour',
  'dash.maturity.label': 'Niveau de maturité : {label}',
  'dash.maturity.next.many': "Encore {n} feedbacks jusqu'à {stage}.",
  'dash.maturity.next.one': "Encore {n} feedback jusqu'à {stage}.",
  'dash.maturity.stage.calibrated': 'Calibré',
  'dash.maturity.stage.early': 'En apprentissage',
  'dash.maturity.stage.mature': 'Mature',
  'dash.maturity.usage':
    'Leadscraper utilise vos feedbacks plus ou moins fortement lors de la prochaine recherche selon le niveau de maturité.',
  'dash.months': 'Mai,Juin,Juil,Août,Sep,Oct,Nov,Déc,Jan,Fév,Mar,Avr',
  'dash.newBadge': 'nouveau',
  'dash.newCust': 'Nouveaux clients',
  'dash.newCustomers': 'Nouveaux clients',
  'dash.newProfile': 'Nouvelle audience',
  'dash.nextRun.autoPaused': 'Auto-pausé · 3 recherches vides',
  'dash.nextRun.in': 'Prochaine recherche dans {time}',
  'dash.nextRun.manual': 'Manuel · pas de planning',
  'dash.nextRun.paused': 'Pausé',
  'dash.nextRun.pausedCredits': 'Pausé · Credits épuisés',
  'dash.nextRun.soon': 'Bientôt',
  'dash.nextUp': 'Suivant',
  'dash.onlyFavorites': 'Favoris uniquement',
  'dash.openLeads': 'Ouvrir Leads →',
  'dash.openProfile': 'Ouvrir Leads',
  'dash.profileDrop.create': 'Créer la première audience',
  'dash.profileDrop.createSub': "Définissez votre cible, puis c'est parti",
  'dash.profiles': 'actifs',
  'dash.progress': 'Progression',
  'dash.projRevenue': "Chiffre d'affaires projeté",
  'dash.projectedRevenue': 'CA projeté',
  'dash.query.businessType': "Type d'entreprise",
  'dash.query.contact': 'Contact',
  'dash.query.dashExplain':
    '"—" signifie : Leadscraper n\'a pas suivi la valeur (disponible avec la V1.13 comme trace complète d\'exécution).',
  'dash.query.deepAnalysis': 'Analyse approfondie',
  'dash.query.deepAnalysisHint': 'Site web + mentions légales lus',
  'dash.query.delivered': 'Livrées',
  'dash.query.deliveredHint': 'Résultats effectifs',
  'dash.query.evaluated': 'Évaluées',
  'dash.query.evaluatedHint': 'Raisonnement Leadscraper appliqué',
  'dash.query.extras': 'Critères supplémentaires',
  'dash.query.failedTitle': 'Échec de la recherche',
  'dash.query.header': 'Recherche de Leads',
  'dash.query.howWorked': 'Comment Leadscraper a travaillé',
  'dash.query.identified': 'Identifiées',
  'dash.query.identifiedHint': 'Entreprises trouvées via recherche web + annuaires',
  'dash.query.leadsSoFar': "{n} Leads jusqu'ici · en cours",
  'dash.query.loading': 'rechargement…',
  'dash.query.noLeads': 'Aucun Lead trouvé',
  'dash.query.profile': 'Audience : {name}',
  'dash.query.region': 'Région / Localisation',
  'dash.query.rerun': 'Relancer',
  'dash.query.rerunTitle':
    "Relancer cette requête dans Leadscraper (p. ex. après des mises à jour d'audience)",
  'dash.query.restart': 'Redémarrer',
  'dash.query.runHistory': 'Historique des dernières exécutions',
  'dash.query.runningNoLeads': 'En cours, des Leads arrivent bientôt',
  'dash.query.showLeads': 'Afficher {n} Leads',
  'dash.query.rerunRow': 'Relancer',
  'dash.query.rerunCta': 'Relancer la recherche',
  'dash.query.searchedLabel': 'Ce que tu as recherché',
  'dash.query.autoRepeat': 'Répéter automatiquement',
  'dash.query.openSettings': 'Ouvrir les réglages',
  'dash.query.startedAt': 'Démarré : {date}',
  'dash.query.suggestions': 'Suggestions Leadscraper',
  'dash.query.technicalDetails': 'Détails techniques',
  'dash.query.unfeasibleTitle': 'Leadscraper considère cette recherche comme irréalisable',
  'dash.query.unnamed': 'Recherche sans nom',
  'dash.query.whenRuns': "Quand cette recherche s'exécute-t-elle ?",
  'dash.queryHint': 'Conseil pour la recherche',
  'dash.queryId': 'Query ID',
  'dash.renameQuery': 'Renommer la requête',
  'dash.roi': 'Calculateur ROI',
  'dash.roiShort': 'ROI',
  'dash.run.audience': 'Cible :',
  'dash.run.businessType': "Type d'entreprise",
  'dash.run.businessTypeP': "ex. Fabricant d'emballages pliants avec presse propre",
  'dash.run.cancel': 'Annuler',
  'dash.run.contact': 'Contact',
  'dash.run.contactP': 'ex. Direction générale, Directeur des achats',
  'dash.run.extras': 'Critères supplémentaires',
  'dash.run.extrasP':
    'ex. pas de groupe, de préférence familiale, certifié FSC souhaité, 50–250 employés',
  'dash.run.forWhich': 'Pour quelle cible ?',
  'dash.run.minField': "Indiquer au minimum le type d'entreprise",
  'dash.run.notBackendProfile':
    "Cette audience n'est pas encore enregistrée dans le backend. Créez-en une vraie via",
  'dash.run.notBackendProfileCta': '+ Nouvelle audience',
  'dash.run.notBackendProfileEnd': ': le scraper fonctionnera alors.',
  'dash.run.optional': '(optionnel)',
  'dash.run.pastQueries': 'Dernières recherches de Leads',
  'dash.run.pastQueriesHint': 'Cliquer reprend les valeurs',
  'dash.run.region': 'Région / Localisation',
  'dash.run.regionHint': 'Ville, région, département ou "national", écris comme tu chercherais.',
  'dash.run.regionP': 'ex. Lyon, Île-de-France, région parisienne, ou national',
  'dash.run.searchBtn': 'Rechercher 10 Leads',
  // LEA-338 Part A / LEA-355 — auto-enrich contact-persons toggle (added in LEA-355).
  'dash.run.withContact.label': 'Enrichir le contact automatiquement',
  'dash.run.withContact.hint':
    "Chaque nouveau Lead est immédiatement enrichi avec les bons contacts et leurs coordonnées. Tu peux aussi examiner d'abord les Leads et les enrichir un par un, recommandé au début.",
  'dash.run.withContact.cost':
    "Jusqu'à {n} crédits, facturés uniquement en cas d'enrichissement réussi.",
  // LEA-418: per-phase credit-cost transparency
  'dash.run.cost.base': 'Coût : {n} leads = {n} crédits (1 par lead livré).',
  'dash.run.cost.extras': 'Contacts et insights : +1 crédit/lead chacun, sur demande.',
  'lt.next.connectCostHint':
    'Seulement 1 crédit si un contact joignable est trouvé, sinon gratuit.',
  // LEA-704: reveal-model pricing (Om QA 26.10.).
  'lt.next.connectFreeHint': "Gratuit — vous ne payez qu'en déverrouillant un interlocuteur.",
  // LEA-356 — cascading Phase-3 acquisition-plan toggle.
  'dash.run.withPlan.label': "Générer un plan d'acquisition automatiquement",
  'dash.run.withPlan.hint':
    "Pour chaque Lead enrichi, un plan d'acquisition sur mesure est généré, une approche de prospection concrète, fondée sur les contacts trouvés.",
  'dash.run.withPlan.cost':
    "Jusqu'à {n} crédits, facturés uniquement si le plan est généré avec succès.",
  'dash.run.sub': '10 Credits · 10 Leads · typiquement 5–12 min',
  'dash.run.title': 'Lancer une recherche de Leads',
  'dash.sched.change': 'modifier',
  'dash.sched.daily': 'Quotidien',
  'dash.sched.dailySub': 'Chaque jour 10 nouveaux Leads',
  'dash.sched.manual': 'Manuel',
  'dash.sched.manualSub': 'Pas de planning, seulement sur clic',
  'dash.sched.pause': '⏸ Pauser',
  'dash.sched.resume': '▶ Reprendre',
  'dash.sched.sub': 'Leadscraper récupère régulièrement 10 nouveaux leads pour cette audience.',
  'dash.sched.time': 'Planifier les requêtes',
  'dash.sched.title': 'Planifier les requêtes',
  'dash.sched.toast.error': 'Impossible de sauvegarder le planning : {err}',
  'dash.sched.toast.manual': "Planification supprimée : l'audience ne s'exécute qu'en manuel.",
  'dash.sched.toast.paused': 'Audience en pause, aucune exécution automatique.',
  'dash.sched.toast.set': 'Planning défini : Leadscraper fonctionne automatiquement ({cadence}).',
  'dash.sched.twiceWeekly': 'Lun / Jeu',
  'dash.sched.twiceWeeklySub': '2× par semaine, ~20 Leads/semaine',
  'dash.sched.weekly': 'Hebdomadaire',
  'dash.sched.weeklySub': 'Une fois par semaine 10 Leads',
  'dash.schedInd.nextRun': 'prochaine recherche',
  'dash.schedInfo.everyNh': 'toutes les {n} h',
  'dash.schedInfo.hourly': 'horaire',
  'dash.schedInfo.oneshot': 'unique',
  'dash.schedInfo.paused': 'pausé',
  'dash.simulation': 'Simulation',
  'dash.startRun': 'Démarrer la recherche',
  'dash.startRunDisabledHint': "Créez d'abord une audience, puis lancez une recherche",
  'dash.status': 'Statut',
  'dash.status.delivered.many': '{n} Leads livrés',
  'dash.status.delivered.one': '{n} Lead livré',
  'dash.status.deliveredSuffix.many': 'Leads livrés',
  'dash.status.deliveredSuffix.one': 'Lead livré',
  'dash.status.done': 'Terminé',
  'dash.status.empty': 'Aucun résultat',
  'dash.status.failed': 'Échec',
  'dash.status.running': 'En cours',
  'dash.status.runningEllipsis': 'En cours…',
  'dash.status.runningPrefix': 'En cours · ',
  'dash.status.unfeasible': 'Non réalisable',
  'dash.step.delivery': 'Compilation des Leads',
  'dash.step.discovery': 'Identifier les entreprises',
  'dash.step.done': 'Terminé',
  'dash.step.fallbackProfile': 'Audience',
  'dash.step.hydration': 'Analyser les entreprises en profondeur',
  'dash.step.planning': 'Leadscraper se souvient',
  'dash.step.reasoning': 'Leadscraper évalue',
  'dash.step.starting': 'Démarrage…',
  'dash.timeline': 'Évolution des indicateurs dans le temps',
  'dash.totalLeads': 'Nombre total de Leads',
  'dash.whenCell.next': 'prochain {label}',
  'dash.winRate': 'Taux de conversion',
  'dash.yourLeads': 'Vos Leads',
  'dash.yourProfiles': 'Vos audiences',
  'dash.yourProfilesSub':
    'Toutes les audiences que vous entraînez. Un clic ouvre les leads de cette audience.',

  'det.accepted': 'Accepté',
  'det.back': 'Retour aux résultats de recherche',
  'det.city': 'Localisation',
  'det.companyProfile': "Profil d'entreprise",
  'det.contact': 'Contact',
  'det.contactsEmpty':
    'Aucun interlocuteur extrait pour le moment. Leadscraper recherche dans les mentions légales + LinkedIn.',
  'det.crmSoonTitle':
    "L'intégration CRM arrive bientôt. Vous serez notifié dès que HubSpot, Pipedrive & Co. seront connectés.",
  'det.decider': 'Décideur',
  'det.delivers': 'Fournit :',
  'det.draftMail': "Préparer un brouillon d'e-mail",
  'det.draftMailSoonToast':
    "Les brouillons d'e-mail depuis le Lead ne sont pas encore disponibles, bientôt.",
  'det.fetched': 'récupéré',
  'det.fits': 'Compatible',
  'det.fitsNot': 'Pas compatible',
  'det.founded': 'Fondation',
  'det.markedFit': '✓ Marqué comme compatible',
  'det.rejectAnyway': '↩ Finalement pas adapté ?',
  'det.markedNotFit': '× Marqué comme non compatible',
  'det.memoryHint': 'Note pour votre mémoire',
  'det.memoryHintText':
    'Si vous acceptez ou refusez ce Lead, cela influencera les Leads similaires dans "{profile}", mais pas vos autres profils.',
  'det.open': 'Ouvrir',
  'det.patterns': "Schémas appris qui s'appliquent ici",
  'det.publicOnly':
    'Toutes les sources sont publiquement accessibles. Leadscraper ne stocke jamais de données provenant de répertoires non publics ou payants.',
  'det.research.footer':
    "Leadscraper teste différents chemins de recherche (LinkedIn, site web d'entreprise, presse, Xing) avant de recourir au directeur général par défaut. Ainsi, il est transparent pourquoi exactement ce contact est affiché.",
  'det.research.hit': '✓ Résultat',
  'det.research.label': 'Chemin de recherche',
  'det.research.noHit': '○ aucun résultat',
  'det.research.resultMany': 'Résultats',
  'det.research.resultOne': 'Résultat',
  'det.research.summaryFallback':
    '{n} chemins de recherche testés, aucun rôle spécifique trouvé, directeur général par défaut',
  'det.research.summaryFound': "Contact trouvé à l'étape {stage} : {label}",
  'det.research.summaryNoHit': '{n} chemins de recherche sans résultat',
  'det.sector': 'Secteur',
  'det.shortProfile': 'Profil court',
  'det.similar': 'Similaire aux Leads que vous avez acceptés précédemment',
  'det.size': 'Employés',
  'det.sourcesCount': 'Sources',
  'det.sourcesSub': 'Chaque champ de ce Lead peut être retracé vers une source publique concrète.',
  'det.sourcesTitle': "D'où proviennent ces informations",
  'det.trail.searched': 'Cortex a consulté {n} sources publiques',
  'det.trail.website': 'Site web',
  'det.trail.register': 'Registre du commerce',
  'det.trail.google': 'Recherche Google',
  'det.trail.press': 'Presse',
  'det.trail.pages': '{n} pages',
  'det.trail.profiles': '{n} profils',
  'det.capturedAt': 'relevé',
  'det.derivedAt': 'déduit',
  'det.sourcePage': 'Page source',
  'det.sourcesBelegtCount': '{n} sourcés',
  'det.sourcesTagline': "D'où vient chaque information, ouvert et vérifiable.",
  'det.sourcesBelegt': '{n} sur {total} sourcés',
  'det.sourcesFieldCount': '{n} champs',
  'det.lastChecked': 'dernière vérification',
  'det.sourcesUnsourced': 'Pas encore sourcé',
  'det.sourcesHonesty':
    "Les informations officielles et publiques sont sourcées directement ; les estimations IA sont clairement signalées. Leadscraper n'utilise aucune base de données payante.",
  'det.sourcesFlex':
    "D'autres cachent d'où viennent leurs données. Nous montrons chaque source, vérifiable.",
  'ld.tier.officialName': 'Source officielle',
  'ld.tier.officialSub': 'Registre officiel et mentions légales obligatoires',
  'ld.tier.publicName': 'Source publique',
  'ld.tier.publicSub': 'Consultable publiquement sur le web',
  'ld.tier.inferredName': 'Déduit par Cortex',
  'ld.tier.inferredSub': "Estimation, à vérifier avant l'envoi",
  'ld.tier.officialFallback': 'Source officielle',
  'ld.tier.publicFallback': 'Source publique',
  'ld.tier.inferredFallback': 'Déduit par Cortex',
  'ld.tier.legendOfficial': 'officiel',
  'ld.tier.legendPublic': 'public',
  'ld.tier.legendInferred': 'déduit · vérifier',
  'ld.tier.legendUnsourced': 'à sourcer',
  'ld.srcLabel.dork': 'Recherche web publique',
  'ld.srcLabel.icypeas_finder': 'E-mail déduit',
  'ld.srcLabel.role_match': 'Correspondance de rôle',
  'ld.srcLabel.cortexNace': 'Analyse sectorielle Cortex',
  'ld.field.vatId': 'N° TVA',
  'ld.field.facebook': 'Facebook',
  'ld.field.instagram': 'Instagram',
  'ld.field.country': 'Pays',
  'ld.field.contactPhone': 'Téléphone (contact)',
  'det.toCRM': 'Transférer vers CRM',
  'det.webExcerpts': 'Extraits de site web',
  'det.website': 'Site web',
  'det.whyFits': 'Pourquoi cela vous correspond',
  'det.whyFitsSub': "d'après ce que Leadscraper a appris sur vous",

  'error.account_deleted': 'Ce compte a été supprimé.',
  'error.email_unverified':
    "Veuillez d'abord vérifier votre adresse e-mail (lien dans l'e-mail d'inscription).",
  'error.demo_read_only': 'Cette action est désactivée dans la démo. Rien n’a été modifié.',
  'error.impersonate_target_not_found':
    "Compte de test introuvable : l'UID n'existe pas dans cet environnement DB (Mini / Staging / Production).",
  'error.invalidInput': 'Saisie non valide.',
  'error.noProfile': 'Aucune audience sélectionnée.',
  'error.profileNotRegistered':
    "Audience pas encore enregistrée dans le backend. J'ouvre l'assistant.",
  'error.unauthenticated':
    "Vous n'êtes pas connecté. Veuillez recharger la page et vous reconnecter.",

  'expired.body':
    'Ton accès est en pause. Réactive ton abonnement pour rechercher à nouveau des Leads et relancer tes cibles.',
  'expired.readOnly':
    'Tu peux toujours consulter et exporter tes Leads. Les nouvelles recherches et la recherche de contacts nécessitent un abonnement actif.',
  'expired.creditsKept': 'Tes {credits} Credits sont gelés, pas supprimés.',
  'expired.cta': "Réactiver l'abonnement",
  'expired.ctaLoading': 'Chargement…',
  'expired.title': 'Ton abonnement a pris fin',
  // LEA-704: welcome-back screen for expired accounts moved into the reveal model.
  'revealMigration.title': 'Bon retour',
  'revealMigration.subtitle': 'Leadscraper facture désormais par contact',
  'revealMigration.free': "La recherche d'entreprises et de contacts est gratuite",
  'revealMigration.payPerContact': 'Tu ne paies que lorsque tu déverrouilles un interlocuteur',
  'revealMigration.units': 'Ton solde est conservé : {n} contacts à déverrouiller',
  'revealMigration.unitsOne': 'Ton solde est conservé : 1 contact à déverrouiller',
  'revealMigration.unitsNone': 'Achète des contacts par pack quand tu en as besoin',
  'revealMigration.cta': 'Continuer',
  'revealMigration.ctaLoading': 'Un instant…',
  'revealMigration.error': "Cela n'a pas fonctionné. Réessaie.",

  'fb.blocked.headline': 'La requête est trop large',
  'fb.blocked.subline':
    'Leadscraper trouverait principalement des portails, associations ou cabinets de conseil, pas de vraies entreprises individuelles.',
  'fb.cta.adjust': 'Ajuster la requête',
  'fb.cta.bypass': 'Commencer quand même',
  'fb.cta.bypassTitle': 'La requête passera quand même par Leadscraper, à vos propres risques',
  'fb.cta.sharpen': 'Retour & préciser',
  'fb.field.ansprechpartner': 'Personne de contact',
  'fb.field.ort': 'Ville',
  'fb.field.rawQuery': 'Texte libre',
  'fb.field.region': 'Région',
  'fb.field.unternehmensart': "Type d'entreprise",
  'fb.field.zusatz': 'Critères supplémentaires',
  'fb.fieldWarnings': 'Champs avec avertissements',
  'fb.suggestions': 'Formulations plus précises',
  'fb.suggestionsHint':
    'Copiez une des suggestions dans le champ ou formulez vous-même : cela augmente considérablement le taux de correspondance.',
  'fb.warning.headline': 'Cette requête est très spécifique',
  'fb.warning.subline':
    'Avec cette combinaison de filtres, Leadscraper ne trouvera peut-être que peu ou aucun résultat. Vous pouvez quand même commencer ou élargir la requête.',

  'find.amount': 'Nombre de Leads',
  'find.amountHint': 'La valeur doit être comprise entre 1 et 1000',
  'find.businessType': "Type d'entreprise",
  'find.businessTypeP': 'ex. Restaurant, Avocat, Expert-comptable',
  'find.contact': 'Contact',
  'find.contactP': 'ex. Propriétaire, Commercial, Directeur',
  'find.creditNote': '(1 Lead = 1 Credit)',
  'find.extras': 'Restrictions supplémentaires',
  'find.extrasP': 'Définissez votre groupe cible plus précisément',
  'find.forProfile': 'Pour quelle audience ?',
  'find.forProfileHint': 'Vos évaluations entraînent Leadscraper pour cette audience.',
  'find.location': 'Localisation',
  'find.locationP': 'ex. Paris, Lyon, Marseille',
  'find.start': 'Démarrer Leadscraper',
  'find.title': 'Trouver de nouveaux Leads',
  'find.trainsProfile': 'Entraîne',

  'hero.eyebrow': 'Leadscraper apprend à vous connaître',
  'hero.stat.feedbacks': 'Feedbacks au total',
  'hero.stat.matchrate': '⌀ Taux de correspondance',
  'hero.stat.profiles': 'audiences actives',
  'hero.sub':
    'Chaque « Convient / Ne convient pas » affine les Leads qui apparaîtront en haut demain. Voici vos indicateurs actuels.',
  'hero.title': 'Sur toutes les audiences, Leadscraper devient plus précis, à chaque retour.',

  'inbox.sched.body':
    'Prochaine exécution {rel} : les nouveaux Leads arrivent automatiquement {where}.',
  'inbox.sched.cta': 'Voir',
  'inbox.sched.inCRM': 'dans le CRM',
  'inbox.sched.inList': 'dans votre liste',
  'inbox.sched.title': '{n} exécutions planifiées actives',

  'ld.aggregatorWarn':
    "Le site web propre de l'entreprise est encore en cours de détermination. En attendant, nous affichons l'URL source (annuaire/presse) d'où provient cette entreprise.",
  'ld.comingSoon': '· bientôt',
  'ld.company': 'Entreprise',
  'ld.companySite': "Site de l'entreprise",
  'ld.contactPhoneUnknown': 'Ligne directe non publique',
  'ld.contacts': 'Contacts',
  'ld.decisionMaker': '· Décisionnaire',
  'ld.email.apply': 'Appliquer le modèle',
  'ld.email.confGuessed': 'supposé',
  'ld.email.confLikely': 'probable',
  'ld.email.confPlausible': 'plausible',
  'ld.email.copied': 'Email supposé copié dans le presse-papiers.',
  'ld.email.derivedFrom':
    "Dérivé de {n} email{s} sur le site web de l'entreprise. {conf}, vérifiez avant d'envoyer.",
  'ld.email.noDirectExplain':
    "L'email direct de {first} {last} n'a pas été trouvé. Nous avons cependant détecté le schéma email de l'entreprise. Cliquez pour voir l'adresse probable. Vous en êtes responsable.",
  'ld.email.notFound': 'Aucun email direct trouvé pour ce contact.',
  'ld.emailLabel': 'E-mail',
  'ld.emailPattern': "Modèle d'Email",
  'ld.emailPattern.confHigh': 'élevée',
  'ld.emailPattern.confLow': 'faible',
  'ld.emailPattern.confMid': 'moyenne',
  'ld.emailPattern.hint': 'Tous les contacts de cette entreprise suivent probablement ce modèle.',
  'ld.emailPattern.noPattern': 'Les emails trouvés ({n}) ne suivent aucun modèle clair.',
  'ld.emailPattern.noSamples': "Aucun email d'employé trouvé sur le site web.",
  'ld.emailPattern.notFound': 'Aucun modèle trouvé',
  'ld.emailPattern.notRecognized': 'non reconnu',
  'ld.emailPattern.sourceMany': 'Sources',
  'ld.emailPattern.sourceOne': 'Source',
  'ld.fetchedThisWeek': 'cette semaine',
  'ld.field.acquisitionHook': 'Accroche Commerciale Leadscraper',
  'ld.field.centralEmail': 'Email central',
  'ld.field.centralPhone': 'Téléphone central',
  'ld.field.certs': 'Certifications',
  'ld.field.city': 'Ville',
  'ld.field.companyName': "Nom de l'entreprise",
  'ld.field.customerRefs': 'Références Clients',
  'ld.field.description': 'Profil court',
  'ld.field.email': 'Email (Décisionnaire)',
  'ld.field.employees': "Nombre d'employés",
  'ld.field.firstName': 'Prénom (décideur)',
  'ld.field.foundedYear': 'Année de création',
  'ld.field.hrNumber': 'Numéro de registre du commerce',
  'ld.field.jobSnapshot': "Offres d'Emploi",
  'ld.field.lastName': 'Nom de famille (Décisionnaire)',
  'ld.field.legalForm': 'Forme juridique',
  'ld.field.linkedin': 'LinkedIn (Décisionnaire)',
  'ld.field.locations': 'Implantations',
  'ld.field.nace': 'Secteur NACE',
  'ld.field.ownership': 'Propriétaires / Historique',
  'ld.field.revenueRange': "Fourchette de chiffre d'affaires",
  'ld.field.role': 'Rôle (Décisionnaire)',
  'ld.field.sizeClass': 'Classe de taille',
  'ld.field.street': 'Rue',
  'ld.field.triggerEvent': 'Événement Déclencheur',
  'ld.field.website': 'URL du site web',
  'ld.field.xing': 'XING (Décisionnaire)',
  'ld.field.deciderProfile': 'Profil du décideur',
  'ld.field.zip': 'Code postal',
  'ld.linkedinPublic': 'LinkedIn · public',
  'ld.match.borderline': 'cas limite',
  'ld.match.excellent': 'excellent',
  'ld.match.solid': 'correspondance solide',
  'ld.match.strong': 'forte correspondance',
  'ld.sparkle.certs': 'Certifications & Récompenses',
  'ld.sparkle.customers': 'Références Clients',
  'ld.sparkle.hookFake':
    'Vous pouvez vous connecter ici car {company} présente un profil classique de PME avec un besoin concret, correspond directement à votre offre.',
  'ld.sparkle.hookLabel': 'Accroche Commerciale Leadscraper',
  'ld.sparkle.hookUnlockLink': "votre site web d'entreprise",
  'ld.sparkle.hookUnlockPost':
    '. Leadscraper générera alors une accroche personnalisée pour chaque lead.',
  'ld.sparkle.hookUnlockPre': 'Saisissez dans le tableau de bord ci-dessus ',
  'ld.sparkle.jobs': 'Instantané Emplois',
  'ld.sparkle.jobsBadge': '{n} postes ouverts',
  'ld.sparkle.locations': 'Implantations',
  'ld.sparkle.locked': '· verrouillé',
  'ld.sparkle.ownerSince': 'depuis {year}',
  'ld.sparkle.ownership': 'Structure Propriétaire',
  'ld.sparkle.staleAction':
    'Relancez la requête dans le tableau de bord : nous générerons alors pour CE lead une accroche commerciale personnalisée plus tous les signaux de vente (événements déclencheurs, postes ouverts, clients, …).',
  'ld.sparkle.staleMsg':
    "Ce lead a été généré avant que votre profil d'entreprise soit enregistré chez Leadscraper.",
  'ld.sparkle.sub': "· Signaux commerciaux issus de l'analyse web en temps réel",
  'ld.sparkle.title': 'Leadscraper Magic',
  'ld.sparkle.trigger': 'Événement Déclencheur',
  'ld.sparkle.waitLabel': '· en attente de re-exécution',
  'ld.specialization': 'Spécialisation',
  'ld.srcDesc.firecrawl': "Page principale du site web de l'entreprise (mise en cache).",
  'ld.srcDesc.footer': 'Pied de page du site : sites, certificats, moyens de contact alternatifs.',
  'ld.srcDesc.haiku_extracted':
    'Leadscraper a extrait des champs structurés du contenu web enrichi (description, clients, événements déclencheurs).',
  'ld.srcDesc.handelsregister':
    "Registre officiel allemand des entreprises : numéro HRB, siège, date d'inscription.",
  'ld.srcDesc.impressum':
    "Page de mentions légales avec nom de l'entreprise, forme juridique, adresse, direction. Récupérée et analysée.",
  'ld.srcDesc.json_ld': 'Métadonnées Schema.org lisibles par machine du site web (profil org).',
  'ld.srcDesc.karriere':
    'Page carrières : postes ouverts, profils recherchés (signal de croissance).',
  'ld.srcDesc.kontakt':
    'Page contact/localisation : numéros de téléphone, adresses email, éventuels contacts.',
  'ld.srcDesc.llm_haiku':
    'Leadscraper a extrait des champs structurés du contenu web enrichi (description, clients, événements déclencheurs).',
  'ld.srcDesc.llm_sonnet': 'Leadscraper a évalué le lead par rapport à votre audience + mémoire.',
  'ld.srcDesc.news':
    "Page presse/actualités : derniers événements, extensions d'usine, récompenses.",
  'ld.srcDesc.regex_derived':
    "Dérivé d'autres données : par ex. modèle d'email à partir d'email d'entreprise connu + nom.",
  'ld.srcDesc.serp': 'Résultats Google pour recherche ciblée de domaine ou personne.',
  'ld.srcDesc.team': 'Page équipe/employés : personnes et rôles.',
  'ld.srcDesc.ueber_uns':
    "Description de l'entreprise : histoire, propriétaires, valeurs, références clients.",
  'ld.srcDesc.user_feedback':
    'Vous avez manuellement confirmé ou rejeté ce Lead, niveau de confiance maximum.',
  'ld.srcLabel.firecrawl': "Site web de l'entreprise (page principale)",
  'ld.srcLabel.footer': 'Pied de page du site',
  'ld.srcLabel.haiku_extracted': 'Extraction IA',
  'ld.srcLabel.handelsregister': 'Registre du commerce',
  'ld.srcLabel.impressum': 'Mentions légales',
  'ld.srcLabel.json_ld': 'Données structurées (Schema.org)',
  'ld.srcLabel.karriere': 'Page carrières',
  'ld.srcLabel.kontakt': 'Page contact',
  'ld.srcLabel.llm_haiku': 'Extraction IA',
  'ld.srcLabel.llm_sonnet': 'Évaluation IA',
  'ld.srcLabel.news': 'Presse / Actualités',
  'ld.srcLabel.regex_derived': 'Dérivation de modèle',
  'ld.srcLabel.serp': 'Recherche Google',
  'ld.srcLabel.team': 'Page équipe',
  'ld.srcLabel.ueber_uns': 'Page à propos',
  'ld.srcLabel.user_feedback': 'Votre feedback',
  'ld.toast.accepted': '„{company}" sauvegardé comme Convient.',
  'ld.toast.feedbackErr': 'Impossible de sauvegarder le feedback : essayez à nouveau.',
  'ld.toast.rejected': '„{company}" marqué comme Ne convient pas.',
  'ld.trust.inferred': '🔵 IA-dérivé',
  'ld.trust.inferredTitle': "Dérivé par l'IA Leadscraper, source non officielle.",
  'ld.trust.official': '🛡 Officiel',
  'ld.trust.officialTitle':
    'Source légalement authoritative (Registre du commerce/Mentions légales).',
  'ld.trust.public': '🟡 Public',
  'ld.trust.publicTitle': "Visible publiquement sur le site de l'entreprise.",
  'ld.uncertainty': 'Leadscraper est ici {score} : {text}.',
  'ld.unverified.body':
    'Correspondance sectorielle générique : la spécialisation n\'a pas été mentionnée dans le contenu du site web. Si strictement nécessaire, précisez la requête (ex. „magasin spécialisé {token}").',
  'ld.unverified.title': '„{token}" n\'a pas pu être vérifié par Leadscraper sur cette entreprise',
  'ld.viaCentralPhone': 'Via standard',
  'ld.websiteExcerpt': 'Extrait du site web',
  'ld.xingPublic': 'XING · public',

  'leads.act.cancel': 'Annuler',
  'leads.act.details': 'Détails',
  'leads.act.fits': 'Correspond',
  'leads.act.fitsDone': 'Enregistré comme correspond',
  'leads.act.fitsNot': 'Ne correspond pas',
  'leads.act.fitsNotDone': 'Enregistré comme ne correspond pas',
  'leads.act.reason': 'Choisir une raison',
  'leads.allProfiles': 'Toutes les audiences',
  'leads.allProfilesHeader': 'Toutes les audiences',
  'leads.allProfilesShow': 'Afficher toutes les audiences',
  'leads.backToActive': "← retour à l'audience active",
  'leads.cardView': 'Cartes',
  'leads.chip.edge': 'Cas limite · Votre avis ?',
  'leads.chip.pattern': 'Forme un modèle',
  'leads.col.actions': 'Actions',
  'leads.col.centralEmail': 'E-mail',
  'leads.col.centralPhone': 'Téléphone',
  'leads.col.city': 'Localisation',
  'leads.col.company': 'Entreprise',
  'leads.col.crm': 'CRM',
  'leads.col.decider': 'Décideur',
  'leads.col.founded': 'Fondation',
  'leads.col.lastActivity': 'Dernière activité',
  'leads.col.legalForm': 'Forme juridique',
  'leads.col.match': 'Match',
  'leads.col.nace': 'Secteur',
  'leads.col.phase': 'Phase',
  'leads.col.phone': 'Téléphone',
  'leads.col.profile': 'Audience',
  'leads.col.revenue': "Chiffre d'affaires",
  'leads.col.sector': 'Sous-secteur',
  'leads.col.size': 'Employés',
  'leads.col.status': 'Statut',
  'leads.col.website': 'Site web',
  'leads.cols.btn': 'Colonnes',
  'leads.cols.fixed': 'Fixe',
  'leads.cols.reset': 'Réinitialiser',
  'leads.cols.sub': "N'affichez que ce dont vous avez besoin.",
  'leads.cols.title': 'Afficher les colonnes',
  'leads.count': '{shown} sur {total} Leads',
  'leads.crm.push': 'Envoyer',
  'leads.crm.notSynced': 'Non synchronisé',
  'leads.crm.syncedTo': 'Synchronisé avec {crm}',
  'leads.crm.pushFailed': "Échec de l'envoi",
  'leads.crossOverview.many': '{n} leads · toutes audiences',
  'leads.crossOverview.one': '{n} lead · toutes audiences',
  'leads.daysAgo': 'il y a {n} jours',
  'leads.empty':
    'Aucun Lead pour ce profil : lancez une nouvelle recherche via « Trouver de nouveaux Leads ».',
  'leads.exp.memoryRefs': 'De votre mémoire',
  'leads.exp.uncertain': 'Leadscraper est ici {score} : {note}.',
  'leads.exp.whyShown': 'Pourquoi Leadscraper vous montre ce Lead',
  'leads.export': 'Export',
  'leads.filter.all': 'Tous',
  'leads.filter.fits': 'Correspond',
  'leads.filter.fitsNot': 'Ne correspond pas',
  'leads.filter.unrated': 'Non évalué',
  'leads.filterBy': 'Filtrer par audience',
  'leads.footerHint':
    'Cliquez sur une ligne pour voir le résumé. Le bouton « Détails » ouvre la vue 360°.',
  'leads.searchP': 'Entreprise, secteur, localisation, décideur…',
  'leads.status.accepted': 'Correspond',
  'leads.status.rejected': 'Ne correspond pas',
  'leads.status.unseen': 'Non vu',
  'leads.sub': "{n} Leads · groupés par tes profils. Un clic ouvre la vue 360° sur l'entreprise.",
  'leads.tableView': 'Tableau',
  'leads.title': 'Tes Leads',
  'leads.toast.accepted': '« {c} » enregistré comme correspond. Leadscraper en apprend.',
  'leads.toast.export': "Fonction d'export bientôt disponible.",
  'leads.toast.rejected':
    '« {c} » rejeté · Raison : {r}. Leadscraper en apprend pour les prochaines recherches.',

  'lp.card.examplesHint': "(IDs de Leads de ton historique d'évaluation pour ce cluster)",
  'lp.card.hideExamples': 'Masquer les exemples',
  'lp.card.showExamplesMany': "Afficher {n} Leads d'exemple",
  'lp.card.showExamplesOne': "Afficher {n} Lead d'exemple",
  'lp.cl.age': "Âge de l'entreprise",
  'lp.cl.age.mock': 'Entreprises établies créées avant 2010 préférées',
  'lp.cl.bizModel': 'Modèle économique',
  'lp.cl.bizModel.mock': "Prestataires opérationnels, pas d'agences ou d'intermédiaires",
  'lp.cl.buyingSignals': "Signaux d'achat",
  'lp.cl.buyingSignals.mock': 'Événements déclencheurs actifs recherchés (croissance, recrutement)',
  'lp.cl.domainBlock': 'Blocage de domaine',
  'lp.cl.domainBlock.mock': 'Domaines concurrents systématiquement exclus',
  'lp.cl.geo': 'Localisation',
  'lp.cl.geo.mock': "NRW + BaWü fortement préférés, Est de l'Allemagne plutôt évité",
  'lp.cl.industry': 'Secteur',
  'lp.cl.industry.mock': "Préfère le secteur services (M-N) à l'industrie",
  'lp.cl.ownership': 'Propriétaire',
  'lp.cl.ownership.mock': 'Entreprises familiales >> filiales PE et groupes',
  'lp.cl.role': 'Contact',
  'lp.cl.role.mock': 'Niveau direction générale attendu, chef de service trop junior',
  'lp.cl.size': "Taille d'entreprise",
  'lp.cl.size.mock': 'Tendance vers les petites structures (10-50 employés)',
  'lp.cl.techStack': 'Stack technique',
  'lp.cl.techStack.mock': 'Certaines technologies sont systématiquement recherchées/évitées',
  'lp.cta.count': 'Évaluer {n} Leads',
  'lp.cta.open': 'Ouvrir les Leads',
  'lp.cta.rate': 'Évaluer les Leads',
  'lp.error.load': 'Erreur de chargement',
  'lp.evidence.many': '{n} preuves',
  'lp.evidence.one': '{n} preuve',
  'lp.journey.active': 'Personnalisé actif',
  'lp.journey.matchRate': 'Taux de correspondance',
  'lp.journey.matched': 'correspondaient',
  'lp.journey.notMatched': 'ne correspondaient pas',
  'lp.journey.preview': 'Premier apprentissage',
  'lp.journey.title': '{n} évaluations : {accepted} correspond · {rejected} ne correspond pas',
  'lp.loading': "Chargement de l'apprentissage…",
  'lp.locked.pill': 'à partir de {n} évaluations',
  'lp.ps.bizModel.analyse':
    "Leadscraper a le filtre standard actif : agences, distributeurs et marketplaces sont automatiquement déprioritisés dans le raisonnement s'ils ne correspondent pas à la demande.",
  'lp.ps.bizModel.content': 'Fournisseurs opérationnels (pas de simples intermédiaires)',
  'lp.ps.bodyDefault':
    "Ces cartes montrent ce que Leadscraper a concrètement **analysé** de ton profil + les Leads confirmés. Évalue plus spécifiquement avec une raison pour que les clusters s'affinent.",
  'lp.ps.bodyHigh':
    "Avec seulement {rejected} {rejectWord}, Leadscraper ne peut pas former de clusters d'exclusion stricts. Ces cartes montrent ce que Leadscraper a concrètement **analysé** de ton profil + les {accepted} Leads confirmés. Dès que tu rejettes plus spécifiquement, les clusters mûrissent en filtres stricts.",
  'lp.ps.footerBody':
    "À partir de **50 évaluations**, Leadscraper prend en compte lors de chaque nouvelle recherche non seulement ta saisie et ce que ton entreprise vend, mais aussi ton **profil appris comme tendance** : secteur, classe de taille, localisation, rôle, structure de propriété. Pas comme un filtre strict, mais comme une pondération supplémentaire dans le raisonnement. Cela signifie qu'une nouvelle requête pour « Conseiller fiscal Hambourg » ne recherche pas génériquement tous les cabinets comptables, mais privilégie automatiquement les cabinets PME dirigés par leur propriétaire, analogue à l'image de profil que tu as construite ici.",
  'lp.ps.footerTitle': "Comment cela s'intègre dans tes prochaines recherches",
  'lp.ps.geo.analyseNo':
    'Leadscraper priorise les résultats de cette région et filtre les résultats du périmètre quand la région centrale se raréfie.',
  'lp.ps.geo.analyseYes':
    "Leadscraper a confirmé {n} entreprises de cette région comme correspondantes : l'ancrage géographique est au point.",
  'lp.ps.geo.fallback': 'Zone DACH',
  'lp.ps.industry.analyseNo':
    'Leadscraper recherche systématiquement des entreprises qui correspondent à ta description sectorielle.',
  'lp.ps.industry.analyseYes':
    'Leadscraper confirme ce secteur grâce à {n} Leads acceptés : la délimitation sectorielle est au point.',
  'lp.ps.industry.anyBranche':
    'Votre profil est ouvert à tous les secteurs. Cortex déduit la tendance réelle à partir de vos évaluations. Actuellement {n} Leads acceptés comme références. Plus vous évaluez, plus la tendance sectorielle dérivée devient précise.',
  'lp.ps.industry.fallback': "Déduit de l'intention de ton profil",
  'lp.ps.ownership.analyseHigh':
    "Leadscraper reconnaît d'après les Leads confirmés que ton focus se porte sur les entreprises dirigées par leur propriétaire : les filiales de groupe sont proposées avec plus de retenue.",
  'lp.ps.ownership.analyseLow':
    'Évalue concrètement une filiale de groupe avec "ne correspond pas" pour que Leadscraper puisse former ici un cluster propriétaire strict.',
  'lp.ps.ownership.contentHigh': 'Profil propriétaire/PME confirmé',
  'lp.ps.ownership.contentLow':
    'Mix de structures propriétaires et de petites structures de groupe',
  'lp.ps.ownership.label': 'Structure de propriété',
  'lp.ps.rejectionMany': 'rejets',
  'lp.ps.rejectionOne': 'rejet',
  'lp.ps.role.analyseHigh':
    'Leadscraper recherche activement ce rôle dans le raisonnement : mentions légales + pages carrières + LinkedIn sont filtrés spécifiquement sur ce critère.',
  'lp.ps.role.analyseLow':
    "Leadscraper recherche spécifiquement ces rôles dans les mentions légales + sur les pages carrières, ne se rabat sur les dirigeants que si le rôle spécifique n'est pas mentionné.",
  'lp.ps.role.fallback': 'Niveau direction générale',
  'lp.ps.size.analyseHigh':
    'Avec {pct}% de taux de réussite, Leadscraper voit que ta classe de taille souhaitée est atteinte de manière stable, aucun besoin de correction visible.',
  'lp.ps.size.analyseLow':
    "Leadscraper ajuste la fourchette d'employés plus finement à ta vision à chaque rejet.",
  'lp.ps.size.contentHigh': 'Leadscraper cible précisément la classe de taille',
  'lp.ps.size.contentLow': "Tendance PME d'après les Leads confirmés",
  'lp.ps.titleDefault': 'Ce que Leadscraper comprend de tes évaluations',
  'lp.ps.titleHigh': 'Leadscraper comprend votre audience · {pct}% de réussite',
  'lp.ps.understands': 'Leadscraper comprend',
  'lp.s0.body':
    'Avec {preview} Leads évalués, nous te montrons la première impression. Avec {active}, Leadscraper recherche activement pour TOI, basé sur tes modèles très concrets.',
  'lp.s0.eyebrow': 'Leadscraper apprend avec vous',
  'lp.s0.headline': 'Leadscraper construit votre audience',
  'lp.s0.openMany': '{n} Leads encore non évalués : évalue-les pour progresser plus rapidement.',
  'lp.s0.openOne': '{n} Lead encore non évalué : évalue-le pour progresser plus rapidement.',
  'lp.s1.body':
    "Les premières tendances sont visibles : à partir de {n} évaluations, cela s'intègre activement dans tes recherches.",
  'lp.s1.eyebrow': 'Première impression',
  'lp.s1.headline': 'Leadscraper collecte encore des preuves',
  'lp.s1.morePatterns': 'Autres modèles, seront visibles à partir de {n} évaluations',
  'lp.s1.strongestLabel': "Tendance la plus forte jusqu'à présent",
  'lp.s2.headline': 'Leadscraper recherche pour TOI',
  'lp.s2.ignoredMany':
    '{n} évaluations étaient "on connaît déjà" ou "données incorrectes" : celles-ci ne sont volontairement pas intégrées dans l\'apprentissage.',
  'lp.s2.ignoredOne':
    '{n} évaluation était "on connaît déjà" ou "données incorrectes" : celle-ci n\'est volontairement pas intégrée dans l\'apprentissage.',
  'lp.s2.pillActive': 'Personnalisé activement',
  'lp.s2.pillSharp': 'Audience bien ciblée',
  'lp.s2.pillUpdating': 'Mise à jour en cours',
  'lp.s2.reanalysisAgo': 'Dernière re-analyse : il y a {n} évaluations · Prochaine à {next}',
  'lp.s2.reanalysisCurrent': 'Re-analyse en cours · Prochaine à {n}',
  'lp.s2.weakLabel': 'Tendances faibles, deviendront plus solides avec plus de données',
  'lp.sq.activeSubS1':
    'Basé sur tes premières {n} évaluations, deviendront plus précises à chaque étape de re-analyse.',
  'lp.sq.activeSubS2':
    'Mis à jour après {n} évaluations · Re-analyse toutes les {interval} évaluations.',
  'lp.sq.activeTitle': 'Leadscraper propose ces recherches',
  'lp.sq.badge.crossSell': 'Cross-Sell',
  'lp.sq.badge.expansion': 'Extension',
  'lp.sq.badge.pattern': 'Pattern',
  'lp.sq.badge.salesFit': 'Sales-Fit',
  'lp.sq.badge.zoomOut': 'Zoom-out',
  'lp.sq.emptyBody':
    'Les propositions seront calculées avec ta prochaine re-analyse de modèles (toutes les {n} évaluations).',
  'lp.sq.eyebrow': 'Requêtes de recherche optimisées',
  'lp.sq.launch': 'Lancer la recherche',
  'lp.sq.loading': 'Leadscraper calcule les propositions…',
  'lp.sq.lockedBody':
    'Dès que tu auras évalué {n} Leads, Leadscraper proposera 3–5 requêtes de recherche, structurées comme tes saisies, avec probabilité de correspondance et justification courte.',
  'lp.sq.lockedTitle': 'Leadscraper prépare des propositions concrètes',
  'lp.sq.mockA.contact': 'Direction générale',
  'lp.sq.mockA.rationale':
    'Exemple de proposition de la façon dont Leadscraper propose des recherches.',
  'lp.sq.mockA.region': 'Bavière',
  'lp.sq.mockA.type': 'Constructeurs de machines PME',
  'lp.sq.mockB.rationale':
    'Exemple de proposition de la façon dont Leadscraper propose des recherches.',
  'lp.sq.mockB.region': 'DACH',
  'lp.sq.mockB.type': 'Planificateurs CVC secteur hospitalier',
  'lp.sq.tier.hypothesis': 'Hypothèse test',
  'lp.sq.tier.solid': 'Solide',
  'lp.sq.tier.strong': 'Fort',
  'lp.sq.tier.veryStrong': 'Très fort',
  'lp.tone.drop': 'FORT REJET',
  'lp.tone.keep': 'FORT KEEP',
  'lp.tone.softDrop': 'LÉGER REJET',
  'lp.tone.softKeep': 'LÉGER KEEP',

  'lt.badge.soft': 'possible',
  'lt.dashHint1': 'Dans le tableau de bord tu trouveras un indice à ce sujet (symbole',
  'lt.dashHint2': 'à côté du statut).',
  'lt.exp.btn': 'Exporter',
  'lt.exp.csvHint': '.csv (séparé par des virgules)',
  'lt.exp.fail': "Échec de l'export : {err}",
  'lt.exp.ing': 'Export en cours…',
  'lt.exp.noRows': "Aucun lead trouvé pour l'export.",
  'lt.exp.success': '{n} lignes exportées au format {fmt}.',
  'lt.exp.tipNoLeads': 'Seuls les leads avec des contacts ou un plan terminé sont exportables',
  'lt.exp.tipReady': 'Exporter {n} leads',
  'lt.exp.tipWrongFilter':
    'Seuls les leads qui correspondent peuvent être exportés. Passez au filtre « Bon ».',
  'lt.exp.toastNoLeads':
    "Seuls les leads avec des contacts ou un plan d'acquisition terminé sont exportables.",
  'lt.exp.unknownErr': 'Erreur inconnue',
  'lt.expH.city': 'Localisation',
  'lt.expH.company': 'Entreprise',
  'lt.expH.companyEmail': 'E-mail entreprise',
  'lt.expH.companyPhone': 'Téléphone entreprise',
  'lt.expH.contact': 'Contact',
  'lt.expH.direct': 'direct',
  'lt.expH.email': 'E-mail',
  'lt.expH.emailSource': 'Source e-mail',
  'lt.expH.guessed': 'supposé ({n}%)',
  'lt.expH.profile': 'Audience',
  'lt.expH.role': 'Fonction',
  'lt.expH.sector': 'Secteur',
  'lt.feedbackFail': "Le feedback n'a pas pu être sauvegardé : essayez à nouveau.",
  'lt.naceF.A': 'Agriculture, sylviculture et pêche',
  'lt.payoff.avoided': 'Le dossier évite désormais :',
  'lt.payoff.flowsIn': 'Alimente la prochaine analyse.',
  'lt.naceF.B': 'Industries extractives',
  'lt.naceF.C': 'Industrie manufacturière',
  'lt.naceF.D': "Production et distribution d'électricité, de gaz",
  'lt.naceF.E': "Production et distribution d'eau ; assainissement, gestion des déchets",
  'lt.naceF.F': 'Construction',
  'lt.naceF.G': "Commerce ; réparation d'automobiles et de motocycles",
  'lt.naceF.H': 'Transports et entreposage',
  'lt.naceF.I': 'Hébergement et restauration',
  'lt.naceF.J': 'Information et communication',
  'lt.naceF.K': "Activités financières et d'assurance",
  'lt.naceF.L': 'Activités immobilières',
  'lt.naceF.M': 'Activités spécialisées, scientifiques et techniques',
  'lt.naceF.N': 'Activités de services administratifs et de soutien',
  'lt.naceF.O': 'Administration publique, défense ; sécurité sociale',
  'lt.naceF.P': 'Enseignement',
  'lt.naceF.Q': 'Santé humaine et action sociale',
  'lt.naceF.R': 'Arts, spectacles et activités récréatives',
  'lt.naceF.S': 'Autres activités de services',
  'lt.naceF.T': 'Ménages privés',
  'lt.naceF.U': 'Organisations et organismes extraterritoriaux',
  'lt.naceS.A': 'Agriculture/Forêt',
  'lt.naceS.B': 'Industries extractives',
  'lt.naceS.C': 'Industrie manuf.',
  'lt.naceS.D': 'Énergie',
  'lt.naceS.E': 'Eau/Déchets',
  'lt.naceS.F': 'Construction',
  'lt.naceS.G': 'Commerce',
  'lt.naceS.H': 'Transport/Entrepos.',
  'lt.naceS.I': 'Hébergement/Rest.',
  'lt.naceS.J': 'IT/Médias',
  'lt.naceS.K': 'Finance/Assur.',
  'lt.naceS.L': 'Immobilier',
  'lt.naceS.M': 'Services prof.',
  'lt.naceS.N': 'Autres services',
  'lt.naceS.O': 'Admin. publique',
  'lt.naceS.P': 'Enseignement',
  'lt.naceS.Q': 'Santé',
  'lt.naceS.R': 'Arts/Spectacles',
  'lt.naceS.S': 'Autres services',
  'lt.naceS.T': 'Ménages privés',
  'lt.naceS.U': 'Extraterritorial',
  'lt.next.title': 'Prochaines étapes',
  'lt.next.verifyContacts': 'Vérifier les contacts',
  'lt.next.verifyingContacts': 'Vérification des contacts …',
  'lt.next.contactsVerified': '{n} contacts vérifiés',
  'lt.next.contactVerified': 'Contact vérifié',
  'lt.next.openPlan': 'Ouvrir le plan',
  'lt.next.generatingPlan': "Génération du plan d'acquisition …",
  'lt.next.credit': '1 crédit',
  'lt.next.retry': 'Réessayer',
  'lt.next.verifyFirst': "Vérifiez d'abord les contacts",
  'lt.next.failedHint': 'La dernière tentative a échoué : vous pouvez réessayer.',
  'lt.profileLeads': 'Leads · {name}',
  'lt.profileSub': '{n} leads · toutes les requêtes de cette audience arrivent ici',
  'lt.profileSubOne': '1 lead · toutes les requêtes de cette audience arrivent ici',
  'lt.queryClear': 'Lever le filtre',
  'lt.queryLabel': 'Filtré sur Query :',
  'lt.resetToast': 'Évaluation pour {c} réinitialisée',
  'lt.ring.match': 'Match {pct}%',
  'lt.ring.rejected': 'Rejeté, compté comme 0',
  'lt.rm.cancel': 'Annuler',
  'lt.rm.header': 'Rejeter le lead',
  'lt.rm.noteOptional': 'Note pour Leadscraper (optionnel)',
  'lt.rm.noteRequired': 'Veuillez décrire brièvement (obligatoire)',
  'lt.rm.placeholderOpt':
    "Qu'est-ce que Leadscraper a manqué ou mal évalué ? (Plus c'est précis, mieux le système apprend.)",
  'lt.rm.placeholderReq': 'Ex. « Concurrent : vend une solution similaire »',
  'lt.rm.sub': 'Dis-nous pourquoi : Leadscraper apprend et livrera mieux la prochaine fois.',
  'lt.rm.submit': 'Rejeter le lead',
  'lt.rr.already_known': 'Déjà connu',
  'lt.rr.already_known.hint': "Déjà dans le CRM ou déjà contacté (pas de signal d'apprentissage)",
  'lt.rr.bad_data': 'Données incorrectes',
  'lt.rr.bad_data.hint': "L'adresse, le nom ou les informations de contact sont incorrects",
  'lt.rr.no_buying_signal': 'Pas de besoin identifiable',
  'lt.rr.no_buying_signal.hint':
    "Pas d'événements déclencheurs, pas de postes ouverts, pas de signal de croissance",
  'lt.rr.not_operator': 'Pas un opérateur',
  'lt.rr.not_operator.hint':
    "Agence, intermédiaire ou promoteur au lieu d'un prestataire opérationnel",
  'lt.rr.other': 'Autre raison',
  'lt.rr.other.hint': 'Écris brièvement pourquoi ci-dessous (texte libre)',
  'lt.rr.wrong_industry': 'Mauvais secteur',
  'lt.rr.wrong_industry.hint': "Leadscraper a mal identifié le domaine d'activité",
  'lt.rr.wrong_ownership': 'Mauvaise structure de propriété',
  'lt.rr.wrong_ownership.hint':
    "Filiale de groupe au lieu d'entreprise familiale, mauvaise forme juridique, etc.",
  'lt.rr.wrong_region': 'Mauvaise localisation',
  'lt.rr.wrong_region.hint': 'Siège / région ne correspond pas à la recherche',
  'lt.rr.wrong_role': 'Mauvais contact',
  'lt.rr.wrong_role.hint': "La personne ou le rôle n'est pas le décideur",
  'lt.rr.wrong_size': "Mauvaise taille d'entreprise",
  'lt.rr.wrong_size.hint': "Trop petite, trop grande ou groupe au lieu d'une PME",
  'lt.tip.accepted': 'Accepté, clic pour annuler',
  'lt.tip.contacts': 'Afficher {n} contacts',
  'lt.tip.dragCol': 'Glisser la largeur de colonne',
  'lt.tip.openCompany': "Ouvrir les détails de l'entreprise",
  'lt.tip.openLead': 'Ouvrir les détails du lead',
  'lt.tip.rejected': 'Rejeté, clic pour annuler',
  'lt.tip.softKeep': 'Potentiellement pertinent : Leadscraper a une incertitude ici, voir détail',
  'lt.tip.unseen': 'Pas encore vu',
  // AddCompanyManualModal — ajout manuel via URL
  'lt.manual.modal.eyebrow': 'Pipeline · manuel',
  'lt.manual.modal.title': 'Ajouter une entreprise',
  'lt.manual.modal.desc':
    "Leadscraper vérifie le site web et extrait les données de base de l'entreprise. Le lead arrive ensuite dans {phase}, d'où vous pouvez générer des contacts + un plan d'acquisition.",
  'lt.manual.modal.phase': '« Entreprise ajoutée »',
  'lt.manual.modal.websiteLabel': 'Site web',
  'lt.manual.modal.placeholder': 'p. ex. heuerlogistics.de',
  'lt.manual.modal.hint':
    "Nous essayons d'atteindre le site web. Aucun crédit n'est utilisé en cas d'échec.",
  'lt.manual.modal.cancel': 'Annuler',
  'lt.manual.modal.close': 'Fermer',
  'lt.manual.modal.submit': 'Ajouter',
  'lt.manual.modal.submitting': 'Ajout en cours …',
  'lt.manual.modal.creditOne': '{n} crédit',
  'lt.manual.modal.creditMany': '{n} crédits',
  'lt.manual.modal.errEmpty': 'Veuillez saisir un site web.',
  'lt.manual.modal.errInvalid':
    'Cela ne ressemble pas à un site web valide (p. ex. heuerlogistics.de).',

  'mem.cancel': 'Annuler',
  'mem.editHint': 'Leadscraper utilisera cette affirmation à partir du prochain tri.',
  'mem.editKicker': "Corriger l'hypothèse apprise",
  'mem.editTitle': 'Comment Leadscraper doit-il apprendre cela ?',
  'mem.param.contact': 'Contact',
  'mem.param.extras': 'Extras',
  'mem.param.leads': 'Leads',
  'mem.param.location': 'Localisation',
  'mem.param.sector': 'Secteur',
  'mem.profile': 'Profil',
  'mem.save': "Sauvegarder l'hypothèse",
  'mem.screenLabel': 'Memory',
  'mem.screenLabelEmpty': 'Memory · vide',
  'mem.toast.confirmed': 'Hypothèse confirmée.',
  'mem.toast.corrected': 'Correction sauvegardée.',
  'mem.toast.forgotten': 'Hypothèse oubliée.',
  'mem.today': "Aujourd'hui",

  'mob.abo': 'Abonnement & Credits',
  'mob.acct.aria': 'Mon compte',
  'mob.active': 'Actif',
  'mob.back': '← Retour',
  'mob.changePassword': 'Changer le mot de passe',
  'mob.changePlan': 'Changer de plan',
  'mob.detail.contacts': 'Contacts ({n})',
  'mob.detail.fits': '✓ Correspond',
  'mob.detail.label.email': 'E-mail',
  'mob.detail.label.phone': 'Téléphone',
  'mob.detail.label.website': 'Site web',
  'mob.detail.notFitting': '✗ Ne correspond pas',
  'mob.detail.rejected': '✗ Rejeté',
  'mob.detail.section.company': 'Entreprise',
  'mob.fb.fits': '✓ Correspond',
  'mob.fb.rejected': '✗ Rejeté',
  'mob.home.activeProfile': 'Audience active',
  'mob.home.cta.newSearch': 'Lancer une nouvelle recherche',
  'mob.home.emptyHint': "Lancez une nouvelle recherche ou changez d'audience.",
  'mob.home.newLeads': 'Nouveaux leads',
  'mob.home.stat.fits': 'Correspond',
  'mob.home.stat.leads': 'Leads',
  'mob.home.stat.matchRate': 'Taux de correspondance',
  'mob.home.viewAll': 'Tout voir →',
  'mob.leads.cta.newSearch': 'Lancer une nouvelle recherche',
  'mob.leads.filter.all': 'Tous',
  'mob.leads.filter.fits': 'Correspond',
  'mob.leads.filter.open': 'Ouvert',
  'mob.leads.filter.rejected': 'Rejeté',
  'mob.leads.new': '＋ Nouveau',
  'mob.leads.title': 'Leads',
  'mob.logout': 'Se déconnecter',
  'mob.logoutConfirm': 'Vraiment se déconnecter ?',
  'mob.more.help': 'Aide & Contact',
  'mob.more.invoices': 'Factures',
  'mob.more.label.email': 'E-mail',
  'mob.more.plan.monthly': 'Abonnement mensuel',
  'mob.more.plan.trial': 'Essai',
  'mob.more.section.account': 'Mon compte',
  'mob.more.section.help': 'Aide & App',
  'mob.more.title': 'Plus',
  'mob.more.toDesktop': 'Passer au bureau',
  'mob.more.toDesktop.value': 'Fonctionnalités complètes',
  'mob.nav.account': 'Compte',
  'mob.nav.home': 'Accueil',
  'mob.nav.leads': 'Leads',
  'mob.nav.profile': 'Audiences',
  'mob.onDesktop': 'Sur ordinateur',
  'mob.profile.active': 'Actif',
  'mob.profile.leadsCount': '{n} leads',
  'mob.profile.newCount': '{n} nouveaux',
  'mob.profile.stat.match': 'Correspondance',
  'mob.profile.switchTo': 'Passer à',
  'mob.profile.title': 'Audiences',
  'mob.queryPlaceholder': 'ex. boulangeries, comptables, magasins de chaussures',
  'mob.search.askWho': 'Qui recherchez-vous ?',
  'mob.search.cancel': 'Annuler',
  'mob.search.profileLabel': 'Audience : {name}',
  'mob.search.region': 'Région (optionnel)',
  'mob.search.regionPlaceholder': 'ex. Île-de-France, PACA, Bretagne',
  'mob.search.start': 'Lancer la recherche',
  'mob.search.title': 'Nouvelle recherche',
  'mob.toast.accepted': '✓ Marqué comme correspondant',
  'mob.toast.rejected': '✗ Rejeté',
  'mob.toast.runStarted': 'Recherche lancée, arrivée dans ~2 min',
  'mob.trialLeads': "Leads d'essai restants",
  'mob.upgrade': 'Passer à Pro',
  'mob.upgradeHint': 'Plus de leads + planification',
  'mob.wizardHint':
    "Créez votre premier profil sur un ordinateur : l'assistant n'est pas encore disponible sur mobile.",

  'mobile.empty.noContactData': 'Aucune donnée de contact disponible.',
  'mobile.empty.noOpenLeads': 'Aucun Lead en attente.',
  'mobile.empty.noProfileSelected': 'Aucune audience sélectionnée.',
  'mobile.empty.noProfileShort': 'Aucune audience.',
  'mobile.empty.nothingFound': 'Rien trouvé.',
  'mobile.note.label': 'Note :',
  'mobile.note.scheduleDesktop':
    "Vous modifiez les plannings et la mémoire d'audience sur ordinateur.",
  'mobile.tip.label': 'Conseil :',
  'mobile.tip.profilesDesktop':
    'Vous créez plusieurs audiences (p. ex. par secteur ou région) sur ordinateur.',

  'ms.aud.computingBody':
    'Dans quelques secondes, Leadscraper décrira ici votre audience cible avec ses propres mots.',
  'ms.aud.computingEyebrow': 'Leadscraper analyse vos évaluations',
  'ms.aud.computingTitle': 'Reconnaissance de modèles en cours…',
  'ms.aud.derivedFrom': 'Dérivé de vos {n} évaluations',
  'ms.aud.eyebrowS1': 'Première évaluation de Leadscraper',
  'ms.aud.eyebrowS2': 'Évaluation actuelle de Leadscraper',
  'ms.aud.fallbackBody':
    'Dès que la re-analyse sera terminée (dans quelques secondes), une description concrète de votre audience cible apparaîtra ici.',
  'ms.aud.fallbackEyebrow': 'Première évaluation de Leadscraper',
  'ms.aud.fallbackTitle':
    "Leadscraper met actuellement à jour l'évaluation avec vos {n} dernières évaluations.",
  'ms.aud.learnedLabel': 'Appris concrètement',
  'ms.aud.lockedEyebrow': 'Audience dans les mots de Leadscraper',
  'ms.aud.lockedMock':
    'Vous recherchez de petits opérateurs en NRW avec un recrutement actif, contacts niveau DG, entreprises familiales avec une tendance claire secteur construction mécanique.',
  'ms.aud.lockedPill': 'à partir de {n} évaluations',
  'ms.aud.nextReanalysis': ' · Prochaine re-analyse à {n}',
  'ms.aud.recomputeEyebrow': 'Leadscraper met à jour son évaluation',
  'ms.aud.recomputeTitle': "L'évaluation est recalculée avec vos dernières évaluations…",
  'ms.aud.trainS1':
    'Continuez à entraîner le scraper et vous obtiendrez **des résultats vraiment excellents** : chaque évaluation rend Leadscraper plus précis.',
  'ms.aud.trainS2':
    "Continuez à entraîner Leadscraper : **chaque évaluation affine les recherches** qui s'exécutent désormais automatiquement pour vous.",
  'ms.card.label': 'Statut Leadscraper',
  'ms.card.ratings': '{n} / {threshold} évaluations',
  'ms.card.s2active': '{n} évaluations · actif dans le raisonnement',
  'ms.card.s2reanalysis': '{n} évaluations · en cours de réanalyse',
  'ms.cv.age': "Âge de l'entreprise : {rule}",
  'ms.cv.bizModel': 'Modèle économique : {rule}',
  'ms.cv.buyingSignals': "Signaux d'achat : {rule}",
  'ms.cv.domainBlock': 'Exclusion : {rule}',
  'ms.cv.geo': 'Région : {rule}',
  'ms.cv.industry': 'Secteur : {rule}',
  'ms.cv.ownership': 'Propriété : {rule}',
  'ms.cv.role': 'Contact : {rule}',
  'ms.cv.size': 'Taille : {rule}',
  'ms.cv.techStack': 'Stack technique : {rule}',
  'ms.donut.match': 'correspond',
  'ms.donut.matchRate': 'Taux de correspondance',
  'ms.donut.noMatch': 'ne correspond pas',
  'ms.donut.ratings': 'Évaluations',
  'ms.donut.title': 'État des évaluations',
  'ms.error': 'Erreur',
  'ms.msg.s0': "Apprend avec vous · {n}/{threshold} jusqu'à aperçu",
  'ms.msg.s1': "Première impression · {n}/{threshold} jusqu'à actif",
  'ms.msg.s2active': 'Personnalisé activement · {n} évaluations',
  'ms.msg.s2reanalysis': 'En cours de réanalyse · {n}',
  'ms.stage0.eyebrow': 'Apprend avec vous',
  'ms.stage1.eyebrow': 'Première impression',
  'ms.stage2.eyebrow': 'Personnalisé activement',

  'nace.A': 'Agriculture, sylviculture et pêche',
  'nace.B': 'Industries extractives',
  'nace.C': 'Industrie manufacturière',
  'nace.D': "Production et distribution d'électricité, de gaz, de vapeur et d'air conditionné",
  'nace.E': "Production et distribution d'eau ; assainissement, gestion des déchets et dépollution",
  'nace.F': 'Construction',
  'nace.G': "Commerce ; réparation d'automobiles et de motocycles",
  'nace.H': 'Transports et entreposage',
  'nace.I': 'Hébergement et restauration',
  'nace.J': 'Information et communication',
  'nace.K': "Activités financières et d'assurance",
  'nace.L': 'Activités immobilières',
  'nace.M': 'Activités spécialisées, scientifiques et techniques',
  'nace.N': 'Activités de services administratifs et de soutien',
  'nace.O': 'Administration publique et défense ; sécurité sociale obligatoire',
  'nace.P': 'Enseignement',
  'nace.Q': 'Santé humaine et action sociale',
  'nace.R': 'Arts, spectacles et activités récréatives',
  'nace.S': 'Autres activités de services',
  'nace.T': "Activités des ménages en tant qu'employeurs",
  'nace.U': 'Activités des organismes extraterritoriaux',

  'naceShort.A': 'Agriculture',
  'naceShort.B': 'Extractives',
  'naceShort.C': 'Industrie',
  'naceShort.D': 'Énergie',
  'naceShort.E': 'Eau/Déchets',
  'naceShort.F': 'Construction',
  'naceShort.G': 'Commerce',
  'naceShort.H': 'Transport',
  'naceShort.I': 'Restauration',
  'naceShort.J': 'IT/Médias',
  'naceShort.K': 'Finance/Assur.',
  'naceShort.L': 'Immobilier',
  'naceShort.M': 'Services spéc.',
  'naceShort.N': 'Serv. support',
  'naceShort.O': 'Admin. publique',
  'naceShort.P': 'Enseignement',
  'naceShort.Q': 'Santé',
  'naceShort.R': 'Arts/Loisirs',
  'naceShort.S': 'Autres serv.',
  'naceShort.T': 'Ménages',
  'naceShort.U': 'Extraterritorial',

  'nav.activeProfile': 'Audience active',
  'nav.apiStatus.checking': "Vérification du statut de l'API…",
  'nav.apiStatus.down': 'API inaccessible : veuillez recharger la page',
  'nav.apiStatus.ok': 'API accessible',
  'nav.apiStatus.slow': "L'API répond lentement",
  'nav.buyLeads': 'Acheter des Leads maintenant',
  'nav.cortex': 'Audience',
  'nav.credits': 'Credits disponibles',
  'nav.credits.available': 'Disponible',
  'nav.credits.label': 'Solde du compte',
  'nav.credits.remaining': 'Restant',
  'nav.credits.total': 'Total',
  'nav.credits.upgrade': 'Upgrade',
  'nav.dashboard': 'Tableau de bord',
  'nav.deleteProfile': "Supprimer l'audience",
  'nav.deleteProfileBody':
    'Tous les leads, évaluations et schémas appris pour « {name} » seront définitivement supprimés. Cette action est irréversible.',
  'nav.deleteProfileBusy': 'Suppression en cours…',
  'nav.deleteProfileCta': 'Supprimer définitivement',
  'nav.deleteProfileError': "L'audience n'a pas pu être supprimée. Veuillez réessayer.",
  'nav.deleteProfileInFlight':
    'Une recherche est en cours pour cette audience. Veuillez attendre la fin.',
  'nav.deleteProfileSuccess': 'Audience supprimée.',
  'nav.deleteProfileTitle': "Supprimer l'audience ?",
  'nav.feedbacks': 'Feedbacks',
  'nav.leads': 'Leads',
  'nav.matchRate': 'Taux de correspondance',
  'nav.rated': 'évalués',
  'nav.open': 'ouverts',
  'nav.rateNudge.title': 'Aller aux Leads pas encore évalués',
  'nav.allRated': 'Tous évalués',
  'nav.newProfile': 'Créer une audience',
  'nav.onboardingRequired': "Veuillez d'abord terminer les 3 étapes d'intégration.",
  'nav.openSettings': 'Ouvrir les paramètres et apprentissages de "{name}"',
  'nav.profileName': "Nom de l'audience",
  'nav.profileNameP': 'ex. Prestataires IT DACH',
  'nav.renameProfile': "Renommer l'audience",
  'nav.renameProfileSub': 'Choisissez un nouveau nom pour cette audience.',
  'nav.runs.footer':
    'Cliquez sur une audience pour voir la progression. Vous pouvez continuer à travailler.',
  'nav.runs.leadsReady': '{n} Lead{s} prêt{s}',
  'nav.runs.many': '{n} recherches en cours',
  'nav.runs.one': '1 recherche en cours',
  'nav.runs.title': 'Recherches en cours',
  'nav.startSubscription': "Démarrer l'abonnement",
  'nav.switchProfiles': "Changer d'audience",

  'notif.act.edge': 'Voir les cas limites',
  'notif.act.pattern': 'Confirmer dans Leadscraper',
  'notif.act.review': 'Voir les Leads',
  'notif.dismiss': 'Masquer',
  'notif.edge.body':
    '{n} Leads incertains pour {profile} : votre avis améliore Leadscraper le plus efficacement.',
  'notif.edge.title': 'Les cas limites ont besoin de votre avis',
  'notif.empty.sub': 'Leadscraper apprend.',
  'notif.empty.title': 'Tout va bien.',
  'notif.kind.edge': 'Cas limite',
  'notif.kind.pattern': 'Modèle',
  'notif.kind.review': 'Évaluation',
  'notif.pattern.back': 'Retour',
  'notif.pattern.badge': 'Modèle appris',
  'notif.pattern.confirmedLabel': 'Pattern confirmé.',
  'notif.pattern.needsConfirm': 'Est-ce correct ?',
  'notif.pattern.no': 'Non, rejeter',
  'notif.pattern.rejectedLabel': 'Pattern rejeté.',
  'notif.pattern.saveAndClose': 'Enregistrer',
  'notif.pattern.stage2': 'Enregistré',
  'notif.pattern.title': 'Modèle détecté',
  'notif.pattern.whyLabel': 'Pourquoi ? (optionnel)',
  'notif.pattern.whyPlaceholder': 'Aide Leadscraper à apprendre la nuance, mais pas obligatoire.',
  'notif.pattern.yes': 'Oui, correct',
  'notif.review.body': 'Vous avez encore {n} Leads non évalués.',
  'notif.review.cta': 'Évaluer maintenant',
  'notif.review.title': 'Évaluer les nouveaux Leads',
  'notif.sub': 'Conseils pour que Leadscraper devienne plus précis.',
  'notif.title': 'Notifications',

  'np.abort': 'Annuler',
  'np.audience': 'Décrire la cible',
  'np.audienceHint':
    "Plus c'est précis, meilleure sera la première analyse. Tu pourras toujours ajuster cela plus tard.",
  'np.audienceHintLong':
    "Écris-le comme tu l'expliquerais à un nouveau commercial. Leadscraper utilise ça comme base pour l'évaluation, et apprend davantage de chaque feedback.",
  'np.audienceLabel': 'Description de la cible',
  'np.audienceP':
    'Exemple : Nous voulons convaincre des cabinets comptables de taille moyenne avec notre solution de recrutement. Objectif : un premier échange avec la direction.',
  'np.back': 'Retour',
  'np.briefingHelp.q1': 'Quel est votre objectif avec cette cible ?',
  'np.briefingHelp.q2': 'Que proposez-vous ?',
  'np.briefingHelp.q3': 'Pourquoi votre offre est-elle pertinente pour cette cible ?',
  'np.briefingHelp.q4': 'Quelle est votre proposition de valeur la plus forte ?',
  'np.briefingHelp.q5': 'Quels problèmes résolvez-vous ?',
  'np.briefingHelp.q6': 'Qui souhaitez-vous contacter en premier ?',
  'np.briefingHelp.q7': 'Quel canal fonctionne pour vous : e-mail, téléphone, LinkedIn ?',
  'np.briefingHelp.q8':
    'Quelle devrait être la prochaine étape : réponse, rendez-vous, démo, proposition ?',
  'np.briefingHelp.q9': "Que faut-il éviter dans l'approche ?",
  'np.briefingHelpFooter':
    'Ce ne sont pas des champs obligatoires, juste une orientation pour le texte libre.',
  'np.briefingHelpTitle': 'Utile pour Leadscraper',
  'np.coldStart': 'Démarrage à froid, aucun paramètre de base',
  'np.coldStartDesc':
    'Le profil démarre complètement vide. Après ~20 feedbacks, les premières analyses claires apparaîtront dans Leadscraper.',
  'np.companySize': "Taille d'entreprise",
  'np.companySizeP': 'ex. 50–250 employés',
  'np.continue': 'Continuer',
  'np.create': "Créer l'audience",
  'np.created': 'Audience créée. Leadscraper est prêt.',
  'np.creating': 'Création en cours…',
  'np.header': 'Nouvelle audience',
  'np.headline': 'Définir la cible',
  'np.suggHeading': 'Suggestions pour votre cible',
  'np.suggHint':
    'Un clic applique la suggestion : vous pouvez basculer entre elles, saisir votre propre texte ou créer directement.',
  'np.draftWriting': 'Leadscraper rédige votre briefing …',
  'np.draftErrorLabel': 'Note :',
  'np.draftErrorFallback':
    'Impossible de générer le brouillon du briefing : vous pouvez continuer à écrire manuellement.',
  'np.industry': 'Secteur',
  'np.industryP': 'ex. Emballage, emballage pliant',
  'np.name': "Nom de l'audience",
  'np.nameP': "ex. Fabricants d'emballages pliants NRW",
  'np.notes': 'Autres indications',
  'np.notesP': 'Exclusions, types de clients, mots-signaux…',
  'np.nothingYet': '· rien de prédéfini. Leadscraper sera façonné par ton feedback.',
  'np.optional': 'Optionnel',
  'np.region': 'Région / État',
  'np.regionP': "ex. NRW, DACH, toute l'Allemagne",
  'np.skip': 'Passer',
  'np.step1Sub':
    'Donne un nom clair à ton profil. Leadscraper utilise cette description comme point de départ avant que ton feedback affine le modèle.',
  'np.step1Title': 'Qui ou quoi cherches-tu ?',
  'np.step2Sub':
    'Optionnel : Leadscraper utilise ces informations comme base. Le profil apprend au fur et à mesure que tu évalues les Leads.',
  'np.step2Title': 'Premiers paramètres',
  'np.stepOf': 'Étape {n} sur 2',
  'np.summaryTitle': 'Leadscraper démarre avec',
  'np.title': 'Créer une audience',
  'np.whatHappens': 'Que se passe-t-il ensuite ?',
  'np.whatHappensBody':
    "Dans le tableau de bord, tu lances une <b>requête de recherche</b> et définis le secteur, la région et la taille. Leadscraper trouve les entreprises et contacts pertinents et construit un plan d'acquisition par Lead à partir de ce briefing.",

  'offer.beta.pricing.intro': 'Invitation Beta · 55 % de remise le 1er mois',

  'og.beta.cardCta': 'Activer le pack Beta',
  'og.beta.cardFeature.1': '500 Leads / mois au niveau Growth',
  'og.beta.cardFeature.2': "Activation immédiate, pas d'essai",
  'og.beta.cardFeature.3': 'Annulable à tout moment en 1 clic',
  'og.beta.cardFoot': 'Carte requise · paiement sécurisé via Stripe',
  'og.beta.cardName': 'Votre pack Beta',
  'og.beta.feature.1.bold': '500 Leads',
  'og.beta.feature.1.lead': '',
  'og.beta.feature.1.tail': ' par mois, e-mails et numéros de téléphone vérifiés',
  'og.beta.feature.2': 'Ciblage IA en langage naturel',
  'og.beta.feature.3': 'Intégrations CRM + export CSV/Excel',
  'og.beta.feature.4': 'Conforme RGPD · Données en UE',
  'og.beta.feature.5.bold': 'WhatsApp à Janik',
  'og.beta.feature.5.lead': 'Accès direct ',
  'og.beta.feature.5.tail': ' pour vos questions',
  'og.beta.narrativeBody':
    "Nous cherchons {profis} qui utilisent notre système tôt, donnent un retour honnête et participent à l'évolution de Leadscraper. En échange, vous payez {price} pour votre premier mois de notre pack Growth, au lieu de 490 € normalement — ensuite au prix normal, résiliable à tout moment.",
  'og.beta.narrativePrice': 'seulement 220 €',
  'og.beta.narrativeProfis': '30 professionnels de vente actifs',
  'og.beta.narrativeTitle': 'Pourquoi cette offre ?',
  'og.beta.priceNowSuffix': '/ 1er mois',
  'og.beta.priceFootnote': 'ensuite {n} €/mois · résiliable à tout moment',
  'og.beta.priceOld': '{n} € / mois normalement',
  'og.beta.savings': 'Vous économisez {n} € le premier mois',
  'og.cancelAny': 'Annulable à tout moment',
  'og.cta': 'Tester 3 jours gratuitement · {plan}',
  'og.ctaBeta': "Sécuriser l'accès Beta · {price} € / mois",
  'og.ctaPlain': 'Continuer avec {plan}',
  'og.ctaSub':
    "Aucun paiement les 3 premiers jours · Ensuite {price},00 € / mois · {leads} Leads d'essai inclus",
  'og.ctaSubPlain': '{price},00 € / mois · activation immédiate',
  'og.dsgvo': 'Conforme RGPD · Serveurs FR',
  'og.eyebrow.beta': 'Invitation Beta personnelle',
  'og.eyebrow.trial50': '50 Credits offerts',
  'og.hlBanner.trial50.body':
    "Après sélection du plan, vous recevez immédiatement {credits} sur votre compte. Utilisez-les dans les 3 prochains jours, si vous n'annulez pas, vous passez automatiquement au plan choisi.",
  'og.hlBanner.trial50.credits': '{n} Credits',
  'og.hlBanner.trial50.title': 'Comment fonctionne votre essai :',
  'og.later': 'Décider plus tard →',
  'og.leadsIncl': '{n} Leads par mois inclus',
  'og.maiOffer.cta': 'Offre de mai : sécurisez 100 Leads B2B pour 49 €',
  'og.maiOffer.detail': 'Parfait pour découvrir, sans engagement.',
  'og.maiOffer.feature.1': 'E-mails et numéros de téléphone vérifiés',
  'og.maiOffer.feature.2': 'Ciblage IA en langage naturel',
  'og.maiOffer.feature.3': 'Intégrations CRM + export CSV/Excel',
  'og.maiOffer.feature.4': "Conforme RGPD · Données dans l'UE",
  'og.maiOffer.feature.5': 'À partir du mois 2 : 190 €/mois, résiliation en 1 clic',
  'og.maiOffer.leadsNum': '100',
  'og.maiOffer.leadsUnit': 'Leads / mois',
  'og.maiOffer.planName': 'Basic',
  'og.maiOffer.price': '49 €',
  'og.maiOffer.priceNote': '0,49 € au lieu de 1,90 € par Lead, uniquement ce mois-ci.',
  'og.maiOffer.priceOriginal': 'Au lieu de 190 € / mois',
  'og.maiOffer.priceSuffix': '/ mois',
  'og.moneyBack': 'Remboursement 14 jours',
  'og.perMonth': '€ / mois',
  'og.plan': 'Abonnement',
  'og.planBadge.recommended': 'Recommandé',
  'og.planCta.loading': 'Vers le paiement…',
  'og.planCta.pick.basic': 'Choisir Basic',
  'og.planCta.pick.growth': 'Choisir Growth',
  'og.planCta.pick.starter': 'Choisir Starter',
  'og.planCta.trial.basic': 'Essai gratuit de 3 jours',
  'og.planCta.trial.growth': 'Essai gratuit de 3 jours',
  'og.planCta.trial.starter': 'Essai gratuit de 3 jours',
  'og.planDetail.basic': 'Pour les petites équipes de vente qui font un suivi ciblé.',
  'og.planDetail.growth': "Pour les équipes qui veulent développer l'outbound.",
  'og.planDetail.starter': 'Meilleur rapport qualité-prix pour les équipes actives.',
  'og.planFeature.basic.1': 'E-mails et numéros de téléphone vérifiés',
  'og.planFeature.basic.2': 'Ciblage IA en langage naturel',
  'og.planFeature.basic.3': 'Intégrations CRM + Export CSV/Excel',
  'og.planFeature.basic.4': "Conforme RGPD · Données dans l'UE",
  'og.planFeature.growth.1': 'Tout de Starter',
  'og.planFeature.growth.2': '5× plus de Leads par mois',
  'og.planFeature.growth.3': "Appel d'onboarding personnalisé",
  'og.planFeature.growth.4': 'Support premium directement avec Janik',
  'og.planFeature.starter.1': 'Tout de Basic',
  'og.planFeature.starter.2': '2,5× plus de Leads par mois',
  'og.planFeature.starter.3': 'File de Leads prioritaire',
  'og.planFeature.starter.4': 'Support e-mail < 4 h',
  'og.planLeadsUnit': 'Leads / mois',
  'og.planPriceNote.basic.default': 'Équivaut à 1,90 € par Lead',
  'og.planPriceNote.basic.trial': 'Ensuite {price}\u00A0€/mois · 100 Credits inclus',
  'og.planPriceNote.growth.default': 'Équivaut à 0,98 € par Lead · Économisez 48 %',
  'og.planPriceNote.growth.trial':
    'Ensuite {price}\u00A0€/mois · 500 Credits inclus · Économisez 48 %',
  'og.planPriceNote.starter.default': 'Équivaut à 1,16 € par Lead · Économisez 39 %',
  'og.planPriceNote.starter.trial':
    'Ensuite {price}\u00A0€/mois · 250 Credits inclus · Économisez 39 %',
  'og.planPriceSuffix.default': '/ mois',
  'og.planPriceSuffix.trial': "/ mois après l'essai",
  'og.planPriceSuffix.trialToday': "aujourd'hui",
  'og.ready': 'Votre compte est prêt',
  'og.recommended': 'Recommandé',
  'og.split.badge.start': 'Parfait pour commencer',
  'og.split.rating.note': '· Retours utilisateurs excellents',
  'og.split.rating.score': '4,8 / 5,0',
  'og.split.trust.cancel': 'Résiliation en 1 clic',
  'og.split.trust.gdpr': 'Conforme RGPD',
  'og.step.activateBeta': 'Activer le pack Beta',
  'og.step.created': 'Compte créé',
  'og.step.pickPlan': 'Choisir un plan',
  'og.step.start': 'Commencer',
  'og.step.startTrial': 'Tester 3 jours gratuits',
  'og.sub1': 'Choisissez votre abonnement pour tester Leadscraper',
  'og.sub1b': '3 jours gratuitement',
  'og.sub2':
    "Aucun paiement maintenant : vous pouvez annuler à tout moment pendant la période d'essai.",
  'og.subtitle.beta':
    "En tant que testeur Beta, vous obtenez notre pack le plus puissant (500 Leads par mois) à un prix spécial : votre premier mois à 220 € au lieu de 490 €. Pas d'engagement minimum, résiliable à tout moment.",
  'og.subtitle.default':
    'Trois plans, même qualité de données. Choisissez combien de Leads vous avez besoin par mois. Vous pouvez changer et annuler à tout moment en un clic.',
  'og.subtitle.mai':
    'Économisez 74 % le premier mois : ensuite, changez ou résiliez en 1 clic à tout moment.',
  'og.subtitle.trial50': "50 Leads offerts, 3 jours d'essai, résiliable à tout moment.",
  'og.title.beta.grad': 'sélectionné',
  'og.title.beta.lead': 'Vous avez été ',
  'og.title.beta.tail': ' pour la Beta.',
  'og.title.default.grad': 'commencez en 60 secondes',
  'og.title.default.lead': 'Choisissez votre plan et ',
  'og.title.default.tail': '.',
  'og.title.mai.grad': 'avantage concurrentiel déloyal',
  'og.title.mai.lead': 'Votre ',
  'og.title.mai.tail': ' commence ici.',
  'og.title.trial50.grad': 'maintenant offerts',
  'og.title.trial50.lead': "50 Leads B2B d'une valeur de 100 €, ",
  'og.title.trial50.tail': '.',
  'og.trial': 'Tester 3 jours gratuitement',
  'og.trial50v2.cta': 'Sécuriser 50 Credits gratuits',
  'og.trial50v2.detail': 'Assez de Credits pour tester complètement Leadscraper.',
  'og.trial50v2.feature.1': 'E-mails et numéros de téléphone vérifiés',
  'og.trial50v2.feature.2': 'Ciblage IA en langage naturel',
  'og.trial50v2.feature.3': 'Intégrations CRM + Export CSV/Excel',
  'og.trial50v2.feature.4': "Conforme RGPD · Données dans l'UE",
  'og.trial50v2.feature.5': 'Continue après 3 jours, résiliation en 1 clic',
  'og.trial50v2.leadsNum': '50',
  'og.trial50v2.leadsUnit': 'Leads en 3 jours',
  'og.trial50v2.planName': 'Essai',
  'og.trial50v2.price': 'Gratuit',
  'og.trial50v2.priceNote': 'Se termine après 3 jours ou continue, résiliation en 1 clic.',
  'og.trialIncl': 'incl.',
  'og.trialLeadsN': "{n} Leads d'essai",
  'og.trust.beta.lock.body': 'aucun supplément caché',
  'og.trust.beta.lock.title': 'Prix spécial bêta le 1er mois',
  'og.trust.cancel.body.default': 'Aucune durée minimale',
  'og.trust.cancel.body.trial': "Gratuit pendant l'essai",
  'og.trust.cancel.title.default': 'Résiliation en 1 clic',
  'og.trust.card.body.default': 'Paiement sécurisé via Stripe',
  'og.trust.card.body.trial': 'Débit seulement après 3 jours',
  'og.trust.card.title.default': 'Carte requise',
  'og.trust.card.title.trial': "Carte pour l'activation",
  'og.trust.gdpr.body': "Serveurs dans l'UE · sources publiques uniquement",
  'og.trust.gdpr.title': 'Conforme RGPD',
  'og.welcome': 'Bienvenue, Janik.',

  'onb.step1Done': "Leadscraper connaît maintenant votre offre : voir l'analyse ci-dessous",

  'onb.heroTitle': 'Votre avantage concurrentiel décisif commence ici',

  'onb.heroDesc':
    'En 3 étapes vers vos 10 premiers leads. Leadscraper apprend vraiment à vous connaître et vous livre enfin des leads qui vous correspondent.',

  'onb.helpCardTitle': 'Nouveau sur Leadscraper ?',
  'onb.helpCardDesc':
    "Notre guide de démarrage rapide vous mène en quelques minutes du compte et de l'e-mail à votre première audience cible.",
  'onb.helpCardCta': 'Lire les premiers pas',
  'onb.helpCardDismissAria': "Masquer l'info",

  'onb.stepLabel': 'Étape {n}',

  'onb.b2cLead': 'Leadscraper ne trouve que des entreprises, pas de particuliers.',

  'onb.b2cBody':
    "Votre analyse de site indique que vous vendez à des particuliers. Les suggestions ci-dessous ciblent donc des multiplicateurs B2B (p. ex. promoteurs, syndics) plutôt que les particuliers directement. Sans relais B2B adapté, Leadscraper n'est probablement pas le bon outil pour votre activité.",

  'onb.step2LabelDone': "Première audience définie : Leadscraper l'a enregistrée",

  'onb.step2LabelPending':
    'Définissez votre premier groupe cible : qui voulez-vous exactement comme clients ?',

  'onb.step2Cta': "Créer l'audience",

  'onb.step2Badge': 'Créer maintenant',

  'onb.step2Locked': "En attente de l'étape 1",

  'onb.step3Title': 'Première recherche',

  'onb.step3DescFull':
    'Dès que votre premier profil est prêt, vous lancez la recherche ici directement. Leadscraper trouve 10 leads en 30-90 secondes, exactement le groupe cible que vous venez de créer.',

  'onb.step3Cta': 'Lancer la recherche',

  'onb.step3Badge': 'Lancer maintenant',

  'onb.step3Locked': "En attente de l'étape 2",
  'onb.step1Pending':
    "Parlez brièvement de vous à Leadscraper : un coup d'œil à votre site web suffit pour qu'il comprenne ce que vous vendez",
  'onb.step2Desc':
    "Décrivez vos clients idéaux en 1-2 phrases : ex. 'Experts-comptables en Île-de-France, 3-15 employés, dirigeants'. Leadscraper construit vos requêtes de recherche à partir de cela, apprend de chaque retour, et le profil s'affine au fil des semaines.",
  'onb.step2Title': 'Créez votre première audience',
  'onb.step3Done': 'Première recherche en cours : Leadscraper va vous livrer les premiers 10 Leads',
  'onb.step3Pending': 'Recherche pour votre cible : Leadscraper livre 10 Leads sur mesure',

  'pd.activeSince': 'Actif depuis le {date}',
  'pd.company.analyze': 'Analyser',
  'pd.company.analyzed': 'Leadscraper a analysé ton entreprise (Confiance {n}%).',
  'pd.company.analyzedAt': 'Analysé le {date}',
  'pd.company.analyzing': 'Analyse en cours…',
  'pd.company.cached': 'Profil chargé depuis le cache.',
  'pd.company.cancel': 'Annuler',
  'pd.company.change': 'Modifier',
  'pd.company.confidence': '{n}% sûr',
  'pd.company.costHint':
    'Coût ~$0.015 par analyse. Re-analyse automatique tous les 30 jours si votre site change.',
  'pd.company.error': 'Analyse échouée : veuillez réessayer.',
  'pd.company.inputDesc1':
    "Leadscraper lit ta page d'entreprise et mémorise ce que tu vends, à qui tu vends, et quels arguments tu utilises. Pour chaque Lead, Leadscraper écrit alors ",
  'pd.company.inputDesc2': ' au lieu de simplement "correspond au secteur".',
  'pd.company.inputDescStrong': 'ta stratégie de pitch sur mesure',
  'pd.company.inputTitle': 'Saisis ton propre site web',
  'pd.company.knownTitle': 'Ce que Leadscraper sait de votre entreprise',
  'pd.company.placeholder': 'https://mon-entreprise.fr',
  'pd.company.reanalyze': 'Re-analyser maintenant',
  'pd.company.reanalyzing': 'Re-analyse…',
  'pd.company.sellLabel': 'Ce que vous vendez',
  'pd.company.staleAt': 'Re-analyse due le {date}',
  'pd.company.targetLabel': 'À qui',
  'pd.company.techDetails': 'Détails techniques',
  'pd.company.valueLabel': 'Propositions de valeur',
  'pd.cortex.comingSoon': 'bientôt disponible',
  'pd.cortex.sub': 'Où Leadscraper est le plus précis sur votre ciblage',
  'pd.cortex.title': 'Audience Leadscraper',
  'pd.curve.coldSub': 'Démarchage à froid',
  'pd.curve.currentRate': 'taux de correspondance actuel',
  'pd.curve.highPct':
    "Leadscraper atteint {n}% très précisément : la courbe d'apprentissage se dessine dès que les données d'historique arrivent dans le temps. ",
  'pd.curve.highPctStrong': 'Tout se passe comme prévu.',
  'pd.curve.inWeeks': 'en {n} semaines',
  'pd.curve.learningActive': 'Leadscraper apprend activement',
  'pd.curve.liftLabel': 'Amélioration depuis le début',
  'pd.curve.liftSub': 'taux de correspondance absolu',
  'pd.curve.lockLabel': 'à partir de 50 évaluations',
  'pd.curve.lowPct':
    "Leadscraper rassemble l'historique à partir de tes {n} évaluations. Avec plus de données, la ligne de tendance devient précise.",
  'pd.curve.midPct':
    "À partir de tes {n} évaluations, Leadscraper construit l'historique : la courbe d'apprentissage devient plus visible à chaque nouvelle recherche.",
  'pd.curve.milestone200': '200 évaluations',
  'pd.curve.milestone200Sub': 'modèle stabilisé',
  'pd.curve.milestone50': '50 évaluations',
  'pd.curve.milestone50Sub': 'premiers patterns',
  'pd.curve.mockAxisEnd': '50 évaluations',
  'pd.curve.mockTitle': 'Taux de correspondance sur les 50 dernières évaluations',
  'pd.curve.noData': 'Pas encore assez de données.',
  'pd.curve.start': 'Début',
  'pd.curve.sub': 'Comment le taux de correspondance a évolué avec chaque évaluation.',
  'pd.curve.subShort': 'Comment le taux de correspondance évolue avec chaque évaluation',
  'pd.curve.title': "Courbe d'apprentissage",
  'pd.curve.today': "Aujourd'hui",
  'pd.curve.todaySub': '{n} évaluations',
  'pd.decisions.checked': '{n} candidats vérifiés',
  'pd.decisions.checkedSg': '{n} candidat vérifié',
  'pd.decisions.delivered': '{n} livrés',
  'pd.decisions.hint':
    "Vous voyez un schéma erroné ? Reformulez votre requête : Leadscraper prend toutes ces décisions comme exemples d'apprentissage pour la prochaine exécution, dès que vous confirmez la mémoire de l'audience.",
  'pd.decisions.more': '+ {n} autres …',
  'pd.decisions.rejected': '{n} rejetés',
  'pd.decisions.showAll': 'Afficher tous les rejetés',
  'pd.decisions.showLess': 'Afficher moins',
  'pd.decisions.title': 'Décisions Leadscraper · dernière recherche',
  'pd.empty.cta': 'Vers le tableau de bord',
  'pd.empty.desc1': 'Une audience est ',
  'pd.empty.desc2':
    ": Leadscraper y rassemble tous les apprentissages issus de vos retours. Créez votre première audience dans le tableau de bord. Vous y trouverez ensuite tous les schémas, hypothèses, motifs de rejet et l'historique des exécutions.",
  'pd.empty.descStrong': "un conteneur d'apprentissage",
  'pd.empty.title': 'Aucune audience créée pour le moment',
  'pd.hex.bizModel': "Modèle d'affaires",
  'pd.hex.industry': 'Secteur',
  'pd.hex.location': 'Localisation',
  'pd.hex.ownership': 'Propriété',
  'pd.hex.role': 'Rôle',
  'pd.hex.size': 'Taille',
  'pd.leads.sub': "Aperçu : la liste complète se trouve dans l'onglet Leads.",
  'pd.leads.title': 'Derniers Leads',
  'pd.leads.viewAll': 'Tout voir',
  'pd.learn.calibratedHint':
    'Leadscraper intègre maintenant activement tes modèles dans son raisonnement.',
  'pd.learn.coldStartHint':
    'Évalue plus de Leads pour que Leadscraper commence à reconnaître tes modèles.',
  'pd.learn.earlyHint':
    'À chaque nouvelle évaluation, la reconnaissance de modèles devient plus précise.',
  'pd.learn.emptyDesc1': 'Dès que tu cliques sur ',
  'pd.learn.emptyDesc2': ' ou ',
  'pd.learn.emptyDesc3':
    " dans la liste de Leads, Leadscraper apprend tes préférences et te montre ici ce qu'il en déduit.",
  'pd.learn.emptyFit': 'convient',
  'pd.learn.emptyNotFit': 'ne convient pas',
  'pd.learn.emptyTitle': 'Aucun commentaire donné pour le moment',
  'pd.learn.fits': 'Convient',
  'pd.learn.lastRating': 'Dernière évaluation ',
  'pd.learn.loadError': 'Erreur lors du chargement',
  'pd.learn.loading': "Chargement de l'état d'apprentissage des commentaires…",
  'pd.learn.matchRate': 'Taux de correspondance',
  'pd.learn.matchRateSub': 'convient / évalué',
  'pd.learn.matureMsg':
    'Profil entièrement calibré : Leadscraper traite tes modèles presque comme des règles.',
  'pd.learn.morePrefix': 'Encore ',
  'pd.learn.moreSuffix': " évaluations jusqu'au niveau ",
  'pd.learn.narrativeHide': "Masquer la lettre à l'IA",
  'pd.learn.narrativeShow': "Afficher la lettre à l'IA",
  'pd.learn.narrativeSub':
    "Exactement ce texte sera transmis à l'IA Leadscraper lors de la prochaine recherche, littéralement.",
  'pd.learn.negative': 'négatif',
  'pd.learn.noData': 'Aucune donnée de commentaire disponible.',
  'pd.learn.noRating': 'Aucune évaluation encore',
  'pd.learn.notFits': 'Ne convient pas',
  'pd.learn.positive': 'positif',
  'pd.learn.rated': 'Évalué',
  'pd.learn.ratingStatus': 'État des évaluations',
  'pd.learn.recentTitle': 'Évaluations récentes',
  'pd.learn.stageCali': 'Calibré',
  'pd.learn.stageEarly': 'En apprentissage',
  'pd.learn.stageMature': 'Mature',
  'pd.learn.stageNext': 'niveau suivant',
  'pd.learn.topReasons': 'Raisons de rejet les plus fréquentes',
  'pd.learn.topReasonsDesc1': 'À partir de tes ',
  'pd.learn.topReasonsDesc2':
    ' rejets : Leadscraper mémorise ces modèles et fait descendre les candidats comparables lors de la prochaine recherche.',
  'pd.learn.totalSub': '{n} au total',
  'pd.openLeads': 'Ouvrir les Leads',
  'pd.pat.actions': 'Actions',
  'pd.pat.confirm': 'Confirmer',
  'pd.pat.confirmT': 'Confirmer, adopter comme règle',
  'pd.pat.reject': 'Rejeter',
  'pd.pat.rejectT': 'Rejeter, supprimer le pattern',
  'pd.pat.remove': 'Supprimer',
  'pd.pat.weaken': 'Affaiblir',
  'pd.patterns.medium': 'Moyen, plausible, en observation',
  'pd.patterns.strong': 'Fort, règles fiables',
  'pd.patterns.sub':
    'Vos préférences, extraites de chaque évaluation Correspond / Ne correspond pas.',
  'pd.patterns.title': 'Ce que Leadscraper a appris',
  'pd.patterns.weak': 'Faible, signaux précoces',
  'pd.queries.dailyLegacy': 'Quotidien (legacy)',
  'pd.queries.daysAgo': 'lancé il y a {n} jours',
  'pd.queries.emptySub': 'Dès que vous lancez une recherche, elle apparaît ici, planning inclus.',
  'pd.queries.emptyTitle': 'Aucune recherche lancée pour cette audience pour le moment.',
  'pd.queries.everyH': 'Toutes les {n} h',
  'pd.queries.filterEmpty': 'Aucune requête dans ce filtre.',
  'pd.queries.hourly': 'Horaire',
  'pd.queries.inDays': 'dans {n} jours',
  'pd.queries.inHours': 'dans {n} h',
  'pd.queries.inMinutes': 'dans {n} min.',
  'pd.queries.leadsDelivered': '{n} Leads livrés',
  'pd.queries.manual': 'Ponctuel',
  'pd.queries.monthlyLegacy': 'Mensuel (legacy)',
  'pd.queries.newSearch': 'Démarrer une nouvelle recherche',
  'pd.queries.overdue': 'en retard',
  'pd.queries.paused': 'en pause',
  'pd.queries.showAll': 'Tout afficher',
  'pd.queries.sub': 'Cliquer ouvre les détails, planning et historique de la recherche.',
  'pd.queries.title': 'Requêtes de recherche de cette audience',
  'pd.queries.tomorrow': 'demain',
  'pd.queries.unnamed': 'Recherche sans nom',
  'pd.queries.weeklyLegacy': 'Hebdomadaire (legacy)',
  'pd.ratings': '{n} évaluations',
  'pd.rej.agency_not_operator': "Agence au lieu d'exploitant",
  'pd.rej.consultant_not_operator': "Consultant au lieu d'exploitant",
  'pd.rej.duplicate_previous_session': 'Déjà livré',
  'pd.rej.insufficient_data': 'Données insuffisantes',
  'pd.rej.learned_rejection_pattern': 'Correspond à votre modèle de rejet',
  'pd.rej.low_confidence': 'Trop incertain',
  'pd.rej.outside_radius': 'Hors du rayon',
  'pd.rej.wrong_company_form': 'Mauvaise forme juridique',
  'pd.rej.wrong_industry': 'Mauvais secteur',
  'pd.rej.wrong_region': 'Mauvaise région',
  'pd.rej.wrong_role': 'Mauvais rôle',
  'pd.rej.wrong_size': 'Mauvaise taille',
  'pd.runs': '{n} recherches',
  'pd.screenLabel': "Détails de l'audience",
  'pd.side.accepted': '({n} correspondant)',
  'pd.side.feedbacks': 'Évaluations',
  'pd.side.firstRun': 'Première recherche',
  'pd.side.focus': 'Focus de recherche',
  'pd.side.lastRun': 'Dernière recherche',
  'pd.side.lastRunLeads': '{n} Leads',
  'pd.side.leadsTotal': 'Leads total',
  'pd.side.matchMiss': 'Correspond / Non',
  'pd.side.matchRate': 'Taux de correspondance',
  'pd.side.next1.d':
    'Avec {pct} % de taux de correspondance, 50–100 nouveaux Leads en valent la peine.',
  'pd.side.next1.t': 'Lancer une recherche',
  'pd.side.next2.d': 'Ainsi Leadscraper apprend plus vite.',
  'pd.side.next2.t': 'Vérifier les patterns non confirmés',
  'pd.side.next3.d': "Plus d'évaluations = plus de précision.",
  'pd.side.next3.t': 'Continuer à donner du feedback',
  'pd.side.patterns': 'Patterns',
  'pd.side.patternsSub': '{strong} fort · {medium} moyen',
  'pd.side.reasons': 'Raisons de refus fréquentes',
  'pd.side.recommended': 'Recommandé',
  'pd.side.snapshot': "En un coup d'œil",
  'pd.target.contacts': 'Contacts',
  'pd.target.excluded': 'Exclus',
  'pd.target.industry': 'Secteur',
  'pd.target.leads': 'Leads',
  'pd.target.patterns': 'Modèles',
  'pd.target.queries': 'Requêtes',
  'pd.target.region': 'Région',
  'pd.target.size': 'Taille',
  'pd.target.sub': 'Ce sur quoi Leadscraper se base pour chaque recherche.',
  'pd.target.title': 'Cible',
  'pd.time.daysAgo': 'il y a {n} jours',
  'pd.time.hoursAgo': 'il y a {n} h',
  'pd.time.justNow': "à l'instant",
  'pd.time.minsAgo': 'il y a {n} min',
  'pd.toast.confirmed': 'Pattern confirmé, sera appliqué dès maintenant comme règle fiable',
  'pd.toast.rejected': 'Pattern rejeté',
  'pd.toast.removed': 'Pattern supprimé',
  'pd.toast.weakened': 'Pattern affaibli, sera observé à nouveau',

  'price.afterThen': 'Puis {price} / mois · résiliation à tout moment',
  'price.badge.popular': 'Populaire',
  'price.badge.recommended': 'Recommandé',
  'price.badge.yourPlan': 'Votre plan',
  'price.ctaStartTrial': 'Commencer 3 jours gratuits',
  'price.ctaSwitchPlan': "Changer d'abonnement",
  'price.ctaCurrentPlan': 'Plan actuel',
  'price.ctaTopUp': 'Recharger maintenant',
  'price.heroSub': 'Plus de Leads, exactement quand vous en avez besoin.',
  'price.heroTrial': 'Votre avantage concurrentiel déloyale commence ici.',
  'price.leads': 'Leads',
  'price.monthlyCancelable': 'résiliation mensuelle',
  'price.oneTime': 'unique',
  'price.pack.1000.tag': 'Parfait pour débuter',
  'price.pack.10000.tag': 'Pour une génération continue de leads',
  'price.pack.5000.tag': 'Pour les premières campagnes à grande échelle',
  'price.pack.50000.tag': 'Pour volumes élevés et équipes',
  'price.perLead': '€ / Lead',
  'price.perMonth': '/mois',
  'price.perMonthLong': '/ mois',
  'price.plan.basic.f1': '100 Leads qualifiés par mois',
  'price.plan.basic.f2': '1 audience active',
  'price.plan.basic.f3': 'IA Leadscraper avec apprentissage continu',
  'price.plan.basic.f4': 'Intégrations CRM (HubSpot, Pipedrive, Salesforce…)',
  'price.plan.basic.f5': 'Support par e-mail',
  'price.plan.basic.tag': 'Pour démarrer avec une audience',
  'price.plan.growth.f1': '500 Leads qualifiés par mois',
  'price.plan.growth.f2': 'Audiences illimitées',
  'price.plan.growth.f3': "IA Leadscraper avec Memory d'équipe",
  'price.plan.growth.f4': 'Toutes les intégrations CRM + webhooks',
  'price.plan.growth.f5': 'Account manager dédié',
  'price.plan.growth.f6': 'Accès API',
  'price.plan.growth.tag': 'Pour équipes commerciales en croissance',
  'price.plan.starter.f1': '250 Leads qualifiés par mois',
  'price.plan.starter.f2': '3 audiences actives',
  'price.plan.starter.f3': 'IA Leadscraper avec apprentissage prioritaire',
  'price.plan.starter.f4': 'Toutes les intégrations CRM',
  'price.plan.starter.f5': 'Support prioritaire',
  'price.plan.starter.f6': 'Export en CSV, XLSX, JSON',
  'price.plan.starter.tag': 'Parfait pour commencer',
  'price.selected': 'Choisi :',
  'price.subOneoffDesc':
    "Leads supplémentaires en pack unique, aucune durée, aucun engagement. Les Credits n'expirent pas.",
  'price.subTrialDesc':
    "3 jours d'essai gratuit : avec de vrais Leads, vos propres profils, votre propre Memory Leadscraper. Leads inutiles ? Vous les récupérez, sans questions.",
  'price.tab.afterSub': '(après abo)',
  'price.tab.lockNote': "Disponible après le début de l'abonnement",
  'price.tab.oneoff': 'Packs uniques',
  'price.tab.sub': 'Abonnements',
  'price.testLeads': 'Leads de test',
  'price.then': 'puis',
  'price.trial3days': '3 jours gratuits',
  'price.trialIncl': 'incl.',
  'price.trust.cancel.s': 'Résiliation mensuelle, pas de frais cachés, aucune durée minimale.',
  'price.trust.cancel.t': 'Résiliation à tout moment',
  'price.trust.gdpr.s':
    "Toutes les données hébergées dans l'UE, cryptées, aucun partage avec des tiers.",
  'price.trust.gdpr.t': 'Conforme RGPD',
  'price.trust.refund.s': 'Si un Lead ne convient pas, vous récupérez le Credit immédiatement.',
  'price.trust.refund.t': 'Leads inutiles ? Remboursé.',

  'pricing.beta.headline': 'Votre accès Beta à Leadscraper',
  'pricing.beta.subText':
    'Plan Growth avec 55 % de remise le premier mois, exclusif pour les testeurs Beta.',
  'pricing.mai.headline': 'Votre avantage concurrentiel déloyal commence ici.',
  'pricing.mai.subText':
    'Économisez 74 % le premier mois : ensuite, changez ou résiliez en 1 clic à tout moment.',
  'pricing.trial50.headline': "50 Leads B2B d'une valeur de 100 €, maintenant offerts.",
  'pricing.trial50.subText': "50 Leads offerts, 3 jours d'essai, résiliable à tout moment.",

  'reject.alreadyKnown': 'Déjà connu',
  'reject.alreadyKnown.hint':
    "Déjà dans votre CRM ou déjà contacté, aucun signal d'apprentissage et n'affecte pas votre taux de correspondance.",
  'reject.badData': 'Données incorrectes',
  'reject.badData.hint': "L'adresse, le nom ou les informations de contact ne sont pas corrects",
  'reject.noBuyingSignal': 'Aucun besoin identifiable',
  'reject.noBuyingSignal.hint':
    'Aucun événement déclencheur, aucun poste ouvert, aucun signal de croissance',
  'reject.notOperator': 'Pas un opérateur',
  'reject.notOperator.hint':
    "Agence, intermédiaire ou promoteur au lieu d'un prestataire opérationnel",
  'reject.other': 'Autre raison',
  'reject.other.hint': 'Écrivez brièvement pourquoi ci-dessous (texte libre)',
  'reject.wrongIndustry': 'Mauvais secteur',
  'reject.wrongIndustry.hint': "Leadscraper a mal identifié le domaine d'activité",
  'reject.wrongOwnership': 'Mauvaise structure de propriété',
  'reject.wrongOwnership.hint':
    "Filiale de groupe au lieu d'entreprise familiale, mauvaise forme juridique, etc.",
  'reject.wrongRegion': 'Mauvaise localisation',
  'reject.wrongRegion.hint': 'Le siège / la région ne correspond pas à la recherche',
  'reject.wrongRole': 'Mauvais interlocuteur',
  'reject.wrongRole.hint': "La personne ou le rôle n'est pas le décideur",
  'reject.wrongSize': "Mauvaise taille d'entreprise",
  'reject.wrongSize.hint': "Trop petite, trop grande ou groupe au lieu d'une PME",

  'rel.daysAgo': 'il y a {n} jours',
  'rel.hAgo': 'il y a {n} h',
  'rel.minAgo': 'il y a {n} min',
  'rel.now': "à l'instant",
  'rel.weeksAgo': 'il y a {n} semaines',
  'rel.yesterday': 'hier',

  'repeat.amountHint':
    'Plus de Leads = couverture plus large, moins de Leads = qualité supérieure par Lead.',
  'repeat.amountLabel': 'Combien de Leads souhaitez-vous ?',
  'repeat.cancel': 'Annuler',
  'repeat.paramsLabel': 'Paramètres de cette exécution',
  'repeat.prediction.basedOn': 'basé sur votre taux de correspondance actuel',
  'repeat.prediction.credits': 'Credits',
  'repeat.prediction.matches': 'correspondances attendues',
  'repeat.prediction.time': 'durée estimée',
  'repeat.prediction.title': 'Résultat attendu',
  'repeat.preset': 'Suggestions',
  'repeat.start': 'Lancer la recherche',
  'repeat.sub': 'Les paramètres sont pré-remplis : ajustez-les ou relancez directement.',
  'repeat.title': 'Répéter la recherche',
  'repeat.toast': 'Recherche lancée, résultats dans quelques minutes.',

  'res.acceptedNote': 'Leadscraper apprend de cette acceptation.',
  'res.breadcrumb': 'Résultats de recherche · {profile}',
  'res.cancel': 'Annuler',
  'res.density.comfortable': 'Confortable',
  'res.density.compact': 'Compact',
  'res.employees': 'Employés',
  'res.fb.all': 'Tous',
  'res.fb.new': 'Nouveau pour vous',
  'res.fb.status': 'Statut du feedback',
  'res.filter': 'Filtrer',
  'res.fit': 'Correspond',
  'res.footer':
    'Leadscraper a examiné 406 entrées supplémentaires. Les {count} présentées ici sont celles qui correspondent le mieux à vos retours précédents.',
  'res.fromMem': 'de votre mémoire : « {text} »',
  'res.learning.body':
    "Nouveau signal sur les deux dernières semaines : vous acceptez plus souvent les entreprises avec leur propre technologie d'impression ou de découpe que les simples façonniers.",
  'res.learning.title': 'Ce que Leadscraper apprend actuellement',
  'res.location': 'Localisation',
  'res.new': 'Nouveau',
  'res.notFit': 'Ne correspond pas',
  'res.openDetails': 'Ouvrir les détails →',
  'res.pickReason': 'Choisir une raison →',
  'res.reasonHint': 'Un clic suffit : votre raison affine ce que vous verrez demain.',
  'res.rejectedNote': 'Raison enregistrée. Cela affine votre mémoire.',
  'res.sector': 'Secteur',
  'res.summary':
    '{count} Leads examinés sur 412. Chacun vient avec une phrase expliquant pourquoi il vous correspond : votre « Correspond / Ne correspond pas » affine ce que vous verrez demain.',
  'res.title': 'Leads · {profile}',
  'res.toast.accepted':
    '« {company} » enregistré comme pertinent. Leadscraper affine votre audience.',
  'res.toast.rejected': 'Raison « {reason} » enregistrée. Les Leads similaires seront plus rares.',
  'res.uncertainty': 'Leadscraper est ici {score} : {text}.',
  'res.whyNotTitle': 'Pourquoi ce Lead ne correspond-il pas ?',

  'run.complete': 'Recherche terminée : {count} Leads livrés.',
  'run.completeEmpty':
    'Recherche terminée : aucune entreprise correspondante trouvée. Précisez votre cible ou essayez une autre région.',
  'run.cta.broaden_query': 'Élargir la requête',
  'run.cta.edit_query': 'Modifier la requête',
  'run.cta.retry': 'Réessayer',
  'run.failed.body':
    'Incident technique lors de la dernière recherche. Attendez 1-2 minutes et réessayez. Si le problème persiste, contactez-nous.',
  'run.failed.title': 'Leadscraper a rencontré un problème',
  'run.no_leads_delivered': 'Aucun Lead correspondant livré',
  'run.no_results.body':
    'Vos mots-clés ne donnent aucune entreprise B2B française pertinente sur Google. Essayez des termes plus courants : ex. "menuiserie" au lieu de "manufacture de meubles", ou élargissez la région.',
  'run.no_results.title': 'Aucun résultat trouvé sur le web pour votre requête',
  'run.partial_yield.body':
    'Leadscraper a trouvé moins de 10 résultats. Pour plus de volume : formulez la description de manière plus large ou élargissez la région.',
  'run.partial_yield.title': '{delivered}/{total} Leads livrés',
  'run.searching': '🧠 Leadscraper recherche pour vous…',
  'run.too_strict.body':
    "Leadscraper a trouvé des entreprises, mais aucune ne correspond précisément à votre cible. Votre description est peut-être trop restrictive : essayez une région plus large, assouplissez le nombre d'employés ou supprimez certains détails.",
  'run.too_strict.title': '{reasoned} candidats évalués, aucun ne correspondait à votre audience',

  'runs.delivered': '{n} Leads livrés',
  'runs.deliveredOne': '1 Lead livré',
  'runs.empty': 'Aucune exécution pour cette recherche encore.',
  'runs.evaluated': '{n} évalués',
  'runs.failed': 'échec',
  'runs.harvested.body':
    'Les précédentes recherches ont déjà fourni {n} entreprises correspondantes. Leadscraper connaît déjà ces résultats. De nouveaux résultats apparaissent lorsque de nouvelles entreprises de votre groupe cible deviennent visibles en ligne. La planification les détecte automatiquement.',
  'runs.harvested.title': 'Audience cible épuisée pour le moment',
  'runs.last': 'dernier',
  'runs.loadError': 'Erreur de chargement',
  'runs.loadFailed': "Impossible de charger l'historique : {err}",
  'runs.loading': "Chargement de l'historique…",
  'runs.noHits': 'aucun résultat',
  'runs.running': 'en cours maintenant',
  'runs.unfeasible': 'non réalisable',

  'sched.autoPush': 'Envoyer automatiquement les nouveaux Leads vers le CRM',
  'sched.autoPushNoCRM':
    "Vous devez d'abord connecter un CRM dans les paramètres du compte pour utiliser l'envoi automatique.",
  'sched.autoPushSub':
    'Dès que Leadscraper termine une exécution planifiée, tous les Leads trouvés sont automatiquement envoyés vers votre CRM connecté.',
  'sched.daily': 'Quotidien',
  'sched.dailySub': 'Chaque jour à la même heure',
  'sched.day.fri': 'Vendredi',
  'sched.day.fri.short': 'Ven',
  'sched.day.mon': 'Lundi',
  'sched.day.mon.short': 'Lun',
  'sched.day.sat': 'Samedi',
  'sched.day.sat.short': 'Sam',
  'sched.day.sun': 'Dimanche',
  'sched.day.sun.short': 'Dim',
  'sched.day.thu': 'Jeudi',
  'sched.day.thu.short': 'Jeu',
  'sched.day.tue': 'Mardi',
  'sched.day.tue.short': 'Mar',
  'sched.day.wed': 'Mercredi',
  'sched.day.wed.short': 'Mer',
  'sched.dayOfMonth': 'Jour du mois',
  'sched.monthly': 'Mensuel',
  'sched.monthlySub': 'Chaque mois à la date sélectionnée',
  'sched.nextRun': 'Prochaine exécution',
  'sched.once': 'Unique',
  'sched.onceSub': 'Exécuter une fois maintenant',
  'sched.rel.inDays': 'dans {n} jours',
  'sched.rel.overdue': 'en retard',
  'sched.rel.soon': 'bientôt',
  'sched.rel.tomorrow': 'demain',
  'sched.section': 'Récurrence',
  'sched.sectionSub':
    'Laissez Leadscraper effectuer cette recherche automatiquement de manière régulière.',
  'sched.time': 'Heure de début',
  'sched.toast.created': "Recherche planifiée créée : s'exécutera automatiquement.",
  'sched.toast.deleted': 'Exécution planifiée supprimée.',
  'sched.toast.paused': 'Exécution planifiée mise en pause.',
  'sched.toast.resumed': 'Exécution planifiée réactivée.',
  'sched.weekday': 'Jour de la semaine',
  'sched.weekly': 'Hebdomadaire',
  'sched.weeklySub': 'Chaque semaine le jour sélectionné',

  'schedCard.creditsHint':
    "max. {n} Credits / jour : dès qu'aucun nouveau Lead n'est trouvé dans votre audience cible, Leadscraper tourne à vide sans consommation.",
  'schedCard.errorToast': "Échec de l'enregistrement : {err}",
  'schedCard.freq.every': 'Toutes les {n} heures',
  'schedCard.freq.everyShort': 'toutes les {n} h',
  'schedCard.freq.hourly': 'Toutes les heures',
  'schedCard.freq.everyMinute': 'Chaque minute (test)',
  'schedCard.minuteTestHint':
    'Mode test : se déclenche ~chaque minute dès que le tick du planificateur tourne. Staging uniquement.',
  'schedCard.freq.hourlyShort': 'chaque heure',
  'schedCard.leadsPerDay': '~{n} Leads / jour',
  'schedCard.nextLabel': 'prochaine exécution {when}',
  'schedCard.nextRun.days': 'dans {n} jours',
  'schedCard.nextRun.hours': 'dans {n} h',
  'schedCard.nextRun.min': 'dans {n} min',
  'schedCard.nextRun.overdue': 'en retard',
  'schedCard.nextRun.tomorrow': 'demain',
  'schedCard.noRepeat': 'Aucune répétition',
  'schedCard.offBody': 'Unique : vous démarrez quand vous voulez.',
  'schedCard.onBody':
    "S'exécute en arrière-plan. Les nouveaux résultats arrivent automatiquement dans votre liste de Leads.",
  'schedCard.perWeek': '≈ {n} / semaine',
  'schedCard.repeat': 'Répéter cette recherche',
  'schedCard.save': 'Enregistrer',
  'schedCard.savedToast': 'Planning enregistré.',
  'schedCard.saving': 'Enregistrement…',

  'schedRuns.col.action': '',
  'schedRuns.col.crm': 'Envoi CRM',
  'schedRuns.col.frequency': 'Fréquence',
  'schedRuns.col.leads': 'Leads/exécution',
  'schedRuns.col.nextRun': 'Prochaine exécution',
  'schedRuns.col.params': 'Paramètres',
  'schedRuns.count': 'actives',
  'schedRuns.crm.no': 'Désactivé',
  'schedRuns.crm.yes': 'Actif',
  'schedRuns.delete': 'Supprimer',
  'schedRuns.empty.sub':
    'Activez « Récurrence » lors de votre prochaine recherche pour recevoir régulièrement de nouveaux Leads.',
  'schedRuns.empty.title': 'Aucune exécution planifiée',
  'schedRuns.freq.daily': 'Quotidien · {time}',
  'schedRuns.freq.monthly': '{day} du mois · {time}',
  'schedRuns.freq.weekly': '{day} · {time}',
  'schedRuns.pause': 'Mettre en pause',
  'schedRuns.resume': 'Reprendre',
  'schedRuns.status.paused': 'En pause',
  'schedRuns.sub':
    'Exécutions récurrentes qui ajoutent automatiquement de nouveaux leads à cette audience.',
  'schedRuns.title': 'Recherches planifiées',

  'so.close.btn': 'Laisser continuer en arrière-plan',
  'so.close.hint':
    'Vous pouvez continuer à travailler : Leadscraper vous préviendra quand de nouveaux Leads seront prêts.',
  'so.close.trust': 'Uniquement des sources publiques · chaque donnée est sourcée dans le Lead.',
  'so.funnel.analyzed': 'Analysé en profondeur',
  'so.funnel.evaluated': 'Évalué',
  'so.funnel.identified': 'Identifié',
  'so.funnel.ready': 'Prêt',
  'so.hero.elapsed': 'Temps depuis le début :',
  'so.hero.inFocus': 'Entreprises ciblées',
  'so.hero.preparing': 'Leadscraper vérifie votre demande',
  'so.hero.reflecting': 'Leadscraper élabore un nouveau plan',
  'so.hero.round': '(Tour {n})',
  'so.hero.searching': 'Leadscraper recherche pour vous',
  'so.live.title': 'Leadscraper travaille en direct',
  'so.query.title': 'Votre requête de recherche',
  'so.reflector.title': 'Leadscraper a abandonné la première approche',
  'so.step.delivery.sub': 'Les meilleures correspondances sont triées + livrées pour vous',
  'so.step.delivery.title': 'Assembler les Leads',
  'so.step.discovery.sub': 'Meilleurs candidats des sources web allemandes',
  'so.step.discovery.title': 'Identifier les entreprises',
  'so.step.done.sub': 'Recherche terminée',
  'so.step.done.title': 'Terminé',
  'so.step.enriching.sub': 'Plan de prospection, scores + recherche approfondie pour les 10 Leads',
  'so.step.enriching.title': 'Cortex enrichit encore',
  'so.step.enriching.title.light': 'Vérification des données de base',
  'so.step.hydration.sub': 'Sites web + mentions légales + carrières + équipe + actualités',
  'so.step.hydration.title': 'Analyser les entreprises en profondeur',
  'so.step.planning.sub': 'Analyser vos apprentissages + planifier les stratégies de recherche',
  'so.step.planning.title': 'Leadscraper se souvient',
  'so.step.reasoning.sub': 'Leadscraper évalue chaque candidat par rapport à votre audience',
  'so.step.reasoning.title': 'Leadscraper évalue',

  'src.derived': 'Par Leadscraper',
  'src.directory': 'Répertoire',
  'src.news': 'Presse spécialisée',
  'src.official': 'Officiel',
  'src.web': "Site web d'entreprise",

  'trial.afterNote':
    'Ensuite votre abonnement {plan} continue automatiquement, résiliable à tout moment.',
  'trial.day1': "Plus qu'1 jour",
  'trial.daysN': 'Plus que {n} jours',
  'trial.freeTest': 'tester gratuitement.',
  'trial.leadsLeft': "{left} / {total} leads d'essai restants",
  'trial.phase': "Phase d'essai",
  'trial.secureSub': "Sécuriser l'abonnement",
  // LEA-324: SEPA subscription "payment processing" banner.
  'bill.sepaProcessing.badge': 'Paiement en cours',
  'bill.sepaProcessing.title': 'Votre paiement SEPA est en cours : votre accès est déjà débloqué.',
  'bill.sepaProcessing.note':
    'Le prélèvement peut prendre 2 à 5 jours ouvrés. Vous pouvez utiliser Leadscraper pleinement dès maintenant.',

  // ─── Transactional email — shared strings ────────────────────────────────
  // LEA-295: machine-translated from de.ts/en.ts. Uses formal "vous" to
  // match the existing app strings. Native-speaker review pending before
  // production rollout (see staging-verification runbook).
  'email.shared.brand.name': 'Leadscraper',
  'email.shared.founder.name': 'Janik Deimann',
  'email.shared.founder.title': 'Fondateur, Leadscraper',
  'email.shared.reply_note': 'Des questions ? Répondez simplement à cet e-mail.',
  'email.sepa-payment-failed.subject': 'Votre paiement SEPA a échoué',
  'email.sepa-payment-failed.preheader': 'Le prélèvement de {{amount_formatted}} a été rejeté.',
  'email.sepa-payment-failed.badge': 'Paiement échoué',
  'email.sepa-payment-failed.hero': 'Votre prélèvement<br>a été rejeté.',
  'email.sepa-payment-failed.greeting': 'Bonjour {{first_name}},',
  'email.sepa-payment-failed.intro':
    'le prélèvement SEPA pour votre pack de crédits n’a pas abouti auprès de votre banque.',
  'email.sepa-payment-failed.credits_line':
    'Nous avons donc retiré {{credits_revoked}} crédits de votre compte.',
  'email.sepa-payment-failed.retry_line':
    'Si vous avez besoin des crédits, vous pouvez simplement racheter le pack dans votre compte.',
  'email.sepa-payment-failed.button': 'Ouvrir Leadscraper',
  'email.sepa-payment-failed.detail.pack_label': 'Pack',
  'email.sepa-payment-failed.detail.amount_label': 'Montant',
  'email.shared.footer.transactional':
    'Vous recevez cet email parce que vous vous êtes inscrit·e à un compte Leadscraper. Ce message transactionnel fait partie de la relation contractuelle et ne peut pas être désabonné.',
  'email.shared.footer.legal':
    'Deimann Com GmbH &middot; Randstraße 75 &middot; 22525 Hambourg &middot; Allemagne<br />Directeur Général : Janik Deimann &middot; HRB 164162 (AG Hambourg) &middot; N° TVA DE332747716 &middot; © {{year}}',

  // ─── Transactional email — welcome ───────────────────────────────────────
  'email.welcome.subject': 'Bienvenue sur Leadscraper, {{first_name}} 👋',
  'email.welcome.title': 'Bienvenue sur Leadscraper',
  'email.welcome.preheader': 'Bienvenue à bord, vos premiers leads en 5 minutes.',
  'email.welcome.badge': 'Compte prêt',
  'email.welcome.hero': 'Ravi de vous accueillir,<br>{{first_name}}.',
  'email.welcome.subhead':
    "Votre compte est configuré et vos premiers crédits sont prêts, c'est parti !",
  'email.welcome.steps.title': 'Démarrez en 5 étapes',
  'email.welcome.steps.1.title': 'Ajoutez votre site web',
  'email.welcome.steps.1.body':
    "Pour que l'agent comprenne où va votre entreprise, et à quoi prêter attention.",
  'email.welcome.steps.2.title': 'Définissez votre audience cible',
  'email.welcome.steps.2.body':
    "Secteur, région, taille d'entreprise, intitulé de poste : plus c'est précis, meilleurs sont les résultats.",
  'email.welcome.steps.3.title': 'Lancez votre première recherche de leads',
  'email.welcome.steps.3.body':
    "L'agent recherche, enrichit et livre les premières entreprises directement dans votre tableau de bord.",
  'email.welcome.steps.4.title': 'Évaluez les leads',
  'email.welcome.steps.4.body':
    "Pouce vers le haut ou le bas : l'agent apprend de chaque retour ce qui vous correspond.",
  'email.welcome.steps.5.title': 'Lancez la prochaine recherche',
  'email.welcome.steps.5.body':
    "À chaque exécution, les résultats deviennent nettement plus précis, jusqu'à correspondre à 100 % à vos besoins.",
  'email.welcome.cta.primary': 'Vers le tableau de bord',
  'email.welcome.signoff.line': 'Des questions ? Répondez simplement à cet email, je vous lis.',

  // ─── Transactional email — subscription-cancelled ────────────────────────
  'email.subscription-cancelled.subject':
    'Dommage de vous voir partir, {{first_name}}, annulation confirmée',
  'email.subscription-cancelled.title': 'Votre abonnement est annulé',
  'email.subscription-cancelled.preheader': 'Nous avons reçu votre annulation.',
  'email.subscription-cancelled.badge': 'Annulation confirmée',
  'email.subscription-cancelled.hero': 'Dommage de vous voir partir,<br>{{first_name}}.',
  'email.subscription-cancelled.subhead':
    "Nous avons reçu votre annulation. Votre accès au plan {{plan_name}} reste actif jusqu'au {{access_until}}.",
  'email.subscription-cancelled.subhead_trial':
    'Nous avons reçu votre annulation. Votre essai est terminé et rien ne sera débité.',
  'email.subscription-cancelled.note_trial':
    'Si vous souhaitez continuer plus tard, vous pouvez réactiver votre abonnement dans votre compte.',
  'email.subscription-cancelled.summary.plan_label': 'Plan',
  'email.subscription-cancelled.summary.until_label': "Accès jusqu'au",
  'email.subscription-cancelled.note':
    'Jusque-là, vous gardez un accès complet. Ensuite, vos données seront supprimées conformément à notre politique de confidentialité.',
  'email.subscription-cancelled.signoff.line':
    "Qu'aurions-nous pu faire mieux ? Répondez à cet email, je vous lis.",
  'email.subscription-cancelled.cta.primary': 'Retour au produit &amp; réactiver',
  'email.subscription-cancelled.cta.note':
    'Vous atterrirez directement dans le tableau de bord où vous pourrez réactiver votre abonnement.',
  'email.subscription-cancelled.footer.transactional':
    'Vous recevez cet email en confirmation de votre annulation. Ce message transactionnel fait partie de la relation contractuelle et ne peut pas être désabonné.',

  // ─── Transactional email — payment-failed / dunning (LEA-304, AI-translated from DE master) ─────
  'email.payment-failed.subject': 'Votre paiement a échoué, merci de mettre à jour',
  'email.payment-failed.title': 'Paiement échoué, à mettre à jour',
  'email.payment-failed.preheader':
    "Nous n'avons pas pu débiter {{amount_formatted}} pour votre plan {{plan_name}}. Merci de mettre à jour vos informations de paiement.",
  'email.payment-failed.badge': 'Paiement échoué',
  'email.payment-failed.hero': "Votre paiement n'a pas abouti, {{first_name}}.",
  'email.payment-failed.subhead':
    'Impossible de débiter <strong style="color:#0B0F19;">{{amount_formatted}}</strong> pour votre plan {{plan_name}}. Mettez à jour vos informations de paiement pour éviter une interruption de vos leads.',
  'email.payment-failed.summary.plan_label': 'Plan',
  'email.payment-failed.summary.amount_label': 'Montant dû',
  'email.payment-failed.summary.attempt_label': 'Tentative',
  'email.payment-failed.summary.attempt_value': '{{attempt_count}} sur 3',
  'email.payment-failed.summary.next_label': 'Prochaine tentative',
  'email.payment-failed.cta.primary': 'Mettre à jour le paiement maintenant',
  'email.payment-failed.reassurance':
    "Cela prend moins d'une minute, ensuite tout continue comme avant. Une question ? Répondez simplement à cet email.",
  'email.payment-failed.footer.transactional':
    'Vous recevez cet email car un paiement de votre abonnement Leadscraper a échoué. Ce message transactionnel fait partie de la relation contractuelle et ne peut pas être désabonné.',

  // ─── Transactional email — trial-ending-soon (LEA-295) ─────
  'email.trial-winback.subject': 'Si c’était juste la peur du prélèvement …',
  'email.trial-winback.badge': 'Votre compte est toujours là',
  'email.trial-winback.hero': '30 % de réduction<br>si vous souhaitez continuer.',
  'email.trial-winback.preheader':
    'Reviens — 30 % de réduction pendant 3 mois, ton compte est toujours là.',
  'email.trial-winback.greeting': 'Bonjour {{first_name}},',
  'email.trial-winback.intro':
    'tu as mis fin à ton essai immédiatement hier — tout à fait normal, le bouton est là pour ça. Mais si c’était seulement pour éviter un prélèvement non voulu : ton compte est toujours là, avec tout ce que tu as configuré.',
  'email.trial-winback.offer':
    'Si tu veux continuer : {{plan_name}} à −30 % pendant 3 mois. Pas de nouveau formulaire — ta carte est enregistrée.',
  'email.trial-winback.button': 'Voir l’offre et réactiver',
  'email.trial-winback.transparency':
    'Le clic ne prélève rien — tu vois d’abord le prix et la date de prélèvement, puis tu confirmes toi-même. Lien : {{winback_url}}',
  'email.trial-winback.signoff': 'Janik',
  'email.trial-ending-soon.cancel_note':
    'Tu ne veux pas continuer ? Résilie en un clic, avant le premier prélèvement : {{cancel_link}}',
  'email.trial-ending-soon.cancel_link_label': "Résilier l'essai",
  'email.trial-ending-soon.subject': 'Votre essai se termine bientôt',
  'email.trial-ending-soon.preheader':
    "L'essai se termine le {{trial_ends_at}} : choisissez un plan maintenant.",
  'email.trial-ending-soon.greeting': 'Bonjour {{first_name}},',
  'email.trial-ending-soon.intro':
    'votre essai {{plan_name}} se termine le {{trial_ends_at}}. Il vous reste {{credits_remaining}} crédits.',
  'email.trial-ending-soon.why':
    "Une fois l'essai terminé, votre compte passe en lecture seule : vous pouvez continuer à consulter vos leads précédents, mais les nouvelles recherches sont suspendues.",
  'email.trial-ending-soon.cta':
    'Si les résultats vous conviennent : choisissez un plan maintenant pour que tout continue sans interruption.',
  'email.trial-ending-soon.button': 'Choisir un plan',
  'email.trial-ending-soon.signoff': 'Janik',

  // ─── Transactional email — trial-ended (LEA-295) ─────
  'email.trial-ended.subject': 'Votre essai est terminé',
  'email.trial-ended.badge': 'Essai terminé',
  'email.trial-ended.hero': 'Votre essai<br>est terminé.',
  'email.trial-ended.preheader': 'Votre essai est terminé, compte en lecture seule.',
  'email.trial-ended.greeting': 'Bonjour {{first_name}},',
  'email.trial-ended.intro':
    'votre essai {{plan_name}} vient de se terminer. Votre compte est maintenant en lecture seule : vous voyez toujours tous vos leads précédents, mais les nouvelles recherches sont suspendues.',
  'email.trial-ended.cta':
    "Choisissez un plan pour continuer immédiatement. Vos données et votre mémoire d'apprentissage sont conservées.",
  'email.trial-ended.button': 'Choisir un plan',
  'email.trial-ended.signoff': 'À bientôt.<br>Janik',

  // ─── Transactional email — verify-email (LEA-295) ─────
  'email.verify-email.subject': 'Confirmez votre adresse email',
  'email.verify-email.badge': 'Presque terminé',
  'email.verify-email.hero': 'Confirmez votre<br>adresse e-mail.',
  'email.verify-email.preheader': 'Confirmez votre email pour activer Leadscraper.',
  'email.verify-email.greeting': 'Bonjour {{first_name}},',
  'email.verify-email.body':
    'cliquez sur le bouton ci-dessous pour confirmer votre email et activer votre compte Leadscraper.',
  'email.verify-email.button': "Confirmer l'email",
  'email.verify-email.fallback_note':
    'Si le bouton ne fonctionne pas, collez ce lien dans votre navigateur :',
  'email.verify-email.ttl_note': 'Le lien expire dans {{verify_expires_in}}.',
  'email.verify-email.ttl_default': '24 heures',
  'email.verify-email.ignore_note':
    "Vous n'avez pas créé de compte Leadscraper ? Ignorez simplement cet email.",

  // ─── Transactional email — refund-confirmation (LEA-295) ─────
  'email.refund-confirmation.subject': 'Remboursement confirmé',
  'email.refund-confirmation.preheader': 'Remboursement : {{amount_formatted}}',
  'email.refund-confirmation.greeting': 'Bonjour {{first_name}},',
  'email.refund-confirmation.intro': 'nous vous avons remboursé {{amount_formatted}}.',
  'email.refund-confirmation.refunded_line':
    'Enregistré le {{refunded_at}} sur votre moyen de paiement initial. Selon la banque, le crédit apparaît sous 3 à 10 jours ouvrés.',
  'email.refund-confirmation.clawback_yes':
    'Comme le remboursement annule les crédits associés, {{credits_clawed_back}} crédits ont été retirés de votre compte.',
  'email.refund-confirmation.clawback_no': 'Vos crédits restent intacts.',
  'email.refund-confirmation.reason_line': 'Motif : {{reason}}.',
  'email.refund-confirmation.outro': 'Des questions ? Répondez simplement à cet email.',
  'email.refund-confirmation.footer':
    'Vous recevez cet email car un remboursement a été émis pour votre compte Leadscraper.',

  // ─── Transactional email — password-reset ────────────────────────────────
  'email.password-reset.subject':
    'Réinitialiser votre mot de passe, lien valide pendant {{expires_in}}',
  'email.password-reset.title': 'Réinitialiser votre mot de passe',
  'email.password-reset.preheader':
    'Réinitialisez votre mot de passe en toute sécurité. Le lien expire dans {{expires_in}}.',
  'email.password-reset.badge': 'Réinitialiser le mot de passe',
  'email.password-reset.hero': 'Définir un nouveau<br>mot de passe.',
  'email.password-reset.body':
    "Quelqu'un a demandé la réinitialisation de votre mot de passe. Si c'était vous, cliquez simplement sur le bouton. Sinon, ignorez cet email. Votre mot de passe reste inchangé.",
  'email.password-reset.expires': 'Le lien expire dans {{expires_in}}.',
  'email.password-reset.cta.primary': 'Réinitialiser le mot de passe',
  'email.password-reset.signoff.line':
    'Des questions sur la sécurité du compte ? Répondez simplement à cet email.',
  'email.password-reset.footer.transactional':
    'Pour des raisons de sécurité, cet email contient des informations sur la demande. Ne le partagez avec personne. Cette notification de sécurité fait partie de la relation contractuelle et ne peut pas être désabonnée.',

  // ─── Transactional email — security-alert ────────────────────────────────
  'email.security-alert.subject': 'Alerte de sécurité : {{event}}',
  'email.security-alert.title': 'Alerte de sécurité',
  'email.security-alert.preheader':
    "Alerte de sécurité : {{event}}. Si ce n'était pas vous, réinitialisez votre mot de passe maintenant.",
  'email.security-alert.badge': 'Alerte de sécurité',
  'email.security-alert.hero': 'Quelque chose a changé sur<br>votre compte.',
  'email.security-alert.subhead':
    'Bonjour {{first_name}}, nous venons de détecter une action liée à la sécurité : <strong style="color:#0B0F19;">{{event}}</strong>. Si c\'était vous, tout va bien, vous pouvez ignorer cet email.',
  'email.security-alert.detail.time_label': 'Heure (UTC)',
  'email.security-alert.detail.ip_label': 'Adresse IP',
  'email.security-alert.detail.browser_label': 'Navigateur',
  'email.security-alert.warning.line':
    '<strong style="color:#881337;">Ce n\'était pas vous ?</strong> Réinitialisez votre mot de passe immédiatement et vérifiez l\'activité de votre compte.',
  'email.security-alert.cta.primary': 'Réinitialiser le mot de passe maintenant',
  'email.security-alert.signoff.line':
    'Des questions sur la sécurité du compte ? Répondez simplement à cet email, je lis chaque message.',
  'email.security-alert.footer.transactional':
    "Pour des raisons de sécurité, cet email contient des informations sur l'action. Ne les partagez avec personne. Cette notification de sécurité fait partie de nos conditions de service et ne peut pas être désabonnée.",
  // LEA-295 bug-fix: see note in de.ts. Machine-translated, pending native review.
  'email.security-alert.event.password_reset': 'Mot de passe réinitialisé',
  'email.security-alert.event.account_deletion_requested':
    'Suppression de compte demandée (délai de grâce de 30 jours)',
  'email.security-alert.event.password_changed': 'Mot de passe modifié',
  'email.security-alert.firstname_fallback': 'là-bas',
  // ── Phase-Trigger-UI (Welle G66 i18n — Pricing-v2) ──
  'phase.creditOne': 'crédit',
  'phase.creditMany': 'crédits',
  'phase.retry': 'Réessayer',
  'phase.cancel': 'Annuler',
  'phase.confirm': 'Confirmer',
  'phase.running': 'En cours …',
  'phase.btn.running': 'en cours …',
  'phase.unknownError': 'Erreur inconnue',
  'phase.errorLabel': 'Erreur :',
  'phase.gate.loadingConnect': 'Recherche des contacts …',
  'phase.gate.loadingPitch': 'Génération des insights complets …',
  'phase.gate.loadingHint':
    'Cela prend généralement 30 à 60 secondes. Vous pouvez quitter la page : nous vous préviendrons une fois terminé.',
  'phase.gate.failConnect': 'Échec de la recherche',
  'phase.gate.failPitch': 'Échec de la génération des insights',
  'phase.gate.failHint': 'Veuillez réessayer : aucun crédit supplémentaire ne sera facturé.',
  'phase.connect.title': 'Débloquer les contacts et coordonnées directes',
  'phase.connect.desc':
    "Nous recherchons jusqu'à 3 décideurs avec e-mail direct, téléphone direct et URL LinkedIn. Les sources sont fournies (piste d'audit RGPD).",
  'phase.connect.cta': 'Trouver des contacts',
  'phase.connect.runtime': 'Durée : ~30-60 secondes',
  'phase.pitch.title': "Débloquer les insights complets et le plan d'acquisition",
  'phase.pitch.desc':
    "Plan d'acquisition personnalisé en 6 sections : ce que fait l'entreprise, pourquoi précisément ce lead, l'actualité (événements déclencheurs), les références clients, des accroches pour votre e-mail de vente.",
  'phase.pitch.cta': 'Générer les insights complets',
  'phase.pitch.runtime': 'Durée : ~20-40 secondes',
  'phase.locked.confirmQuestion': 'Confirmation : débiter {credits} pour "{action}" ?',
  'phase.deepen.title': 'Approfondir ce lead',
  'phase.deepen.descConnectDone':
    "Les contacts sont chargés. Chargez maintenant les insights complets pour le plan d'acquisition + le stack technologique.",
  'phase.deepen.descDefault':
    'Identifié. Chargez les contacts ou directement les insights complets, facturé à chaque clic.',
  'phase.deepen.pricingError':
    "Le catalogue tarifaire n'a pas pu être chargé, retour aux prix standard.",
  'phase.deepen.directPitch': 'Charger directement les insights complets (sans contacts)',
  'phase.btn.connect': '+ Trouver des contacts ({credits})',
  'phase.btn.pitch': '+ Insights complets ({credits})',
  'phase.toast.connectLoading': 'Les contacts se chargent.',
  'phase.toast.pitchLoading': 'Les insights complets se chargent.',
  'phase.toast.noCredits': 'Plus de crédits. Veuillez recharger ou améliorer votre forfait.',
  'phase.toast.connectSoon':
    'La recherche de contacts arrive bientôt, débloquée avec la vague F2.2.',
  'phase.toast.pitchSoon': 'Les insights complets arrivent bientôt, débloqués avec la vague F2.3.',
  'phase.toast.error': 'Erreur : {msg}',
  'phase.toast.unexpected': 'Erreur inattendue. Veuillez réessayer.',
  'phase.dialog.connectTitle': 'Trouver des contacts ?',
  'phase.dialog.pitchTitle': 'Charger les insights complets ?',
  'phase.dialog.connectDesc':
    'Nous recherchons les décideurs (e-mail, téléphone, LinkedIn) pour ce lead. Le résultat est généralement disponible en 1 à 2 minutes.',
  'phase.dialog.pitchDesc':
    "Nous générons le plan d'acquisition, le stack technologique, les phrases déclencheuses et les champs Sparkle pour ce lead. Le résultat est généralement disponible en 1 à 2 minutes.",
  'phase.dialog.close': 'Fermer la boîte de dialogue',
  'phase.dialog.costNote':
    "Cette action coûte {credits}. Une fois un crédit utilisé, il n'est pas remboursé automatiquement.",
  'phase.dialog.confirmDeduct': 'Oui, débiter {credits}',
  // ── LeadDetail Rest-Strings (Welle G66.2 i18n) ──
  'det.src.impressum': 'Mentions légales',
  'det.src.handelsregister': 'Registre du commerce',
  'det.src.subPage': 'Page équipe',
  'det.src.dorkEnrich': 'Recherche web',
  'det.src.geminiGrounding': 'Recherche IA',
  'det.confReason.deepResearchConfirmed': 'confirmé par recherche',
  'det.confReason.handelsregisterOnly': 'registre du commerce uniquement',
  'det.confReason.nameMatch': 'correspondance de nom',
  'det.confReason.multiSource': 'sources multiples',
  'det.confReason.rankFallback': 'Classement Discovery (recherche approfondie ignorée)',
  'det.confReason.rankFallbackLowConf':
    'Classement Discovery (recherche approfondie sans résultat)',
  'det.trust.authoritative':
    'Vérifié depuis une source officielle (mentions légales/registre du commerce)',
  'det.trust.semiAuth': "Depuis le site de l'entreprise (p. ex. /team)",
  'det.trust.llm': 'Extrait par IA du contenu du site',
  'det.trust.derived': "Déduit d'autres données (faible fiabilité)",
  'det.trust.sourceGeneric': 'Source : {source}',
  'det.trust.confidence': 'confiance',
  'det.pReject.duplicate': 'Doublon',
  'det.pReject.duplicateHint':
    'La personne est déjà dans la liste ou incohérence de nom ("Werner Weber Kurt Richter")',
  'det.pReject.wrongRole': 'Mauvais rôle',
  'det.pReject.wrongRoleHint': "La personne n'a pas le pouvoir de décision recherché",
  'det.pReject.inactive': 'Plus actif',
  'det.pReject.inactiveHint': 'La personne a changé de poste, est à la retraite, etc.',
  'det.pReject.wrongData': 'Données incorrectes',
  'det.pReject.wrongDataHint': 'E-mail/téléphone erroné ou injoignable',
  'det.pReject.betterContact': 'Une autre personne convient mieux',
  'det.pReject.betterContactHint': 'Il existe un contact plus adapté dans cette entreprise',
  'det.pReject.private': 'Ne pas contacter',
  'det.pReject.privateHint': "Je ne veux pas contacter cette personne (pas d'apprentissage)",
  'det.toast.personFeedbackRealOnly':
    "Le feedback sur les personnes n'est disponible que pour les vrais leads.",
  'det.toast.removeFailed': 'Suppression impossible : réessayez.',
  'det.toast.backendUnavailable': "Backend indisponible : veuillez recharger l'application.",
  'det.toast.planRegenerating': "Le plan d'acquisition est régénéré avec le briefing actuel …",
  'det.toast.phaseAlreadyRunning': '{phase} est déjà en cours, un instant.',
  'det.available': 'disponible',
  'det.unavailable': 'indisponible',
  'det.primary': 'Principal',
  'det.sourcePrefix': 'Source :',
  'det.dataViaWebResearch': 'Données via recherche web publique',
  'det.openLink': 'Ouvrir {label}',
  'det.openLinkedin': 'Ouvrir le profil LinkedIn de {name}',
  'det.openXing': 'Ouvrir le profil XING de {name}',
  // ── LeadsTable Rest-Strings (Welle G66.3 i18n) ──
  'lt.trigErr.noContacts': "Nous n'avons trouvé aucun contact. Aucun crédit débité.",
  'lt.trigErr.insufficientCredits': 'Crédits insuffisants. Veuillez recharger.',
  'lt.trigErr.phaseRunning': 'Cette phase est déjà en cours : veuillez patienter.',
  'lt.trigErr.phaseCompleted': 'Cette phase est déjà terminée.',
  'lt.trigErr.triggerFailed': 'Échec du déclenchement : {msg}',
  'lt.cta.findContacts': 'Trouver des contacts · 1 crédit',
  'lt.cta.createPlan': "Créer un plan d'acquisition · 1 crédit",
  'lt.cta.openOutreach': "Ouvrir le message d'approche",
  'lt.verifyStuck': 'La vérification est bloquée : rechargez la page et réessayez.',
  'lt.verifyFailed': 'Échec de la vérification des interlocuteurs.',
  'lt.planFailed': "Le plan d'acquisition n'a pas pu être créé.",
  'lt.softKeepAria': 'Possible, cliquez pour les détails',
  'lt.manual.toast.backendUnavailable': 'Backend indisponible : réessayez plus tard.',
  'lt.manual.toast.added': '{name} ajouté',
  'lt.manual.toast.alreadyExists': "{name} existe déjà : je l'ouvre pour vous.",
  'lt.manual.toast.switchProfile':
    "Changez éventuellement d'audience : le lead est peut-être ailleurs.",
  'lt.manual.toast.addFailed': "Échec de l'ajout.",
  'lt.manual.companyFallback': 'Entreprise',
  // ── Dashboard Rest-Strings (Welle G66.4 i18n) ──
  'dash.cancel.requested':
    'Annulation demandée : elle prendra effet au prochain point de contrôle.',
  'dash.cancel.failed': "Échec de l'annulation",
  'dash.cancel.titleNoRun': "ID d'exécution pas encore disponible",
  'dash.cancel.titleCancel': 'Annuler la recherche',
  'dash.cancel.inFlight': 'Annulation …',
  'dash.cancel.confirm': 'Vraiment annuler ?',
  'dash.refreshing': 'Actualisation …',
  'dash.run.noCredits': 'Aucun crédit : veuillez souscrire un abonnement.',
  'dash.run.startSub': "Démarrer l'abonnement",
  'dash.sugg.region': 'Région :',
  'dash.sugg.contact': 'Contact :',
  'dash.sugg.extra': 'Complément :',
  'dash.sugg.why': 'Pourquoi :',
  // ── Bestandskunden-Exclude (A1, 2026-06-02) ──
  'acct.exclude.title': 'Exclure les clients existants',
  'acct.exclude.desc':
    'Ajoutez les domaines que vous connaissez déjà (p. ex. votre export CRM). Ils sont exclus des résultats de TOUTES les recherches, un domaine par ligne.',
  'acct.exclude.placeholder': 'entreprise.fr\nexemple-sarl.fr\nclient.com',
  'acct.exclude.count': '{n} domaines exclus de toutes les recherches',
  'acct.exclude.save': 'Enregistrer la liste',
  'acct.exclude.saved': "Liste d'exclusion enregistrée ({n} domaines)",
  // ── Agent-Chat / Cockpit (LEA-435 Wave B) ──
  'agent.nav': 'Assistant',
  'agent.tab.chat': 'Chat',
  'agent.tab.workspace': 'Espace de travail',
  'agent.boot': 'Un instant — votre assistant démarre …',
  'agent.thinking': 'Réflexion en cours …',
  'agent.turnError': "Cela n'a pas fonctionné — réessayez dans un instant.",
  'agent.budgetExhausted':
    "Le quota de chat de votre compte est épuisé pour aujourd'hui. Il se réinitialise automatiquement demain — vos crédits et leads ne sont pas affectés.",
  'agent.artifact.eyebrow': 'Groupe cible',
  'agent.artifact.draftBadge': 'Brouillon',
  'agent.artifact.createdBadge': "Créé à l'instant",
  'agent.artifact.industry': 'Secteur',
  'agent.artifact.region': 'Région',
  'agent.artifact.size': 'Taille',
  'agent.artifact.exclusions': 'Exclusions',
  'agent.artifact.any': 'indifférent',
  'agent.bootError': "L'assistant est momentanément indisponible. Veuillez recharger la page.",
  'agent.empty.title': '{greeting}, comment puis-je vous aider ?',
  'agent.greet.morning': 'Bonjour',
  'agent.greet.day': 'Bonjour',
  'agent.greet.evening': 'Bonsoir',
  'agent.empty.sub':
    'Décrivez simplement les clients que vous recherchez — je construis la recherche, je demande votre validation et nous examinons les résultats ensemble.',
  'agent.starter.find': 'Je cherche de nouveaux clients — aidez-moi à définir ma cible',
  'agent.starter.describe': 'Analysez mon site web et proposez-moi des cibles pertinentes',
  'agent.starter.review': 'Montrez-moi mes derniers leads et passons-les en revue',
  'agent.composer.placeholder': 'Message à votre assistant …',
  'agent.composer.send': 'Envoyer',
  'agent.composer.stop': 'Stop',
  'agent.composer.hint': 'Entrée pour envoyer · Maj+Entrée pour une nouvelle ligne',
  'agent.scroll.end': 'Aller à la fin',
  'agent.confirm.title': 'Validation : {action}',
  'agent.confirm.approve': 'Valider',
  'agent.confirm.deny': 'Refuser',
  'agent.tool.analyze': 'Analyser le site',
  'agent.tool.analyzeReference': 'Voir le site de référence',
  'agent.tool.draft': 'Ébauche de cible',
  'agent.tool.createProfile': 'Créer le profil',
  'agent.tool.startRun': 'Lancer la recherche',
  'agent.tool.runStatus': 'Statut de recherche',
  'agent.tool.listLeads': 'Charger les leads',
  'agent.tool.getLead': 'Détails du lead',
  'agent.tool.connect': 'Trouver les contacts',
  'agent.tool.pitch': 'Créer un plan de prospection',
  'agent.tool.feedback': 'Enregistrer l’avis',
  'agent.tool.credits': 'Solde de crédits',
  'agent.tool.exclude': 'Exclure des entreprises',
  'agent.tool.cancelApproval': 'Retirer la validation',
  'agent.tool.cancelPlan': 'Arrêter le plan de recherche',
  'agent.support.open': 'Support',
  'agent.support.title': 'Ouvrir le chat d’assistance — un humain vous répond',
  'agent.ws.title': 'Vos cibles',
  'agent.ws.new': 'Nouveau',
  'agent.ws.empty': 'Les profils de cible créés ensemble dans le chat apparaîtront ici.',
  'agent.ws.openLeads': 'Voir les leads',
  // Kopieren / Umbenennen / Datei-Anhang (LEA-435 Usability-Welle)
  'agent.msg.copy': 'Copier',
  'agent.msg.copied': 'Copié',
  'agent.sessions.rename': 'Double-cliquez pour renommer',
  'agent.composer.attach': 'Joindre la liste clients (CSV/XLSX)',
  'agent.attach.none': "Aucun domaine d'entreprise détecté dans le fichier.",
  'agent.attach.xlsxFailed': 'Impossible de lire le fichier Excel. Essaie plutôt un fichier CSV.',
  'agent.attach.saved':
    "J'ai importé ma liste de clients : {n} domaines d'entreprises sont désormais exclus de toutes les recherches futures (p. ex. {examples}).",
  'agent.attach.saveFailed':
    "J'ai importé ma liste de clients ({n} domaines d'entreprises), mais l'enregistrement comme liste d'exclusion a échoué.",
  // Session-Verlauf + Relativzeit (LEA-435 Multi-Session)
  'agent.sessions.new': 'Nouveau chat',
  'agent.sessions.empty': 'Aucune conversation.',
  'agent.sessions.untitled': 'Nouvelle conversation',
  'agent.sessions.delete': 'Supprimer',
  // LEA-448
  'agent.sessions.deleteConfirm': 'Supprimer cette conversation ? Action irréversible.',
  'agent.artifact.radius': 'rayon de {n} km',
  'agent.leads.companyContactHint':
    'Contact de l’entreprise issu des mentions légales — pas un interlocuteur personnel.',
  'agent.run.stalled': 'Cela prend plus de temps que d’habitude…',
  'agent.run.interrupted': '{n} entreprises livrées — recherche interrompue plus tôt',
  'agent.run.qualifierDown':
    "Notre étape de qualification était brièvement indisponible — c'était de notre côté, pas vos critères. Une nouvelle recherche vaut le coup.",
  'agent.run.recheck': 'Vérifier à nouveau',
  // LEA-448 round-4
  'agent.cost.startRun':
    'jusqu’à {n} crédits — seules les entreprises réellement livrées comptent ; les écartées ne sont jamais facturées',
  'agent.cost.startRunRescue':
    'deuxième tentative après un résultat maigre — ne compte pas comme une recherche supplémentaire ; comme toujours, seules les entreprises livrées sont facturées (jusqu’à {n} crédits)',
  'agent.cost.connect':
    '{n} crédit — interlocuteurs (nom, fonction, e-mail, téléphone) de cette entreprise à partir de sources publiques',
  'agent.cost.pitch':
    '{n} crédit — plan de prospection (recherche + premier message prêt à envoyer) pour cette entreprise',
  // LEA-704: reveal-model pricing (Om QA 26.10.).
  'agent.cost.startRunReveal':
    "gratuit — la recherche ne coûte rien, vous ne payez qu'en déverrouillant un interlocuteur",
  'agent.cost.scheduleReveal':
    'gratuit — chaque recherche · {cadence} · se met en pause d’elle-même après {k} recherches d’affilée sans nouvelle entreprise ou quand votre solde est vide · vous pouvez l’arrêter à tout moment',
  'agent.cost.connectReveal':
    'gratuit — les interlocuteurs sont recherchés et visibles une fois déverrouillés',
  'agent.cost.pitchReveal': 'gratuit — le plan de prospection est inclus dans le déverrouillage',
  'agent.cost.startRunPlan':
    '{runs} recherches l’une après l’autre, jusqu’à {per} crédits chacune — jusqu’à {n} crédits au total pour jusqu’à {leads} entreprises ; seules les entreprises réellement livrées comptent, le plan s’arrête après un résultat maigre',
  'agent.cost.connectBatch':
    'jusqu’à {n} crédits — interlocuteurs (nom, fonction, e-mail, téléphone) de {count} entreprises à partir de sources publiques ; une entreprise sans contact joignable n’est pas facturée',
  'agent.cost.pitchBatch':
    'jusqu’à {n} crédits — plans de prospection (recherche + premier message prêt à envoyer) pour {count} entreprises',
  'agent.sessions.history': 'Historique',
  'agent.sessions.close': 'Fermer',
  'agent.time.now': "à l'instant",
  'agent.time.min': 'il y a {n} min',
  'agent.time.hour': 'il y a {n} h',
  'agent.time.day': 'il y a {n} j',
  // ── Live-Fortschrittskarte (LEA-435) ──
  'agent.run.running': 'Recherche en cours',
  'agent.run.finalizing': 'Finalisation — presque terminé …',
  'agent.run.preparing': 'Préparation de la recherche …',
  'agent.run.done': 'Recherche terminée',
  'agent.run.failed': 'Recherche échouée',
  'agent.run.cancelled': 'Recherche annulée',
  'agent.run.delivered': '{n} / {total} entreprises livrées',
  'agent.run.reviewCta': 'Consulter les leads',
  'agent.run.dismiss': 'Masquer',
  'agent.run.step.planning': 'Planification',
  'agent.run.step.discovery': 'Découverte',
  'agent.run.step.hydration': 'Enrichissement',
  'agent.run.step.reasoning': 'Évaluation',
  'agent.run.step.delivery': 'Livraison',
  'agent.run.won': '{n} leads tout frais pour vous !',
  'agent.run.empty': 'Aucune entreprise correspondante trouvée',
  'agent.rescue.head.zero': "Cette recherche n'a trouvé aucune entreprise correspondante.",
  'agent.rescue.head.lowOne':
    "Cette recherche n'a trouvé qu'une seule entreprise correspondante — vous pouvez déjà la consulter.",
  'agent.rescue.head.low':
    "Cette recherche n'a trouvé que {n} entreprises correspondantes — vous pouvez déjà les consulter.",
  'agent.rescue.cause.ours':
    "C'était de notre côté, pas votre cible : la recherche ne s'est pas déroulée correctement pour des raisons techniques.",
  'agent.rescue.cause.oursQualifier':
    "C'était de notre côté, pas votre cible : notre étape de vérification était indisponible pendant la recherche, les entreprises trouvées n'ont donc pas été évaluées.",
  'agent.rescue.cause.fewFound':
    "Dans la zone de recherche ({area}), nous n'avons trouvé que peu d'entreprises correspondant à votre description. Cela en dit plus sur notre portée dans cette zone que sur votre marché.",
  'agent.rescue.cause.harvested':
    "Vous connaissez déjà les entreprises trouvées : elles vous ont été livrées lors de recherches précédentes ou figurent sur votre liste d'entreprises connues.",
  'agent.rescue.cause.harvestedLow':
    "Vous connaissez déjà les autres entreprises trouvées : elles vous ont été livrées lors de recherches précédentes ou figurent sur votre liste d'entreprises connues.",
  'agent.rescue.cause.tooBroad':
    'Votre cible ne mentionne aucun secteur précis. Sans secteur, la recherche ne sait pas quelles entreprises examiner.',
  'agent.rescue.cause.filtered':
    'Nous avons trouvé des entreprises, mais aucune ne remplissait vos critères (secteur, taille ou région).',
  'agent.rescue.cause.filteredLow':
    'Les autres entreprises que nous avons trouvées ne remplissaient pas vos critères (secteur, taille ou région).',
  'agent.rescue.cause.unknown': "Nous n'avons pas pu déterminer avec certitude la raison.",
  'agent.rescue.freeRule':
    "Les recherches infructueuses ne coûtent jamais rien : sans entreprise livrée, rien n'est facturé. Et la nouvelle tentative ne compte pas comme une recherche supplémentaire.",
  'agent.rescue.pick': 'Ma proposition — un clic lance la nouvelle recherche :',
  'agent.rescue.noOption.tooBroad':
    'Indiquez-moi un secteur ou un métier précis, et nous affinerons la cible ensemble.',
  'agent.rescue.noOption.wide':
    "La zone de recherche est déjà aussi large que possible — une nouvelle tentative avec les mêmes critères n'apporterait probablement rien de nouveau.",
  'agent.rescue.thin.zero':
    "La deuxième tentative n'a pas non plus trouvé d'entreprise correspondante. Cela indique qu'il existe très peu d'entreprises trouvables publiquement pour cette combinaison — une autre tentative avec les mêmes critères n'y changerait rien.",
  'agent.rescue.thin.low':
    "La deuxième tentative n'a presque rien trouvé non plus ({n} livrées). Cela indique qu'il existe peu d'entreprises trouvables publiquement pour cette combinaison — une autre tentative avec les mêmes critères n'y changerait rien.",
  'agent.rescue.thin.next':
    'Un autre angle serait plus judicieux — par exemple un secteur voisin ou une autre région.',
  'agent.rescue.opt.same': 'Relancer la même recherche',
  'agent.rescue.opt.widen': 'Élargir la zone : {area} (au lieu de {from} seulement)',
  'agent.rescue.opt.dach': 'Élargir la zone : Allemagne, Autriche et Suisse',
  'agent.rescue.opt.dachFrom':
    'Élargir la zone : Allemagne, Autriche et Suisse (au lieu de {from} seulement)',
  'agent.rescue.opt.industry': 'Relancer avec le secteur « {industry} »',
  'agent.rescue.chip.market': 'Essayons « {market} » comme cible',
  'agent.rescue.chip.rethink': 'Aidez-moi à repenser la cible',
  'agent.rescue.unavailable': "Cette deuxième tentative n'est plus disponible",
  'agent.rescue.card.note':
    'Ne compte pas comme une recherche supplémentaire — comme toujours, seules les entreprises livrées sont facturées',
  'agent.rescue.card.noteFree':
    'Deuxième tentative gratuite — ne compte pas comme une recherche supplémentaire',
  'agent.rescue.oursRetryLater':
    'Réessayez dans quelques minutes — les entreprises non livrées ne sont jamais facturées.',
  'agent.rescue.card.used': 'Lancée',
  'agent.rescue.card.aria': 'Propositions pour une deuxième tentative',
  'agent.rescue.preparing': "Je regarde ce qui n'a pas fonctionné …",
  // ── Momentum-Leiste (LEA-435) ──
  'agent.momentum.label': 'Votre élan',
  'agent.momentum.audiences': 'Audiences',
  'agent.momentum.searches': 'Recherches',
  'agent.momentum.leads': 'Leads',
  'agent.momentum.contacts': 'Contacts',
  'agent.momentum.pitches': 'Outreach',
  // ── Lead-Bewert-Deck (LEA-435) ──
  'agent.leads.title': 'Vos leads — lesquels correspondent ?',
  'agent.leads.rated': '{done}/{total} évalués',
  'agent.leads.accept': 'Ça correspond',
  'agent.leads.reject': 'Ne correspond pas',
  'agent.leads.accepted': 'Ça correspond',
  'agent.leads.rejected': 'Ne correspond pas',
  'agent.leads.contacts': '{n} contacts',
  'agent.leads.openAll': 'Tout voir en détail',
  'agent.leads.done': 'Bien joué — tous évalués ! Cela affine votre prochaine recherche.',
  'agent.leads.chainConnect': '→ Trouver les décideurs pour vos résultats ({n})',
  'agent.leads.chainMsg': 'Trouve les contacts pour : {names}. (leadIds: {ids})',
  // ── Erfolgs-Puls (LEA-435) ──
  'agent.pulse.hitRate': 'Taux de réussite {pct}%',
  'agent.pulse.rising': 'augmente',
  'agent.pulse.detail': '{accepted} sur {rated} leads correspondent · {profiles} audiences',
  'agent.pulse.nudge':
    "Évaluez vos leads avec 👍/👎 — j'apprends ainsi votre taux de réussite et je m'améliore à chaque recherche.",
  // ── Aktions-Chips (LEA-435) ──
  'agent.chip.confirmDraft': 'Oui, créer ainsi',
  'agent.chip.adjustDraft': 'Affiner le ciblage',
  'agent.chip.startRun': 'Lancer la recherche',
  'agent.chip.reviewLeads': 'Consulter les leads',
  'agent.chip.msg.confirmDraft': 'Oui, crée le profil exactement comme ça.',
  'agent.chip.msg.adjustDraft': 'Je voudrais encore ajuster le ciblage.',
  'agent.chip.msg.startRun': 'Lance maintenant la recherche pour ce profil.',
  'agent.chip.msg.startRunNamed': 'Lance maintenant la recherche pour la cible « {name} ».',
  'agent.chip.msg.reviewLeads': 'Voyons les leads livrés.',
  // ── Editierbare Firmen-Karte (#122, 2026-06-02) ──
  'common.remove': 'Supprimer',
  'dash.cortex.editHint':
    'Supprimez des chips avec × ou ajoutez-en : Leadscraper cible ainsi votre offre plus précisément (max. 8 par colonne).',
  'dash.cortex.descLabel': 'Description',
  'dash.cortex.changeUrl': 'Analyser un autre site',
  'dash.cortex.editSaved': "Profil d'entreprise mis à jour",
  'dash.cortex.addPlaceholder': 'ajouter…',
  'dash.cortex.capReached': 'Max. 8 atteint',
  'pd.target.edit': 'Redécrire',
  'pd.target.editHint':
    'Décris tes clients idéaux en 1–2 phrases. Leadscraper en redéduit secteur, région et interlocuteur.',
  'pd.target.editPlaceholder':
    "p.ex. fabricants d'emballages, à l'échelle nationale, 50–250 employés, direction",
  'pd.target.reparsing': 'Leadscraper réfléchit …',
  'pd.target.saved': 'Audience mise à jour',
  'pd.target.saveError': 'Échec de la mise à jour : réessaie.',

  // W21/W22 Dossier — page cible comme dossier auto-rédigé
  // (Claude-Design-Handover 03.07.2026). Zone 1 : carte dossier.
  'dos.eyebrow': 'Ta cible · rédigée par toi et Leadscraper',
  'dos.maturity.coldStart': 'Fait connaissance avec toi',
  'dos.maturity.early': 'Premier aperçu',
  'dos.maturity.calibrated': 'Calibré',
  'dos.maturity.mature': 'Mature',
  'dos.ratings': '{n} évaluations',
  'dos.matchRate': '{pct} % de taux de correspondance',
  'dos.weak': 'faible',
  'dos.edit.cta': 'Modifier la cible',
  'dos.weave.youSearch': 'Tu recherches',
  'dos.weave.vorgabeLabel': 'Ton critère · issu de ton briefing',
  'dos.weave.withSize': 'avec {size} salariés',
  'dos.weave.sizeValue': '{range} salariés',
  'dos.weave.inRegion': 'en {region}',
  'dos.weave.contact': 'interlocuteur',
  'dos.weave.prefers': 'de préférence',
  'dos.weave.and': 'et',
  'dos.weave.weakHint': 'premier indice :',
  'dos.legend.you': 'ton critère',
  'dos.legend.learned': 'appris, le chiffre = preuves, cliquable',
  'dos.legend.weak': 'faible (1–2 preuves)',
  'dos.emptyLearned':
    "Rien appris pour l'instant : évalue tes premiers leads ci-dessous, et ce dossier continuera de s'écrire tout seul.",
  'dos.heartbeat.active': 'Apprentissage actif',
  'dos.heartbeat.waiting': 'En attente de tes premières évaluations',
  'dos.heartbeat.since': 'depuis {date}',
  'dos.heartbeat.next': 'prochaine analyse à {n} évaluations',
  'dos.proof.title': 'Tes {n} entreprises acceptées',
  'dos.proof.openAll': 'Tout voir dans le board',
  'dos.error.learn': 'Les données d’apprentissage sont momentanément indisponibles.',
  'dos.error.retry': 'Réessayer',
  'dos.details.show': 'Tous les {n} modèles en détail ↓',
  'dos.details.hide': 'Masquer les détails',
  'dos.aside.patterns': 'Motifs en détail',
  'dos.kpi.title': 'Ton audience en chiffres',
  'dos.kpi.match': 'Réussite',
  'dos.kpi.reachable': 'Joignables',
  'dos.kpi.reachableSub': '{n} sur {m} demandes',
  'dos.kpi.reachableTeaser': 'Dès la première demande de contact',
  'dos.kpi.yield': 'Par recherche',
  'dos.kpi.yieldSub': '{n} recherches',
  'dos.kpi.matchTeaser': 'dès {p} évaluations',
  'dos.journey.eyebrow': 'Comment ton dossier prend forme',
  'dos.journey.s1': 'Audience décrite',
  'dos.journey.s1Sub': 'Bien enregistrée : Leadscraper sait quoi chercher.',
  'dos.journey.s2': 'Reçois tes premiers leads',
  'dos.journey.s2Sub':
    'Lance ta première recherche : les premières entreprises arrivent en quelques minutes.',
  'dos.journey.s2Done': '{n} leads sont prêts.',
  'dos.journey.s2Running':
    'Ta recherche est en cours : les premières entreprises arrivent sous peu.',
  'dos.journey.s2RunningBadge': 'Recherche en cours · généralement 5–12 min',
  'dos.journey.s3': 'Évalue tes {p} premiers leads',
  'dos.journey.s3Progress': '{n} sur {p} leads évalués',
  'dos.journey.s3Sub':
    'À {p} évaluations, Leadscraper rédige ici sa première analyse, dès {a}, ton feedback guide chaque recherche.',
  'dos.voice.preview':
    'Après tes {p} premières évaluations, Leadscraper rédigera ici son analyse de ton audience.',
  'dos.voice.more': 'Lire la suite',
  'dos.voice.less': 'Réduire',
  'dos.analysis.pending':
    'Leadscraper analyse tes {n} évaluations : la première analyse de ton audience apparaîtra ici sous peu.',
  'dos.heartbeat.analysing': 'Analyse de tes évaluations …',
  // Dossier — popover de preuve
  'dos.popover.close': 'Fermer',
  'dos.popover.evidence': '{n} preuves',
  'dos.popover.weakChip': 'faible · {n} preuves',
  'dos.popover.view': 'voir ↗',
  'dos.popover.noExamples':
    'Aucun lead-preuve individuel enregistré pour ce modèle : le chiffre compte tes évaluations.',
  'dos.popover.weakNote': 'Seulement {n} preuves, encore intégré avec prudence dans la recherche.',
  // Dossier — zone 2 : évaluer maintenant
  'dos.rate.eyebrow': 'Évaluer maintenant',
  'dos.rate.waiting': '{n} leads attendent ton verdict',
  'dos.rate.waitingOne': '1 lead attend ton verdict',
  'dos.rate.openBoard': 'Tout ouvrir dans le tableau →',
  'dos.rate.sub': 'Chaque évaluation affine le dossier, directement ici, sans quitter la page.',
  'dos.rate.fits': 'Correspond à ma cible',
  'dos.rate.fitsNot': 'Ne correspond pas',
  'dos.rate.view': 'voir',
  'dos.rate.acceptedCheck': '✓ Accepté',
  'dos.rate.learned': '· le dossier a appris :',
  'dos.rate.flowsIn': '· intégré à la prochaine analyse.',
  'dos.rate.undo': 'Annuler',
  'dos.rate.whyQuestion':
    "Qu'est-ce qui n'allait pas ? Un mot suffit : Leadscraper en tire les leçons.",
  'dos.rate.noReason': 'Continuer sans raison',
  'dos.rate.allDone':
    'Tout est évalué : de nouveaux leads apparaîtront ici dès qu’une recherche en livrera.',
  'dos.rate.rejectedCheck': '✗ Écarté',
  'dos.rate.avoidedLearned': ', le dossier évite désormais :',
  'dos.reason.industry': 'Mauvais secteur',
  'dos.reason.tooBig': 'Trop grande',
  'dos.reason.tooSmall': 'Trop petite',
  'dos.reason.region': 'Mauvaise région',
  'dos.reason.role': 'Mauvais rôle',
  'dos.reason.other': 'Autre',
  // Dossier — zone 3 : prochaines recherches
  'dos.sug.eyebrow': 'Déduit de tes modèles',
  'dos.sug.title': 'Tes prochaines recherches',
  'dos.sug.basis.expansion': 'Extension',
  'dos.sug.basis.crossSell': 'Vente croisée',
  'dos.sug.basis.zoomOut': 'Zoom arrière',
  'dos.sug.basis.patternHint': 'Indice de modèle',
  'dos.sug.basis.salesFit': 'Adéquation commerciale',
  'dos.sug.tier.veryStrong': 'très forte',
  'dos.sug.tier.strong': 'forte',
  'dos.sug.tier.solid': 'solide',
  'dos.sug.tier.hypothesis': 'faible',
  'dos.sug.fitLabel': 'adéquation attendue',
  'dos.sug.start': 'Lancer la recherche',
  'dos.sug.history': '{n} recherches précédentes',
  'dos.sug.historyOne': '1 recherche précédente',
  'dos.sug.showHistory': "Voir l'historique →",

  'common.close': 'Fermer',
  'common.selected': 'Sélectionné',
  'credit.balanceTitle': 'Ton solde de crédits',
  'credit.available': 'disponibles',
  'det.trigger.cat.serviceRadius': 'Zone de service',
  'det.trigger.cat.specialization': 'Spécialisation',
  'det.trigger.cat.capacity': 'Capacité',
  'det.trigger.cat.history': 'Historique',
  'det.trigger.cat.partnership': 'Partenariat',
  'det.trigger.cat.certification': 'Certification',
  'det.trigger.cat.other': 'Autre',
  'lead.removeContactTitle': 'Pourquoi supprimer ?',
  'lead.actionNeedPlan': "Génère d'abord un plan d'acquisition",
  'lead.actionNoEmail': 'Aucune adresse e-mail pour le contact prioritaire',
  // scraper run experience + API errors (LEA-302) — see de.ts for context
  'scraper.act.loadProfile': 'Chargement de ton profil + évaluations précédentes…',
  'scraper.act.firstFeedbacks':
    "Collecte des premières évaluations : à partir de 10, Cortex apprend tes modèles d'acceptation/rejet.",
  'scraper.act.feedbacksCollected':
    '{seen} évaluations collectées : la personnalisation sera active à partir de {activeAt} évaluations par profil. Cette recherche fonctionne encore sans override des modèles.',
  'scraper.act.patternsActive':
    "{seen} évaluations · {accepted} modèles d'acceptation · {rejected} modèles de rejet actifs dans le raisonnement",
  'scraper.act.planning':
    'Planification de la stratégie de recherche : quelles sources et requêtes couvrent le mieux ta demande ?',
  'scraper.act.aiSearchTempError':
    'La recherche IA a rencontré un problème temporaire (réseau/timeout). Veuillez réessayer.',
  'scraper.act.aiSearchUnavailable':
    'Recherche IA actuellement indisponible (problème de configuration). Contactez le support.',
  'scraper.act.aiSearchBadFormat':
    'La recherche IA a retourné un format invalide. Veuillez réessayer.',
  'scraper.act.aiSearchFailed': 'Échec de la recherche IA ({reason}). Veuillez réessayer.',
  'scraper.act.reasonUnknown': 'inconnue',
  'scraper.act.researcherAnalyzing': "L'IA-Researcher analyse votre requête de recherche…",
  'scraper.act.researcherFound': 'IA-Researcher : {n} entreprises vérifiées identifiées',
  'scraper.act.goal': 'Objectif : {goal}',
  'scraper.act.strategy': 'Stratégie : {strategy}',
  'scraper.act.reasoning': 'Raisonnement : {reasoning}',
  'scraper.act.srcCurated': '⭐ Source curée',
  'scraper.act.srcOwn': '💡 Proposition propre',
  'scraper.act.srcKindRegister': 'Registre',
  'scraper.act.srcKindDirectory': 'Répertoire',
  'scraper.act.srcKindPortal': 'Portail',
  'scraper.act.source': '{tag} : {label} [{kind}]',
  'scraper.act.googleSearch': 'Recherche Google : « {q} »',
  'scraper.act.googleMaps': 'Google Maps : « {q} »{location}',
  'scraper.act.googleNews': 'Google News : « {q} »',
  'scraper.act.researcherEnough':
    "L'IA-Researcher suffit ({n} entreprises) : ignore les recherches Google supplémentaires",
  'scraper.act.researcherIdentified':
    "L'IA-Researcher a identifié {n} entreprises : ignore les recherches Google",
  'scraper.act.researcherNone':
    "L'IA-Researcher n'a trouvé aucune entreprise correspondante : la requête est très niche. Essayez avec un profil plus large ou une région moins spécifique.",
  'scraper.act.companyIdentified': 'Entreprise identifiée : {name} ({i}/{total})',
  'scraper.act.enrichBasics':
    'Enrichissement de {n} entreprises avec les données de base (adresse, taille, stack tech)...',
  'scraper.act.enrichCompany': "Enrichissement de l'entreprise {idx}/{total} : {domain}",
  'scraper.act.phase1Light':
    "Phase-1-Light : {n} entreprises identifiées en {secs}s. L'adresse/taille/détails seront scrapés si nécessaire.",
  'scraper.act.serperExhausted':
    '⚠ Credits Serper épuisés, Discovery limitée. Rechargez sur serper.dev/dashboard.',
  'scraper.act.mapsHits': '{n} résultats Maps pour « {query} »',
  'scraper.act.searchHitsCollected': '{n} résultats collectés depuis la recherche Google',
  'scraper.act.directoriesFound':
    '{n} répertoires sectoriels trouvés, extraction des entreprises listées…',
  'scraper.act.searchingPortal': 'Recherche sur {host} des entreprises listées…',
  'scraper.act.minedCompanies': '{n} entreprises extraites de {portal}',
  'scraper.act.onlyPortals':
    'Aucune entreprise opérationnelle identifiée : tous les résultats étaient des portails',
  'scraper.act.queryInfeasible': 'Cortex considère la requête comme non réalisable : {reason}',
  'scraper.act.rethinking': 'Cortex réfléchit à nouveau (round {round}) : {reason}',
  'scraper.act.searchingPortalNew': 'Recherche sur {host} (nouvelle étape de plan)…',
  'scraper.act.minedPortalRound': '{n} entreprises de {host} (round réflecteur {round})',
  'scraper.act.backlogResumed': '{n} candidats en backlog repris des runs précédents',
  'scraper.act.companiesIdentifiedAgg':
    "{n} entreprises identifiées, {rescued}/{attempted} sauvées des portails agrégateurs, début de l'analyse approfondie",
  'scraper.act.companiesIdentified': "{n} entreprises identifiées, début de l'analyse approfondie",
  'scraper.act.handelsregisterChecked': 'Extrait du registre du commerce vérifié : {hrb}',
  'scraper.act.scanningWebsite': 'Analyse du site web : {domain}',
  'scraper.act.relatedPages': '{n} pages supplémentaires analysées : {domain}',
  'scraper.act.deepAnalysis': "Analyse approfondie de l'entreprise : {name}",
  'scraper.act.pipelineStarted':
    "Pipeline démarrée : {n} candidats passent en parallèle par l'hydratation + évaluation",
  'scraper.act.allDroppedPrefilter':
    'Toutes les {n} entreprises trouvées ont été rejetées comme non-pertinentes (secteur/région). Précisez votre groupe cible ou essayez une autre région.',
  'scraper.act.noCompaniesFound':
    "La découverte n'a trouvé aucune entreprise pour cette recherche. Précisez votre groupe cible.",
  'scraper.act.phase1OnlyRun':
    'Exécution Phase-1 uniquement : {n} Leads identifiés. Les phases 2 + 3 ont été ignorées.',
  'scraper.act.leadsDeliveredEnriching':
    "{n} Leads livrés : Cortex enrichit encore (plan d'acquisition, scores, recherche approfondie)",
  'scraper.act.deeperResearch':
    'Recherche approfondie : {name}, {findings} à partir de {sources} sources',
  'scraper.act.coldStart': 'Démarrage à froid (aucune exécution précédente)',
  'scraper.act.runHistory':
    '{runs} exécutions précédentes · {delivered} déjà livrés · {dropped} déjà rejetés',
  'scraper.act.buyerProfile': 'Profil acheteur : {narrative} (Confiance : {confidence})',
  'scraper.act.confHigh': 'élevée',
  'scraper.act.confMid': 'moyenne',
  'scraper.act.confLow': 'faible',
  'scraper.act.subsidiary':
    'Filiale DACH détectée : {domain} ({src}), utilisée pour la recherche de contacts.',
  'scraper.act.subsidiarySrcDirect': 'vérifiée directement',
  'scraper.act.subsidiarySrcGoogle': 'via recherche Google',
  'scraper.rq.harvestedMsg':
    'Groupe cible temporairement épuisé : les recherches précédentes ont déjà livré {prior} entreprises pertinentes.',
  'scraper.rq.harvestedRec':
    'Cortex a déjà trouvé les entreprises connues. De nouveaux résultats apparaîtront quand de nouvelles entreprises de votre groupe cible deviendront visibles en ligne. La planification les détectera automatiquement.',
  'scraper.rq.noMarketMsg':
    "Seulement {n} entreprises trouvées sur tout le web pour cette recherche. Ce groupe cible ne semble pas être publiquement détectable, peut-être trop spécialisé ou données internes d'entreprise.",
  'scraper.rq.noMarketRec':
    'Essayez de formuler plus largement ou combinez avec des secteurs similaires. La planification ne vaut pas la peine pour cette requête.',
  'scraper.rq.tooNicheMsg':
    'Seulement {n} entreprises potentielles sur le marché : votre groupe cible est très niche.',
  'scraper.rq.tooNicheRec':
    "La planification ne vaut la peine qu'avec des groupes cibles de 50+ entreprises. Considérez une région plus large ou plus de variantes sectorielles.",
  'scraper.rq.qualifierDownMsg':
    "L'évaluation par IA était indisponible pendant cette recherche : les {n} entreprises trouvées n'ont donc pas pu être évaluées. C'est un problème technique de notre côté, pas un verdict sur votre marché.",
  'scraper.rq.qualifierDownRec':
    "Relancez la recherche dans quelques minutes. Inutile de modifier vos critères : aucune entreprise n'a réellement été évaluée cette fois-ci.",
  'scraper.rq.unmatchedMsg':
    '{n} entreprises analysées : aucune ne correspondait à vos critères (secteur, taille, région).',
  'scraper.rq.unmatchedRec':
    "Vérifiez la description : critères trop stricts ? L'acceptation de similaires n'aide pas car aucun similaire n'était plausible.",
  'scraper.sum.delivered':
    '{n} Leads livrés ({hard} certains{softFrag}) sur {total} entreprises analysées.',
  'scraper.sum.softFragment': ', {soft} possiblement pertinents',
  'scraper.sum.deliveredNiche':
    '{n}/10 Leads livrés : le groupe cible est niche (seulement {total} entreprises identifiées sur le marché).',
  'scraper.sum.nicheRec':
    'Normal avec une planification récurrente. De nouveaux résultats apparaissent avec le temps. Si vous avez besoin de plus de volume : considérez une région plus large ou des secteurs connexes.',
  'scraper.sum.deliveredDropped':
    '{n}/10 Leads livrés : Cortex a rejeté {dropped} autres candidats comme non-pertinents.',
  'scraper.sum.droppedRec':
    'Si vous voulez plus de volume : formulez la description de manière plus souple ou acceptez les similaires/conservations douces.',
  'scraper.sum.deliveredMixed': '{n}/10 Leads livrés : rendement mixte sur {total} entreprises.',
  'scraper.sum.mixedRec':
    "Normal avec une planification récurrente : Cortex collecte d'autres résultats avec le temps.",
  'scraper.sum.noneMatched':
    '{total} entreprises analysées : aucune ne correspondait à vos critères.',
  'scraper.sum.noneMatchedRec':
    'Vérifiez la description : critères trop stricts ou essayez une autre région.',
  'scraper.mem.active': 'Personnalisation active · {n} évaluations',
  'scraper.mem.analyzing': 'Nouvelle analyse en cours · {n} évaluations',
  'scraper.mem.firstImpression': "Première impression · {n}/{active} jusqu'à actif",
  'scraper.mem.learning': "Apprend avec vous · {n}/{preview} jusqu'à aperçu",
  'scraper.reflector.fallback':
    "Réflecteur non disponible : requête signalée comme non-faisable pour éviter que l'utilisateur attende indéfiniment.",
  // LEA-543: Zielgruppe sind Privatpersonen — Leadscraper findet nur Unternehmen.
  // Server-seitig lokalisiert via tForLang, zusammen unter 240 Zeichen (die
  // Fehler-Antwort wird im Client bei 300 Zeichen abgeschnitten).
  'apierr.b2cOnly':
    'Leadscraper trouve des entreprises et les décideurs qui y travaillent — nous ne fournissons pas de particuliers.',
  'apierr.b2cPivot': 'Une alternative possible : {pivot}',
  'apierr.junkQuery':
    'Veuillez décrire concrètement QUI vous recherchez : par ex. "Boulangeries à Hambourg" ou "Conseillers fiscaux NRW 5-50 employés". Les termes génériques comme "B2B", "Test", "Profil" ou les textes avec fautes de frappe ne sont pas acceptés.',
  'apierr.invalidWebsite': 'Veuillez saisir un site web valide (par ex. mon-entreprise.fr)',
  'apierr.noUserCompanyStep1': "Analysez d'abord le site web (étape 1).",
  'apierr.noUserCompany': "Analysez d'abord le site web.",
  'apierr.insufficientPhase':
    'Vous avez besoin de {cost} Credit(s) pour cette phase. Actuellement : {credits}.',
  // LEA-704: reveal-model pricing (Om QA 26.10.).
  'apierr.pitchRequiresReveal':
    "Déverrouillez d'abord les contacts de cette entreprise — le plan de prospection est inclus.",
  'apierr.planGenFailed': "Le plan d'acquisition n'a pas pu être généré. Aucun Credit consommé.",
  'apierr.urlParse': "L'URL n'a pas pu être analysée.",
  'apierr.urlIncomplete': 'Veuillez fournir une URL complète.',
  'apierr.dupCompany': 'Vous avez déjà créé cette entreprise{nameSuffix}.',
  'apierr.dupCompanySuffix': ' ({name})',
  'apierr.manualUnreachable':
    "Le site web n'était pas accessible lors de la création : les données n'ont pas pu être récupérées.",
  'apierr.manualPhase1Failed':
    'Phase 1 échouée (site web inaccessible). Réessayez via "Actualiser les données".',
  'apierr.cancelRequested':
    'Annulation demandée. Sera prise en compte au prochain point de contrôle.',
  'apierr.noCredits':
    'Aucun Credits disponibles. Veuillez souscrire un abonnement ou acheter des Credits.',
  'apierr.rescueNotAvailable':
    "La deuxième tentative gratuite pour cette recherche n'est pas (ou plus) disponible.",
  'apierr.intentParse':
    'Impossible d\'extraire un secteur concret de votre description "{desc}". Veuillez préciser : par exemple au lieu de "Paris" → "Boulangeries à Paris" ou "Comptables à Paris".',
  // i18n localization batch (LeadDetail / acquisition plan)
  'det.acquisitionPlan': "Plan d'acquisition",
  'det.creatingPlan': "Cortex crée votre plan d'acquisition…",
  'det.planLoadTime':
    "Généralement 30 à 60 secondes, aucun rechargement nécessaire, s'affiche automatiquement",
  'det.planUncertaintyWarning': 'Remarque : le texte du plan contient des incertitudes',
  'det.companyClassification': "Classification de l'entreprise",
  'det.opportunities': 'Opportunités',
  'det.risksAndDealbreakers': 'Risques / facteurs rédhibitoires',
  'det.channelMix': 'Mix de canaux · séquence sur 7 jours',
  'ld.sparkle.sampleMessageLabel': "Message d'exemple pour le premier contact",
  'ld.sparkle.sampleMessageCopied': "Message d'exemple copié.",
  'common.copy': 'copier',
  'ld.sparkle.messageSubject': 'Objet : ',
  'ld.lean.urteil': 'Pourquoi ce lead',
  'ld.lean.winkel': 'Ton angle',
  'ld.lean.kontakte': 'Qui en premier',
  'ld.lean.nachricht': 'Premier contact, prêt à envoyer',
  'ld.lean.nachrichtShort': 'Brouillon de premier contact',
  'ld.lean.telefon': 'Accroche téléphonique',
  'ld.lean.check': 'Avant d’envoyer',
  'ld.lean.copyAI': 'Copier pour l’IA',
  'ld.lean.copyAITitle':
    'Copie le plan, les données publiques de l’entreprise et des contacts ainsi que ton profil d’offre comme handover pour ChatGPT, Claude & co.',
  'ld.lean.copiedAI': 'Handover copié : colle-le dans ton outil d’IA',
  'ld.lean.varMain': 'Recommandée',
  'ld.lean.sendMail': 'Envoyer par e-mail',
  'ld.lean.sendMailTitle':
    'Ouvre ton logiciel de messagerie avec {addr}, objet et texte préremplis',
  'ld.lean.zentrale': 'Standard',
  'ld.lean.nameNotPublic': 'nom non public',
  'ld.lean.verifiziert': 'vérifié',
  'ld.lean.chEmail': 'E-mail',
  'ld.lean.chTelefon': 'Téléphone',
  'ld.lean.chLinkedIn': 'LinkedIn',
  'ld.lean.chXing': 'Xing',
  'ld.ai.instructions':
    'Tu es mon copilote commercial pour ce lead précis. Ci-dessous, toutes les données que mon outil (Leadscraper) a recherchées dans des sources publiques et préparées en plan d’acquisition : utilise-les directement, ne les demande pas d’abord.\n\nMarqueurs : ✓ = vérifié publiquement (site, mentions légales, LinkedIn, registre), ~ = hypothèse sans source solide. Garde cette distinction et n’invente rien sur l’entreprise ni sur le contact.\n\nTu peux m’aider à affiner le message de premier contact, construire un script d’appel, préparer les objections ou le suivi.',
  'ld.ai.secLead': 'Lead',
  'ld.ai.secData': 'Données disponibles',
  'ld.ai.secContacts': 'Contacts',
  'ld.ai.secCompany': 'Mon entreprise',
  'ld.ai.secPlan': 'Plan d’acquisition',
  'ld.ai.secUncertain': 'Incertitudes & à vérifier',
  'ld.ai.secTask': 'Ce que j’attends de toi',
  'ld.ai.taskBody':
    'Commence tout de suite : affine le message de premier contact ci-dessus dans mon ton et propose UNE amélioration concrète qui augmente mon taux de réponse.',
  'ld.ai.company': 'Entreprise',
  'ld.ai.industry': 'Secteur',
  'ld.ai.size': 'Taille',
  'ld.ai.region': 'Région',
  'ld.ai.dataAsOf': 'Données au : recherché le {date}',
  'det.recommendedNextStep': 'Prochaine étape recommandée',
  'det.botProtectionWarning':
    "Ce site web avait une protection anti-bots active. Nous n'avons pas pu explorer directement la page de mentions légales/contact. Les données affichées ici proviennent de sources publiques (Google, annuaires professionnels) et peuvent être moins précises que les données directes des mentions légales.",
  'det.possibleNotVerified': 'Possible, non vérifiable à 100 %',
  'det.noJustificationYet':
    "Pas encore de justification : pour ce lead, l'appariement acheteur n'a pas pu être exécuté (profil utilisateur incomplet ou site web inaccessible). Lancer les phases 2/3 récupérera plus de données.",
  'det.offering': 'Offre',
  'det.nicheSignals': 'Signaux de niche',
  'det.niche.signalsOne': '1 signal',
  'det.niche.signalsMany': '{n} signaux',
  'det.vatId': 'N° TVA : ',
  'det.revenue': "Chiffre d'affaires ",
  'det.agency': 'Agence',
  'det.distributor': 'Distributeur',
  'det.stack': 'Stack :',
  'det.webDesign': 'Conception web :',
  'det.masteryBusiness': 'Entreprise certifiée maître artisan',
  'det.guild': 'Corporation : ',
  'det.imprintVerified': '✓ Mentions légales vérifiées',
  'det.sealsOfQuality': 'Labels de qualité :',
  'det.social': 'Réseaux :',
  'det.verifyingContacts': 'Vérification des contacts…',
  'det.inferringPattern': 'Déduction du modèle…',
  'det.emailPatternPlaceholder': '{prenom}.{nom}@entreprise.de',
  'det.sales': 'Commercial',
  'det.marketing': 'Marketing',
  'det.engineering': 'Technique',
  'det.finance': 'Finance',
  'det.management': 'Direction',
  'det.procurist': 'Fondé de pouvoir',
  'det.contactRemoved': 'supprimé, ne sera plus livré.',
  'det.percentSure': '% de certitude',
  'det.foundIn': 'trouvé dans :',
  'det.recommendedChannel': 'Canal recommandé',
  'det.tier1': 'Niveau 1 · joignable directement',
  'det.tier2': 'Niveau 2 · canal de profil',
  'det.tier3': 'Niveau 3 · via le siège',
  'det.tier4': 'Niveau 4 · contact de secours',
  'det.tier5': 'Niveau 5 · routage entreprise uniquement',
  'det.inferred': '⚠ supposé',
  'det.companyCentral': "(Siège de l'entreprise)",
  'det.quality.title': 'Qualité du lead',
  'det.quality.company': 'Entreprise',
  'det.quality.contact': 'Contact',
  'det.quality.noContacts':
    'Aucun décideur vérifiable publiquement pour cette entreprise : Leadscraper n’invente jamais de contacts.',
  'det.quality.companyFitPlain': 'Secteur, région et taille correspondent à ta recherche.',
  'det.quality.companyFitSoft':
    'Secteur et région correspondent, pas encore parfaitement net sur chaque critère.',
  'det.quality.noContactsCentral': 'Elle reste joignable via le standard (voir contact).',
  'det.quality.outreach': 'Outreach',
  'det.quality.lockedContactVerify': "Vérifiez d'abord le contact",
  'det.quality.lockedPlanCreate': "Créez d'abord le plan d'acquisition",
  'ld.sparkle.conversationOpener': 'Accroche de conversation',
  'ld.sparkle.openerCopied': 'Accroche copiée.',
  'lt.next.contactVerificationStarted': 'Vérification du contact lancée …',
  'lt.next.contactVerificationLabel': 'Vérification du contact',
  'lt.next.planGenerationStarted': "Génération du plan d'acquisition lancée …",
  'lt.next.planGenerationLabel': "Génération du plan d'acquisition",
  'lt.next.verifiedNoContacts': 'Vérifié, aucun contact trouvé',
  // LEA-379 i18n#5 (Om QA): lead-card loading status — these keys existed only in
  // de/en, so FR fell back to German. Copy is tweakable — flag Janik if off.
  'lt.loading.connecting': 'Recherche des contacts …',
  'lt.loading.planning': "Génération du plan d'acquisition …",
  'lt.loading.adding': 'Ajout …',
  'lt.loading.verifying': 'Vérification …',
  'lt.loading.connectingLive': 'Vérification des contacts …',
  'lt.loading.planningLive': "Création du plan d'acquisition …",
  'det.size.employees': 'employés',
  'det.since': 'depuis ',

  // ── Funnel Prism (extraction i18n Stage C, /dev/prism-demo) ──────────────
  // Général / bandeau
  'prism.kicker.account': 'Compte créé',
  'prism.kicker.waiting': 'Tes premiers clients t’attendent',
  'prism.audienceFallback': 'ta cible',
  // LEA-379 i18n#4 (Om QA): Stripe checkout line-item, localized per session lang.
  'billing.tripwire.lineItem.name': 'Leadscraper · Pack de démarrage 50 leads',
  'billing.tripwire.lineItem.desc': '50 leads vérifiés, prêts à contacter.',
  'prism.a11y.close': 'Fermer',
  // Étape 1 — Cible
  'prism.target.eyebrow': 'Étape 1 sur 3 · Cible',
  'prism.target.title': 'Qui veux-tu atteindre ?',
  'prism.target.titleGrad': 'On les trouve immédiatement.',
  'prism.target.sub':
    'Décris ta cible en une phrase : ta recherche en direct s’aligne exactement dessus.',
  'prism.target.label': 'Ta cible',
  'prism.target.placeholder': 'p. ex. dirigeants de cabinets comptables à Lyon',
  'prism.target.chip.steuer': 'Cabinets comptables à Lyon',
  'prism.target.chip.agentur': 'Agences marketing à Paris',
  'prism.target.chip.handwerk': 'Artisans du bâtiment à Nantes',
  'prism.target.chipQuery.steuer': 'Dirigeants de cabinets comptables à Lyon',
  'prism.target.chipQuery.agentur': 'Fondateurs d’agences marketing à Paris',
  'prism.target.chipQuery.handwerk': 'Artisans du bâtiment à Nantes',
  'prism.target.tip':
    '💡 Le plus efficace : secteur + région, p. ex. « dentistes à Bordeaux ». On comprend aussi les rôles comme « dirigeants de PME ».',
  'prism.target.suggestion': 'Tu veux dire p. ex. « {suggestion} » ?',
  'prism.target.validating': 'Vérification de ta cible…',
  'prism.target.cta': 'Trouver ma cible',
  'prism.target.foot': 'Gratuit · aucune donnée bancaire requise',
  'prism.target.errFallback': 'Ça ne ressemble pas encore à une cible.',
  // Étape 2 — Site web
  'prism.website.eyebrow': 'Étape 2 sur 3 · Site web',
  'prism.website.title': 'Ton site web ·',
  'prism.website.titleGrad': 'pour que l’IA te comprenne',
  'prism.website.sub':
    'Le site de ta propre entreprise, pour que nous comprenions ce que tu vends et quels clients te correspondent.',
  'prism.website.label': 'URL du site',
  'prism.website.placeholder': 'https://ton-entreprise.fr',
  'prism.website.hint':
    'Pas encore de site à toi ? Passe simplement cette étape. La recherche se fait alors uniquement sur ta cible.',
  'prism.website.errInvalid':
    'Ça ne ressemble pas encore à une adresse web : p. ex. « ton-entreprise.fr ».',
  'prism.website.cta': 'Analyser le site',
  'prism.website.foot': 'Analyse uniquement · rien n’est publié',
  // Phase d’analyse
  'prism.analyzing.reading': 'L’IA lit ton site web…',
  'prism.analyzing.wait': 'Ta cible est en cours d’affinage…',
  'prism.analyze.step1': 'Site chargé et lu en direct',
  'prism.analyze.step2': 'Modèle d’affaires identifié',
  'prism.analyze.step3': 'Offre et proposition de valeur analysées',
  'prism.analyze.step4': 'Cible idéale déduite',
  // Étape 3 — Questions
  'prism.questions.eyebrow': 'Dernière étape · Affinage',
  'prism.questions.back': '← Retour',
  'prism.questions.title': 'Confirme rapidement ·',
  'prism.questions.titleGrad': 'question {num} sur {total}',
  'prism.questions.q1': 'Quelle taille pour les entreprises ?',
  'prism.questions.q1o1': 'Jusqu’à 50 salariés',
  'prism.questions.q1o2': 'Plus de 50',
  'prism.questions.q1o3': 'Peu importe',
  'prism.questions.q2': 'Les entreprises doivent-elles être spécialisées ?',
  'prism.questions.q2o1': 'Oui, un segment',
  'prism.questions.q2o2': 'Généralistes',
  'prism.questions.q2o3': 'Peu importe',
  'prism.questions.q3': 'Où doivent-elles être situées ?',
  'prism.questions.q3o1': 'Ma région uniquement',
  'prism.questions.q3o2': 'Toute la France',
  'prism.questions.q3o3': 'Peu importe',
  'prism.questions.yes': 'Oui, exactement',
  'prism.questions.no': 'Pas vraiment',
  'prism.questions.foot': 'Plus ta réponse est précise, plus tes premiers leads seront ciblés.',
  // Phase de recherche
  'prism.searching.label': 'Entreprises trouvées dans ta cible…',
  // Wave 2: concrete/procedural so the endless rotation doesn't feel "stuck" —
  // 6 true process steps instead of 4.
  'prism.searching.wait1': 'Contrôle de la pertinence des résultats…',
  'prism.searching.wait2': 'Résultats faibles écartés…',
  'prism.searching.wait3': 'Recherche des doublons…',
  'prism.searching.wait4': 'Vérification de l’accessibilité des sites…',
  'prism.searching.wait5': 'Localisations recoupées…',
  'prism.searching.wait6': 'Fiches entreprises consolidées…',
  'prism.search.step1': 'Requêtes de recherche planifiées pour ta cible',
  'prism.search.step2': 'Entreprises collectées via la recherche web et cartographique',
  'prism.search.step3': 'Portails, annuaires et doublons écartés',
  'prism.search.step4': 'Adéquation des meilleurs résultats à ta cible évaluée',
  'prism.search.step5': 'Sites web des meilleurs résultats vérifiés en direct',
  'prism.search.step6': 'Région et type d’entreprise des meilleurs résultats recoupés',
  'prism.search.step7': 'Résultats faibles écartés',
  'prism.search.step8': 'Plausibilité du résultat contrôlée',
  'prism.search.step9': 'Meilleurs résultats compilés',
  'prism.search.n.companies': '{count} entreprises',
  'prism.search.n.ap': '{count} contacts',
  'prism.search.n.valid': '{count} valides',
  'prism.search.n.revenue': '~{count} M€',
  'prism.search.n.top': 'Top 50',
  // Labels de fit
  'prism.score.perfect': 'Fit parfait',
  'prism.score.outstanding': 'Fit exceptionnel',
  'prism.score.veryStrong': 'Fit très fort',
  'prism.score.good': 'Bon fit',
  'prism.score.titleAttr': 'Score de fit {score}/100',
  // Écran d’affinage (résultats faibles)
  'prism.refine.title': 'Pas encore assez de résultats : affinons ensemble.',
  'prism.refine.body':
    'Pour {audience}, nous n’avons pas encore trouvé assez d’entreprises convaincantes.',
  'prism.refine.hint1': 'Précise ta cible, idéalement',
  'prism.refine.hintStrong': 'secteur + région',
  'prism.refine.hint2':
    '(p. ex. « cabinets comptables à Lyon », « cabinets dentaires à Bordeaux », « entreprises du bâtiment à Nantes »). Plus c’est précis, plus nous trouvons de vraies entreprises pour toi.',
  'prism.refine.try': 'Celles-ci fonctionnent déjà bien, en un clic :',
  // F9: écran 429 — quota journalier, nommé honnêtement (pas un refine qualité).
  'prism.rateLimit.title': 'Tu as atteint ta limite quotidienne de recherches live.',
  'prism.rateLimit.body':
    'Cela n’a rien à voir avec ta cible — nous limitons les recherches live gratuites par jour. Ta cible et ton site restent enregistrés.',
  'prism.rateLimit.reset': 'Ton quota se réinitialise à {time}.',
  'prism.rateLimit.cta': 'Retour au début',
  // D2 (LEA-430) : reprise « content de te revoir » + alternative honnête au timer.
  'prism.resume.title': 'Content de te revoir !',
  'prism.resume.body': 'Ta recherche pour {audience} est terminée — ton résultat est enregistré.',
  'prism.resume.cta': 'Voir le résultat',
  'prism.resume.dismiss': 'Lancer une nouvelle recherche',
  'prism.resume.saved': 'Ta sélection est enregistrée — sans pression de temps.',
  'prism.understood.title': 'Ton entreprise, comprise',
  'prism.understood.opps': 'Opportunités',
  // Wave 2: label above the highlighted "why now" line.
  'prism.understood.momentumLabel': 'Pourquoi maintenant :',
  // DEPRECATED (Wave 2): "À surveiller" is no longer rendered (legacy bundles).
  'prism.understood.risks': 'À surveiller',
  'prism.understood.demoModel': 'Service B2B qui aide les PME à trouver de nouveaux clients.',
  'prism.understood.demoOpp1': 'Niche bien définie à forte valeur par client',
  'prism.understood.demoOpp2': 'Peu de concurrence spécialisée dans la région',
  'prism.understood.demoOpp3': 'Décideurs directement joignables (petites équipes)',
  'prism.understood.demoRisk1': 'Cycles de décision longs dans les PME',
  'prism.understood.demoRisk2': 'Le premier contact demande une accroche concrète',
  'prism.seed.badge': 'Pack de départ',
  'prism.seed.working': '{delivered}/{total} leads livrés',
  'prism.seed.workingSub':
    'Cela prend 10 à 30 minutes. Les nouveaux leads apparaissent automatiquement. Exporte de préférence quand ils sont tous là.',
  'prism.seed.creditsNote':
    'Tes {total} crédits de départ sont utilisés au fil de l’eau, 1 crédit par lead finalisé.',
  'prism.seed.done': 'Les {delivered} leads sont dans ton compte.',
  'prism.seed.donePartial':
    '{delivered} leads livrés : les crédits restants restent sur ton solde.',
  'prism.refine.cta': 'Affiner ma cible maintenant',
  // Résultat (effet waouh)
  // Wave 2: the real kept-count now carries the headline.
  'prism.results.foundSuffix': 'entreprises trouvées dans ta cible',
  // #4 (Quickwins): variante personnalisée — {audience} arrive comme »citation«
  // prête du client (jamais fléchie, le gate vit côté client).
  'prism.results.foundSuffixAud': 'entreprises trouvées pour {audience}',
  // DEPRECATED (#13): "only X match" undersells the engine and contradicts
  // the 50-unlock — replaced by topLine (abundance + curation).
  'prism.results.matched': '{count} correspondent à ta cible',
  // #13: story = we show the strongest matches, the market has more of them.
  'prism.results.topLine': 'Ci-dessous : tes meilleurs résultats selon la pertinence.',
  // Wave 2: crossfade label target for the number morph (reserved; the
  // "vérifiées en direct" framing currently carries foundSuffix).
  'prism.results.checkedLabel': 'dont vérifiées en direct, tes plus fortes',
  // DEPRECATED (Wave 2): replaced by prism.results.matched.
  'prism.results.checked': '{count} déjà vérifiées en direct',
  'prism.results.unlockHint': 'Débloque tes',
  'prism.results.unlockOffer': '{n} entreprises adaptées pour 49 €',
  'prism.results.disclaimer':
    'Estimation du potentiel de marché basée sur ton analyse en direct : ce sont exactement ces entreprises que nous trouvons pour toi.',
  'prism.results.stat.checked': 'entreprises trouvées',
  // Wave 2: new real stat labels.
  'prism.results.stat.onTarget': 'correspondent à ta cible',
  // #13: market-abundance tile instead of "X match" — real engine estimate
  // (market.projected_range_dach); tile is omitted when no estimate exists.
  'prism.results.stat.market': 'entreprises sur ton marché (estimation)',
  'prism.results.stat.avgFit': 'Score de fit moyen de tes meilleurs résultats',
  // DEPRECATED (Wave 2): synthetic tiles — no longer rendered.
  'prism.results.stat.contacts': 'contacts identifiables',
  'prism.results.stat.revenue': 'potentiel de CA de la cible',
  'prism.results.chart.sizeTitle': 'Entreprises par taille',
  'prism.results.chart.sizeMuted': 'dans ta cible',
  'prism.results.chart.emp1': '1–9 sal.',
  'prism.results.chart.emp2': '10–49 sal.',
  'prism.results.chart.emp3': '50–199 sal.',
  'prism.results.chart.emp4': '200+ sal.',
  'prism.results.chart.qualityTitle': 'Qualité des données de tes leads',
  'prism.results.chart.qualityMuted': 'vérifiée aujourd’hui',
  'prism.results.chart.mail': 'E-mail vérifié',
  'prism.results.chart.dial': 'Ligne directe',
  'prism.results.chart.decider': 'Décideurs',
  'prism.results.insights.title': 'Potentiel et timing de ta cible',
  'prism.results.insights.openRate': 'Taux d’ouverture moyen des e-mails B2B vérifiés',
  'prism.results.insights.bestTimeValue': 'Mar–Jeu · 9h–11h',
  'prism.results.insights.bestTime': 'Meilleur créneau de contact dans ce secteur',
  'prism.results.insights.dealValue': 'Panier moyen par client gagné',
  'prism.results.insights.competitionValue': 'faible',
  'prism.results.insights.competition': 'Concurrence en prospection dans ta région',
  'prism.results.why.title': 'Bon timing :',
  'prism.results.why.p1': 'Dans ta cible, on a récemment vu',
  'prism.results.why.strong': '18 % de nouveaux décideurs en plus',
  'prism.results.why.p2':
    'devenir actifs, la phase idéale pour un premier contact, avant que la concurrence ne suive.',
  'prism.results.timing.title': 'Pourquoi c’est exactement le bon moment',
  'prism.results.timing.legend': 'Meilleure phase de contact dans ta cible · maintenant',
  'prism.timing.text':
    'En {month}, la joignabilité chez {who} est historiquement à son maximum : les budgets du prochain trimestre se décident et les décideurs répondent au téléphone. Qui prend contact maintenant est là avant que la concurrence n’arrive en {next}.',
  // Mois (graphique de saisonnalité + texte timing)
  'prism.month.now': 'Maintenant',
  'prism.month.short.1': 'Jan',
  'prism.month.short.2': 'Fév',
  'prism.month.short.3': 'Mar',
  'prism.month.short.4': 'Avr',
  'prism.month.short.5': 'Mai',
  'prism.month.short.6': 'Juin',
  'prism.month.short.7': 'Juil',
  'prism.month.short.8': 'Août',
  'prism.month.short.9': 'Sep',
  'prism.month.short.10': 'Oct',
  'prism.month.short.11': 'Nov',
  'prism.month.short.12': 'Déc',
  'prism.month.long.1': 'janvier',
  'prism.month.long.2': 'février',
  'prism.month.long.3': 'mars',
  'prism.month.long.4': 'avril',
  'prism.month.long.5': 'mai',
  'prism.month.long.6': 'juin',
  'prism.month.long.7': 'juillet',
  'prism.month.long.8': 'août',
  'prism.month.long.9': 'septembre',
  'prism.month.long.10': 'octobre',
  'prism.month.long.11': 'novembre',
  'prism.month.long.12': 'décembre',
  // Lead offert
  'prism.freelead.tag': 'Ton premier lead · offert',
  'prism.freelead.verified': 'vérifié',
  'prism.freelead.lockedChip': '🔒 Interlocuteur et coordonnées après le déblocage',
  'prism.freelead.note1': 'Voici à quoi ressemble',
  'prism.freelead.noteStrong': 'chacune',
  'prism.freelead.note2':
    'de tes {n} entreprises adaptées : un vrai interlocuteur avec e-mail ou téléphone. Tu débloques les {rest} autres à l’étape suivante.',
  'prism.freelead.alt1': 'Cette entreprise correspond à ta cible. Au déblocage, nous ajoutons',
  'prism.freelead.altStrong': 'de vrais interlocuteurs avec e-mail ou téléphone',
  'prism.freelead.alt2': ', pour les {n}.',
  // Lignes de leads
  'prism.lead.ap': 'Interlocuteurs',
  'prism.lead.inclDeciders': 'après déblocage',
  'prism.results.moreStrong': '≈{count} autres',
  'prism.results.moreRest':
    'entreprises trouvées. Nous recherchons les contacts après le déblocage.',
  'prism.results.planTitle': 'Ton plan de prospection de départ :',
  'prism.results.planBody':
    'les {n} entreprises les plus fortes d’abord, interlocuteurs avec e-mail ou téléphone, exportables en CSV ou Excel.',
  'prism.results.cta': 'Débloquer mes {n} entreprises adaptées',
  'prism.results.detailsLink': 'Qu’est-ce qui est inclus exactement ?',
  'prism.results.foot':
    '49 € aujourd’hui · {n} entreprises adaptées · dès le jour 4 : 290 €/mois, résiliable à tout moment',
  // Paywall
  'prism.paywall.step2': 'Débloquer',
  'prism.paywall.step3': 'C’est parti',
  'prism.paywall.resPrefix': 'Tes',
  'prism.paywall.resStrong': '50 leads',
  'prism.paywall.resSuffix': 'sont réservés pour toi',
  'prism.paywall.resExpired': 'Réservation expirée : on garde encore ta recherche un moment.',
  'prism.paywall.eyebrow': '{count} entreprises trouvées, prêtes à débloquer',
  'prism.paywall.title1': 'Débloque tes',
  'prism.paywall.titleGrad': '{n} entreprises adaptées',
  'prism.paywall.title2': 'maintenant.',
  // #4 (Quickwins): variante H1 personnalisée ({audience} = »citation« prête).
  'prism.paywall.title2Aud': 'pour {audience} maintenant.',
  'prism.paywall.sub1': 'Nous avons trouvé',
  'prism.paywall.subStrong1': '{count} entreprises',
  'prism.paywall.sub2': 'pour {audience}. Les',
  'prism.paywall.subStrong2': '{n} plus fortes',
  'prism.paywall.sub3':
    't’attendent. Nous recherchons les interlocuteurs et leurs coordonnées après le déblocage.',
  // Coffre à leads
  'prism.vault.title': 'Tes {n} meilleures entreprises sont prêtes',
  // Wave 2: 3-stage story from real numbers — {count}=discovery.kept
  // (vérifiées en direct), {audience}=typed target audience.
  // #13: no more "exactly X match" (contradicted "50 strongest" and shrank
  // the market) — {onTarget} stays as an unused-but-compatible placeholder.
  'prism.vault.sub':
    'Sur {count} entreprises trouvées pour {audience} : voici tes {n} plus fortes. Nous recherchons les interlocuteurs et leurs coordonnées après le déblocage.',
  'prism.vault.locked': 'verrouillé',
  'prism.vault.blurEmail': 'contact@entreprise.fr',
  // Wave 2: real remaining count from the scored pool instead of a static "+45".
  'prism.vault.more': '+ {count} autres entreprises trouvées, verrouillées',
  'prism.vault.cta': 'Tout débloquer · 49 €',
  'prism.vault.reassure':
    '49 € aujourd’hui · dès le jour 4 : 290 €/mois · résiliable à tout moment',
  // Carte fondateur + vidéo
  'prism.founder.head': 'Un message personnel du fondateur',
  'prism.founder.quote':
    '« Salut, moi c’est Janik. Pendant toute ta phase de test, je t’accompagne personnellement, et l’offre de départ est volontairement peu chère, pour que tu essaies Leadscraper en toute tranquillité. Donne-nous notre chance : je suis sûr qu’on est faits pour travailler ensemble. »',
  'prism.founder.role': 'Fondateur · Leadscraper',
  'prism.video.playAria': 'Lire la vidéo de démo',
  'prism.video.chip': 'Démo live · 10:04',
  'prism.video.title': 'Regarde comment Janik trouve tes premiers leads',
  'prism.video.cta': 'Voir la démo, vraie recherche, vrai dashboard',
  'prism.video.iframeTitle': 'Démo live · Leadscraper',
  // Timeline (déroulé du test)
  'prism.timeline.title': 'Ton test de 3 jours, pas à pas',
  'prism.timeline.today': 'Aujourd’hui',
  'prism.timeline.todayStrong': '49 € aujourd’hui',
  'prism.timeline.todayRest': ' : {n} entreprises adaptées débloquées, dans ton compte en 10 à 30 minutes.',
  'prism.timeline.days13': 'Jours 1–3',
  'prism.timeline.testP1': 'Tu testes avec de vrais leads.',
  'prism.timeline.testStrong': '3 jours',
  'prism.timeline.testP2': ': si ça ne colle pas, tu résilies en 1 clic, pas un centime de plus.',
  'prism.timeline.day4': 'Dès le jour 4',
  'prism.timeline.aboP1': 'Ensuite, ton plan continue avec',
  'prism.timeline.aboStrong': '250 crédits pour 290 €/mois',
  'prism.timeline.aboP2': ' — résiliable à tout moment.',
  // Bloc comparatif
  'prism.versus.title': 'Pourquoi Leadscraper, et pas la méthode habituelle',
  'prism.versus.oldTitle': 'La méthode habituelle',
  'prism.versus.old1': 'Des heures sur Google ou des listes achetées obsolètes',
  'prism.versus.old2': 'Taux de bounce élevé, zone grise RGPD',
  'prism.versus.old3': 'Interlocuteurs à chercher soi-même, laborieusement',
  'prism.versus.old4': '1 000–1 500 €/mois + engagement annuel (Cognism, Dealfront)',
  'prism.versus.old5': 'Des semaines avant la première réponse',
  'prism.versus.newTitle': 'Avec Leadscraper',
  'prism.versus.new1': '{n} entreprises adaptées en 10 à 30 minutes, alignées sur ta cible',
  'prism.versus.new2': 'E-mails contrôlés techniquement, téléphone si disponible',
  'prism.versus.new3': 'Interlocuteurs directement inclus',
  'prism.versus.new4': '49 € pour tester · résiliable chaque mois · sans engagement annuel',
  'prism.versus.new5': 'Exporte aujourd’hui, contacte demain',
  'prism.versus.foot1': 'Le même travail, pour lequel d’autres paient',
  'prism.versus.footStrong1': 'des semaines',
  'prism.versus.foot2': 'et',
  'prism.versus.footStrong2': 'plus de 1 000 €/mois',
  'prism.versus.foot3': ', chez toi aujourd’hui, en test pour',
  'prism.versus.footStrong3': '49 €',
  // Panneau ROI
  'prism.roi.title': 'Ce que tes {n} entreprises adaptées te rapportent',
  'prism.roi.row1': 'Leads avec interlocuteurs, prêts en 10 à 30 minutes',
  'prism.roi.row2': 'Ta mise aujourd’hui',
  'prism.roi.row3': 'Un seul client gagné rapporte',
  'prism.roi.row3v': 'plusieurs fois ta mise',
  'prism.roi.hl1': 'Un',
  'prism.roi.hlStrong': 'seul',
  'prism.roi.hl2':
    'client issu de tes {n} premières entreprises adaptées rembourse les 49 € plusieurs fois : tout le reste, c’est de l’avance.',
  'prism.roi.perLead': 'par lead prêt à l’emploi',
  'prism.roi.stat2v': '10–30 min',
  'prism.roi.stat2': 'au lieu de semaines de recherche',
  'prism.roi.stat3v': '3 jours',
  'prism.roi.stat3': 'd’essai avant le début de l’abonnement',
  // Carte tarif
  'prism.plan.badge': 'Offre de lancement · 3 jours d’essai',
  'prism.plan.leadsUnit': 'entreprises adaptées · interlocuteurs en 10 à 30 minutes',
  'prism.plan.anchor': 'En recherche manuelle : ~10 h de travail',
  'prism.plan.priceSuffix': 'aujourd’hui',
  'prism.price.netVat': 'TVA en sus',
  'prism.plan.perLeadStrong': 'moins de 1 €',
  'prism.plan.f1': 'E-mails contrôlés techniquement, téléphone si disponible',
  'prism.plan.f2': 'Interlocuteurs par entreprise, si publiquement trouvables',
  'prism.plan.f3': 'Export en CSV ou Excel, connexion CRM possible',
  'prism.plan.cta': 'Débloquer maintenant · 49 €',
  'prism.plan.secure': 'Paiement sécurisé via Stripe · chiffré SSL',
  'prism.plan.subnote': 'Résiliation à tout moment en 1 clic dans ton compte.',
  'prism.plan.gbCondition': 'Conditions de la garantie : art. 7 des',
  'prism.guarantee.title': 'Garantie satisfait ou remboursé',
  'prism.guarantee.sub':
    'Pendant les 3 jours d’essai, nous te remboursons les 49 € : écris à support@leadscraper.eu, remplis notre court formulaire de retour, et nous mettons fin à ton abonnement avec le remboursement. Uniquement pour cette offre de lancement.',
  'prism.legal.agb': 'CGV',
  'prism.legal.agbUrl': 'https://www.leadscraper.de/fr/conditions-generales',
  'prism.legal.privacyUrl': 'https://www.leadscraper.de/fr/politique-de-confidentialite',
  'prism.legal.privacy': 'Politique de confidentialité',
  // Bandeau avis (les citations clients restent volontairement non traduites)
  'prism.reviews.title': 'Des équipes commerciales déjà passées chez nous',
  // Barre de confiance
  'prism.trust.payStrong': '49 € aujourd’hui',
  'prism.trust.payRest': '· carte, PayPal, Apple & Google Pay · sécurisé via Stripe',
  'prism.trust.cancelStrong': 'Résiliable à tout moment',
  'prism.trust.cancelRest': '· en 1 clic depuis ton compte, sans délai, sans justification',
  'prism.trust.dataStrong': 'Données publiques uniquement',
  'prism.trust.dataRest': '· RGPD by design · serveurs dans l’UE',
  // FAQ
  'prism.faq.title': 'Questions fréquentes',
  'prism.faq.q1': 'Que se passe-t-il après les 3 jours ?',
  'prism.faq.a1':
    'Dès le jour 4, ton plan continue avec 250 crédits pour 290 €/mois, résiliable à tout moment en un clic. Tu décides donc tranquillement pendant les 3 jours.',
  'prism.faq.q2': 'Je peux résilier à tout moment ?',
  'prism.faq.a2':
    'Oui, chaque mois : un clic dans ton compte suffit, sans préavis ni justification. Si tu résilies pendant les 3 jours d’essai, tu ne paies que les 49 €. Ensuite, ton accès reste ouvert jusqu’à la fin du mois payé.',
  'prism.faq.q3': 'D’où viennent les leads, c’est conforme au RGPD ?',
  'prism.faq.a3':
    'Exclusivement de données d’entreprises publiquement accessibles. RGPD by design · traitement et serveurs exclusivement dans l’UE.',
  'prism.faq.q4': 'Et si les leads ne conviennent pas ?',
  'prism.faq.a4':
    'Pendant les 3 jours d’essai, nous te remboursons les 49 € si tu remplis notre court formulaire de retour (CGV art. 7). Écris à support@leadscraper.eu ; avec le remboursement, nous mettons fin à ton abonnement. Ensuite, plus aucun remboursement n’est possible, mais tu peux résilier l’abonnement à tout moment.',
  'prism.faq.q5': 'J’obtiens de vrais interlocuteurs ?',
  'prism.faq.a5':
    'Oui : par entreprise, des interlocuteurs recherchés avec adresse e-mail ou numéro de téléphone. Les adresses e-mail sont contrôlées techniquement ; nous ne pouvons pas garantir que chaque boîte existe. Si aucun contact joignable n’est trouvé pour une entreprise, rien n’est facturé pour elle.',
  // Ligne fondateur
  'prism.founderline.strong': 'Entreprise indépendante basée à Hambourg',
  'prism.founderline.rest': '· Janik Deimann, fondateur',
  'prism.founderline.sub':
    'Deimann Com GmbH · Chez nous, tu parles à des humains, pas à une file de tickets.',
  'prism.founderline.ask':
    'Encore un doute ? Écris-nous : support@leadscraper.eu. Un humain te répond.',
  // Barre d’achat fixe
  'prism.sticky.leads': '{n} entreprises adaptées ·',
  'prism.sticky.today': 'aujourd’hui · dès le jour 4 : 290 €/mois',
  'prism.sticky.cta': 'Débloquer maintenant',
  // Paiement intégré
  'prism.checkout.eyebrow': 'Offre de lancement · 49 € aujourd’hui',
  'prism.checkout.title': '{n} entreprises adaptées · débloquer maintenant',
  'prism.checkout.sumPrice': '49 € aujourd’hui',
  'prism.checkout.sumDesc': '{n} entreprises adaptées débloquées, 3 jours d’essai',
  'prism.checkout.after': 'dès le jour 4',
  'prism.checkout.monthly': '290 € / mois',
  'prism.checkout.reassure3d':
    'Si tu résilies dans les 3 jours, tu ne paies que les 49 €. Tes leads restent à toi : tu peux encore les consulter et les exporter ensuite.',
  'prism.checkout.deliverNote':
    'Cette recherche contient {count} entreprises adaptées, prêtes à être livrées. Un crédit n’est décompté que si nous trouvons un contact ; le reste de tes 50 crédits sert à d’autres recherches.',
  'prism.checkout.cancelNote': 'Résilie l’abonnement à tout moment, un clic.',
  'prism.checkout.invite':
    'On t’invite : 50 leads en une fois à prix coûtant, uniquement pour démarrer et tester Leadscraper sans risque.',
  'prism.checkout.or': 'ou par carte',
  'prism.checkout.tabCard': 'Carte',
  'prism.checkout.tabSepa': 'Prélèvement SEPA',
  'prism.checkout.cardholder': 'Titulaire de la carte',
  'prism.checkout.cardholderPh': 'Jean Dupont',
  'prism.checkout.cardNumber': 'Numéro de carte',
  'prism.checkout.expiry': 'Expiration',
  'prism.checkout.expiryPh': 'MM / AA',
  'prism.checkout.country': 'Pays',
  'prism.checkout.countryDe': 'Allemagne',
  'prism.checkout.countryAt': 'Autriche',
  'prism.checkout.countryCh': 'Suisse',
  'prism.checkout.paying': 'Activation…',
  'prism.checkout.embedLoading': 'Chargement du paiement sécurisé …',
  'prism.checkout.payCta': 'Débloquer {n} entreprises adaptées · 49 €',
  'prism.checkout.securePrefix': 'Paiement sécurisé via',
  'prism.checkout.secureSuffix': '· chiffré SSL',
  // Wave 2: generic button reference — the live CTA of the PaymentElement
  // (locked zone) reads "Continuer vers le paiement", not "Débloquer 50 leads".
  'prism.checkout.fine1': 'En cliquant sur le bouton ci-dessus, tu acceptes les',
  'prism.checkout.fine2':
    'ainsi que le renouvellement automatique en abonnement Starter (250 crédits / 290 € par mois) dès le jour 4, résiliable à tout moment en un clic. Cette offre s’adresse exclusivement aux entrepreneurs et professionnels (B2B, § 14 du Code civil allemand). Tous les prix sont HT, TVA légale en sus. Garantie satisfait ou remboursé : uniquement pour cette offre de lancement, uniquement dans les 3 jours d’essai et avec le formulaire de retour rempli (CGV art. 7).',
  // Écran de succès
  'prism.success.title': '{n} entreprises adaptées débloquées',
  'prism.success.body':
    'Tes {n} entreprises adaptées sont débloquées. Les interlocuteurs arrivent en 10 à 30 minutes, exportables en CSV/CRM. Dès le jour 4 démarre ton abonnement Starter (250 crédits/mois), résiliable chaque mois.',
  'prism.success.cta': 'C’est parti',

  // --- LEA-379 i18n backfill (2026-07-06): keys that previously fell back to
  //     German (packages/i18n index.ts fallback). Machine-translated from EN/DE,
  //     billing/cancel copy pending Janik wording review. ---
  'acct.plan.downgradeScheduled': 'Changement de plan planifié',
  'acct.plan.downgradeScheduledDetail':
    "Tu passeras à {plan} le {date}. D'ici là, tu gardes ton plan actuel, et tes Credits sont conservés.",
  'acct.plan.downgradeCancel': 'Annuler le changement',
  'acct.plan.downgradeCanceling': 'Annulation …',
  // LEA-555 — trial intercept.
  // LEA-557 — retention discount (30% x 3 Monate).
  // LEA-558 — VIP-Einrichtung (990-€-Vergleichswert nur in der Copy).
  // LEA-560 — Win-back-Banner.
  'acct.winback.title': 'Ton offre de bienvenue',
  'acct.winback.body':
    '{plan} à −30 % pendant 3 mois. Le checkout affiche le prix et la date de prélèvement avant que quoi que ce soit se passe.',
  'acct.winback.cta': 'Aller au checkout',
  'acct.winback.starting': 'Ouverture …',

  // LEA-524 — Pausendauer + Wiederaufnahme-Datum.
  'acct.cancel.save.offerTitle':
    'Avant de résilier — peut-être que l’une de ces options te convient mieux',
  'acct.cancel.save.offerSub': 'Sans pression. Résilier reste à un clic.',
  'acct.cancel.pauseMonthsLabel': 'Mettre en pause pendant',
  'acct.cancel.pauseMonths1': '1 mois',
  'acct.cancel.pauseMonths': '{n} mois',
  'acct.cancel.pauseResumeHint':
    'Votre abonnement reprend automatiquement le {date} — le prélèvement redémarre à cette date.',
  'acct.cancel.pausedDetailUntil':
    "Aucun montant n'est prélevé. Vous conservez l'accès et vos crédits restants. Votre abonnement reprend automatiquement le {date} ; vous pouvez le reprendre plus tôt à tout moment.",
  'acct.cancel.pausedNoteUntil':
    "En pause jusqu'au {date}, aucun prélèvement. Vos crédits restent utilisables.",

  'acct.cancel.trial.vipTitle': 'Janik configure ton compte personnellement',
  'acct.cancel.trial.vipBody':
    'Groupes cibles, profils de recherche, premières recherches — le fondateur configure ton compte avec toi personnellement. Une prestation d’une valeur de 990 € — gratuite pour toi si tu poursuis le test.',
  'acct.cancel.trial.vipCta': 'Demander la configuration personnelle',
  'acct.cancel.trial.vipRequesting': 'Demande en cours …',
  'acct.cancel.trial.vipDoneTitle': 'Demande envoyée',
  'acct.cancel.trial.vipDoneBody':
    'Janik te contactera personnellement sous 24 heures. Ton essai continue normalement — rien n’a été résilié ni facturé.',

  'acct.cancel.save.discountTitle': '30 % de réduction pendant les 3 prochains mois',
  'acct.cancel.save.discountBody':
    'Reste et paie 30 % de moins pendant trois mois — la réduction s’applique directement à ton abonnement, ta carte reste inchangée, pas de nouveau checkout.',
  'acct.cancel.save.discountCta': 'Activer les 30 % de réduction',
  'acct.cancel.save.discounting': 'Activation …',
  'acct.cancel.save.discountDoneTitle': 'Réduction active',
  'acct.cancel.save.discountDoneBody':
    'Tes trois prochaines factures mensuelles sont réduites de 30 %. Ensuite ton abonnement continue au prix normal — tu peux toujours résilier à tout moment en un clic.',

  'acct.cancel.trial.interceptTitle': "Un instant — ton essai court jusqu'au {date}.",
  'acct.cancel.trial.interceptTitleNoDate': 'Un instant — ton essai est toujours en cours.',
  'acct.cancel.trial.interceptSub': "Rien ne te sera facturé d'ici là.",
  'acct.cancel.trial.reminderTitle': 'Nous te préviendrons à temps',
  'acct.cancel.trial.reminderBody':
    "Rien à noter, rien à retenir. Nous t'écrirons 24 heures avant la fin — et si tu ne veux pas continuer, tu pourras résilier directement depuis cet e-mail.",
  'acct.cancel.trial.reminderPointMail':
    "Le lien de résiliation se trouve directement dans l'e-mail.",
  'acct.cancel.trial.reminderPointNoCharge': 'Rien ne te sera prélevé avant cela.',
  'acct.cancel.trial.reminderCta': 'Continuer et me rappeler',
  'acct.cancel.trial.keepTestingCta': 'Continuer l’essai',
  'acct.cancel.trial.reminderSaving': 'Activation …',
  'acct.cancel.trial.reminderDoneTitle': 'Rappel activé',
  'acct.cancel.trial.reminderDoneBody':
    "Nous t'écrirons le {date} — 24 heures avant la fin de ton essai, avec le lien de résiliation directement dans l'e-mail.",
  'acct.cancel.trial.reminderDoneBodyNoDate':
    "Nous t'écrirons 24 heures avant la fin de ton essai, avec le lien de résiliation directement dans l'e-mail.",
  'acct.cancel.trial.cancelNowLink': 'Résilier définitivement',
  'acct.cancel.trial.confirm.endsNow':
    "Ton accès d'essai prend fin immédiatement, et non à la date d'expiration.",
  'acct.cancel.trial.confirm.forfeits':
    'Tes profils de recherche et tes crédits restants sont perdus.',
  'acct.cancel.trial.confirm.noCharge': 'Rien ne te sera facturé.',
  'acct.cancel.trial.done.title': "Accès d'essai terminé",
  'acct.cancel.trial.done.body':
    "Ton essai est terminé et rien ne t'a été facturé. Si tu changes d'avis, tu peux souscrire un abonnement à tout moment.",

  'acct.cancel.trigger': "Résilier l'abonnement",
  'acct.cancel.manageHint': "Gérer l'abonnement",
  'acct.cancel.scheduledTitle': 'Résiliation planifiée',
  'acct.cancel.scheduledDetail':
    'Ton abonnement se termine le {date}. Tu gardes un accès complet jusque-là.',
  'acct.cancel.reactivate': 'Annuler la résiliation',
  'acct.cancel.reactivating': 'Annulation …',
  'acct.cancel.restored': 'Abonnement rétabli : ton plan continue.',
  'acct.cancel.title': "Résilier l'abonnement",
  'acct.cancel.stepOf': 'Étape {n} sur {total}',
  'acct.cancel.reasonTitle': 'Pourquoi souhaites-tu résilier ?',
  'acct.cancel.reasonSub': 'Facultatif : ta réponse nous aide à améliorer Leadscraper.',
  'acct.cancel.reason.too_expensive': 'Trop cher',
  'acct.cancel.reason.too_few_leads': 'Trop peu de (bons) leads',
  'acct.cancel.reason.wrong_contacts': 'Mauvais contacts',
  'acct.cancel.reason.unreliable_data': 'E-mails/données de contact peu fiables',
  'acct.cancel.reason.too_complicated': 'Trop compliqué',
  'acct.cancel.reason.missing_feature': 'Une fonctionnalité manque',
  'acct.cancel.reason.temporary_only': 'Besoin ponctuel uniquement',
  'acct.cancel.reason.switched_tool': 'Passage à un autre outil',
  'acct.cancel.reason.other': 'Autre',
  'acct.cancel.freeTextPlaceholder': 'Dis-nous en plus (facultatif) …',
  'acct.cancel.save.downgradeTitle': 'Un plan plus petit conviendrait peut-être ?',
  'acct.cancel.save.downgradeBody':
    'Plutôt que de résilier, tu peux passer à un plan moins cher : tu gardes tes Credits et tu paies moins dès le prochain cycle.',
  'acct.cancel.save.downgradeCta': 'Voir les plans moins chers',
  'acct.cancel.save.downgradeOffer':
    'Passe à {plan} · {price}\u00A0€/mois · {leads} leads/mois. Tu gardes tes Credits et tu paies moins dès le prochain cycle.',
  'acct.cancel.save.downgradeCtaPlan': 'Passer à {plan}',
  'acct.cancel.save.downgrading': 'Changement …',
  'acct.cancel.save.seeAllPlans': 'Voir tous les plans',
  'acct.cancel.save.helpTitle': 'Réglons ça ensemble',
  'acct.cancel.save.helpBody':
    'Nous améliorons activement beaucoup de tout cela. Dis-nous ce qui manquait : nous pouvons souvent réajuster ta recherche rapidement.',
  'acct.cancel.confirm.accessUntil': "Tu gardes un accès complet jusqu'au {date}.",
  'acct.cancel.confirm.noCharge': 'Aucun montant ne te sera facturé après cela.',
  'acct.cancel.confirm.reactivate':
    'Tu peux annuler la résiliation à tout moment avant cette date.',
  'acct.cancel.audit.title': 'Une dernière chose (facultatif)',
  'acct.cancel.audit.sub':
    "Qu'est-ce qui a marché, qu'est-ce qui n'a pas marché ? Ça alimente directement nos améliorations.",
  'acct.cancel.audit.rightCompanies': 'Les bonnes entreprises ?',
  'acct.cancel.audit.rightContacts': 'Les bons contacts ?',
  'acct.cancel.audit.contactDataUsable': 'E-mail/téléphone/LinkedIn utilisables ?',
  'acct.cancel.audit.enoughLeads': 'Assez de leads ?',
  'acct.cancel.audit.helpedWin': "Est-ce que ça t'a aidé à gagner des clients ?",
  'acct.cancel.audit.good': 'Bien',
  'acct.cancel.audit.bad': 'Mauvais',
  'acct.cancel.lead.title': "Quel lead t'a déçu ? (facultatif)",
  'acct.cancel.lead.sub': 'Si un lead précis ne convenait pas, le nommer nous aide le plus.',
  'acct.cancel.lead.pick': 'Choisir un lead',
  'acct.cancel.lead.loading': 'Chargement …',
  'acct.cancel.lead.none': 'Aucun lead livré trouvé.',
  'acct.cancel.cf.title': 'Aide-nous à faire mieux (facultatif)',
  'acct.cancel.cf.gapPlaceholder': "De quoi avais-tu besoin que nous n'avons pas pu livrer ?",
  'acct.cancel.cf.toolPlaceholder': 'Tu passes à un autre outil ? Lequel ?',
  'acct.cancel.cf.betterPlaceholder': "Qu'est-ce qu'il fait mieux ?",
  'acct.cancel.justCancel': 'Résilier maintenant',
  'acct.cancel.keep': 'Finalement, je garde',
  'acct.cancel.next': 'Continuer',
  'acct.cancel.back': 'Retour',
  'acct.cancel.stillCancel': 'Résilier quand même',
  'acct.cancel.confirmBtn': 'Confirmer la résiliation',
  'acct.cancel.confirming': 'Résiliation …',
  'acct.cancel.done.title': 'Résiliation confirmée',
  'acct.cancel.done.body':
    'Ton abonnement se termine le {date}. Tu gardes un accès complet jusque-là, et tu peux annuler la résiliation à tout moment avant cette date.',
  'acct.cancel.done.close': 'Fermer',
  'acct.cancel.save.pauseTitle': 'Mettre en pause plutôt que résilier ?',
  'acct.cancel.save.pauseBody':
    'Gèle ton abonnement au lieu de le résilier : aucun prélèvement, tes Credits et tes données restent, et tu peux reprendre à tout moment en un clic.',
  'acct.cancel.save.pauseCta': "Mettre l'abonnement en pause",
  'acct.cancel.save.pausing': 'Mise en pause …',
  'acct.cancel.pauseTrigger': 'Mettre en pause',
  'acct.cancel.pausing': 'Mise en pause …',
  'acct.cancel.pausedBadge': 'En pause',
  'acct.cancel.pausedNote':
    'Abonnement en pause, aucun prélèvement. Tes Credits restent utilisables.',
  'acct.cancel.pausedTitle': 'Abonnement en pause',
  'acct.cancel.pausedDetail':
    "Aucun montant n'est prélevé. Tu gardes l'accès et tes Credits restants. Reprends à tout moment.",
  'acct.cancel.resume': "Reprendre l'abonnement",
  'acct.cancel.resuming': 'Reprise …',
  'billing.errorRetry': 'Réessayer',
  'billing.transientError': 'Temporairement indisponible. Réessaie dans un instant.',
  'billing.downgradeScheduled':
    'Changement de plan planifié : tu passeras à {plan} le {date}. Tes Credits sont conservés.',
  'billing.downgradeAlready': 'Un changement vers {plan} est déjà planifié pour le {date}.',
  'dash.run.suggHeading': 'Exemples de recherches pour ton activité',
  'dash.run.intent.broad': 'Classique',
  'dash.run.intent.growth': 'Signal de croissance',
  'dash.run.intent.tool': "Signal d'outil",
  'dash.run.intent.default': 'Suggestion',
  'dash.run.costPreview': "jusqu'à {n} Credits",
  'det.sourcesPending':
    'Les preuves-sources pour ce lead sont encore en cours de compilation : elles apparaîtront ici une fois vérifiées.',
  'ld.contact.emailCopied': 'Adresse e-mail copiée.',
  'ld.contact.phoneCopied': 'Numéro de téléphone copié.',
  'ld.contact.copy': 'Copier',
  'ld.contact.copied': 'Copié.',
  'ld.contact.tagCentral': 'Standard',
  'ld.contact.tagUnconfirmed': 'non confirmé',
  'ld.contact.tagPattern': 'Modèle',
  'ld.contact.centralTooltip': 'Ligne directe non publique : appelle et demande {name}.',
  'ld.contact.centralTooltipNoName': 'Ligne directe non publique : cela aboutit au standard.',
  'ld.contact.verifiedSmtp': 'Boîte e-mail confirmée (SMTP).',
  'ld.contact.unverifiedHint': "Reprise d'une source publique, pas encore vérifiée par SMTP.",
  'ld.contact.patternTooltip':
    "Adresse probable d'après le modèle d'e-mail de l'entreprise, non confirmée.",
  'ld.contact.derivePattern': "Déduire l'e-mail d'après le modèle de l'entreprise",
  'ld.contact.bestRoute': 'Meilleur canal :',
  'ld.contact.route.central': 'Appel via le standard',
  'ld.contact.route.centralEmail': 'E-mail au standard',
  'ld.contact.route.linkedin': 'Message LinkedIn',
  'ld.contact.route.xing': 'Message Xing',
  'ld.contact.route.phone': 'Appel (ligne directe)',
  'ld.contact.route.email': 'E-mail',
  'ld.contact.route.pattern': "E-mail via le modèle de l'entreprise",
  'ld.contact.provMailbox': 'Boîte confirmée',
  'ld.contact.provImpressum': "Nommé dans l'Impressum",
  'ld.contact.provFound': 'Trouvé dans des sources publiques',
  'ld.contact.provVia': 'confirmé via',
  'ld.contact.confHigh': 'Élevée',
  'ld.contact.confMid': 'Moyenne',
  'ld.contact.confLow': 'Faible',
  'ld.contact.photoVia': 'Photo : {src} ↗',
  'ld.contact.roleProof': 'Rôle confirmé publiquement ↗',
  'ld.section.roleFallback':
    "Le rôle souhaité ({roles}) n'est pas confirmé publiquement : nous affichons les meilleurs contacts suivants.",
  'ld.section.noDirect':
    'Les contacts directs ne sont pas publics ici, joignables via le standard.',
  'lt.expH.legalForm': 'Forme juridique',
  'lt.expH.street': 'Rue',
  'lt.expH.zip': 'Code postal',
  'lt.expH.website': 'Site web',
  'lt.expH.vatId': 'N° de TVA',
  'lt.expH.hr': 'Handelsregister',
  'lt.expH.founded': 'Fondée',
  'lt.expH.size': 'Employés',
  'lt.expH.revenue': "Fourchette de chiffre d'affaires",
  'lt.expH.description': 'Description',
  'lt.expH.techStack': 'Stack technique',
  'lt.expH.triggers': 'Signaux/Déclencheurs',
  'lt.expH.scoreCompany': "Score d'adéquation entreprise",
  'lt.expH.scoreData': 'Qualité des données',
  'lt.expH.seniority': 'Séniorité',
  'lt.expH.department': 'Service',
  'lt.expH.phone': 'Téléphone',
  'lt.expH.linkedin': 'LinkedIn',
  'lt.expH.xing': 'Xing',
  'lt.expH.qualification': 'Qualification',
  'lt.expH.confidence': 'Confiance',
  'lt.expH.channel': 'Canal recommandé',
  'lt.filter.all': 'Tous',
  'lt.filter.torate': 'À évaluer',
  'lt.filter.identified': 'Entreprise ajoutée',
  'lt.filter.connected': 'Avec contacts',
  'lt.filter.planned': 'Plan prêt',
  'lt.filter.archived': 'Archivé',
  'lt.view.list': 'Liste',
  'lt.view.listSubheader': 'Tableau, toutes les colonnes visibles',
  'lt.funnel.subheader': 'Funnel, leads regroupés par phase',
  'lt.funnel.addCompany': 'Ajouter une entreprise',
  'lt.funnel.add': 'Ajouter',
  'lt.funnel.addTooltip': 'Ajouter une entreprise via URL · 1 Credit',
  'lt.funnel.pullAllContacts': 'Récupérer tous les contacts',
  'lt.funnel.empty': "Aucun lead dans cette phase pour l'instant",
  'lt.funnel.dropHint': 'Dépose ici pour démarrer la phase',
  'lt.col.planned': "Plan d'acquisition prêt",
  'lt.card.new': 'Nouveau',
  'lt.card.viewPlan': 'Voir le plan',
  'lt.card.findContacts': 'Trouver des contacts',
  'lt.card.createPlan': "Créer un plan d'acquisition",
  'lt.card.contactsCount': '{n} contacts',
  'lt.card.fitTooltip': 'Adéquation {score} %, à quel point cette entreprise correspond à ta cible',
  'lt.card.noContacts': "Aucun contact pour l'instant",
  'lt.card.noJustification':
    'Pas encore de justification Cortex : le lead sera enrichi lors du prochain run.',
  'lt.card.rejectTitle': 'Marquer comme non pertinent',
  'lt.card.rejectAria': 'Marquer {company} comme non pertinent',
  'lt.card.openWebsite': 'Ouvrir {website}',
  'lt.manual.verifyingDesc': 'Vérification du site web, extraction des données de base …',
  'lt.manual.addedDesc':
    'Ajoutée via URL : secteur, adresse et coordonnées sont complétés lors de la vérification.',
  'lt.phaseChip.identified': 'Ajoutée',
  'lt.phaseChip.connected': 'Contacts',
  'lt.phaseChip.planned': 'Plan prêt',
  'nav.matchRateMin': "Le taux de correspondance s'affiche à partir de 5 évaluations",
  'notif.review.bodyAll': '{n} leads non évalués dans {m} cibles.',
  'price.ctaDowngradeScheduled': 'Changement déjà planifié',
  'run.startFailed': "La recherche n'a pas pu être lancée. Réessaie.",
  'email.subscription-paused.subject': 'Ton abonnement est en pause',
  'email.subscription-paused.badge': 'Abonnement en pause',
  'email.subscription-paused.hero': 'Votre abonnement<br>est en pause.',
  'email.subscription-paused.detail.plan_label': 'Forfait',
  'email.subscription-paused.detail.until_label': 'En pause jusqu’au',
  'email.subscription-paused.preheader': "Aucun prélèvement jusqu'au {{pause_ends_at}}.",
  'email.subscription-paused.greeting': 'Salut {{first_name}},',
  'email.subscription-paused.intro':
    "ton abonnement {{plan_name}} est désormais en pause. Aucun montant ne te sera facturé jusqu'au {{pause_ends_at}}.",
  'email.subscription-paused.access':
    'Tu gardes un accès complet et tes Credits restants : tu ne reçois simplement pas de nouveaux Credits mensuels.',
  'email.subscription-paused.resume_note':
    'Le {{pause_ends_at}}, ton abonnement reprend automatiquement. Tu peux le reprendre ou le résilier à tout moment avant cette date.',
  'email.subscription-paused.button': "Gérer l'abonnement",
  'email.subscription-paused.signoff': "À bientôt, l'équipe Leadscraper",
  'email.subscription-pause-ending.subject': 'Ton abonnement reprend bientôt',
  'email.subscription-pause-ending.preheader': 'Ta pause se termine le {{resumes_at}}.',
  'email.subscription-pause-ending.greeting': 'Salut {{first_name}},',
  'email.subscription-pause-ending.intro':
    'petit rappel : ta pause se termine le {{resumes_at}}. Ton abonnement {{plan_name}} reprendra alors automatiquement.',
  'email.subscription-pause-ending.charge_note':
    'La facturation reprend normalement à partir de là. Si tu préfères ne pas reprendre, tu peux résilier avant cette date.',
  'email.subscription-pause-ending.button': "Gérer l'abonnement",
  'email.subscription-pause-ending.signoff': "L'équipe Leadscraper",
  'scraper.sum.recallUnverified':
    "{n}/10 leads livrés : le chercheur IA a suffi, la recherche web étendue a donc été ignorée. Le marché pourrait être bien plus vaste que les {total} entreprises trouvées jusqu'ici.",
  'scraper.sum.recallUnverifiedRec':
    "Ce n'est pas un marché étroit, c'est une recherche ignorée. Nous élargissons la découverte pour mesurer la taille réelle du marché.",
  'scraper.sum.supplyExhausted':
    "{n}/10 leads livrés : {dropped} correspondances supplémentaires t'avaient déjà été livrées lors de recherches précédentes et ont été filtrées comme doublons. Le marché n'est pas étroit ; tu as simplement déjà reçu la plupart des entreprises que nous pouvons actuellement trouver.",
  'scraper.sum.supplyExhaustedRec':
    'Normal pour les recherches récurrentes. De nouvelles entreprises apparaissent au fil du temps. Pour plus de volume frais : choisis une région plus large ou des secteurs connexes.',
  'det.emailPatternExampleTag': 'Exemple',
  'det.emailPatternLockedHint': 'Déterminé pour cette entreprise lorsque tu vérifies les contacts.',
  'det.email.verified': 'vérifié',
  'det.email.unverified': 'non vérifié',
  'det.linkedinProfile': 'Profil LinkedIn',
  'det.xingProfile': 'Profil Xing',
  // --- Autopilot-Modus (Port aus feat/autopilot-setup-experience) ---
  'autopilot.act.title': 'Dernières activités',
  'autopilot.appr.action': 'Valider',
  'autopilot.appr.givenShort': 'Validé',
  'autopilot.appr.opsShort': 'Validé par nous',
  'autopilot.appr.opsFeedback':
    'Nous l’avons vérifié et validé, tu n’as rien à faire. Si cela te convient, tu peux le confirmer ici. Pour toute modification, écris directement à ton interlocuteur.',
  'autopilot.appr.opsNoAction':
    'Nous l’avons vérifié et validé, tu n’as rien à faire. Pour toute modification, écris directement à ton interlocuteur.',
  'autopilot.appr.opsChanged':
    'Le contenu a changé depuis ton retour du {date}. Nous avons vérifié et validé la version actuelle.',
  'autopilot.appr.opsConfirm': 'Ça me convient',
  'autopilot.appr.opsConfirmAsk': 'Enregistrer ton retour ?',
  'autopilot.appr.opsDone': 'Merci, ton retour est enregistré.',
  'autopilot.appr.opsAllDone': 'Tout est validé. Si quelque chose te semble bizarre, dis-le-nous.',
  'autopilot.appr.launchHintOps':
    'Nous validons le lancement dès que la cible, les messages et la gestion des réponses sont vérifiés.',
  'autopilot.camp.readonlyOps':
    'Tu veux modifier quelque chose ? Préviens ton interlocuteur, nous l’adaptons.',
  'autopilot.appr.pvShow': 'Voir',
  'autopilot.appr.pvHide': 'Réduire',
  'autopilot.appr.pvShowFirst': 'Vérifie d’abord ce que tu valides',
  'autopilot.appr.pvHeading': 'Voici ce que tu valides',
  'autopilot.appr.pvSampleTitle': 'Échantillon d’entreprises cibles',
  'autopilot.appr.pvSampleFoot':
    'Un échantillon de ta cible — tu vois la liste complète en fonctionnement.',
  'autopilot.appr.pvEmpty': 'Le contenu est en cours de préparation.',
  'autopilot.appr.pvFirms': '{n} entreprises',
  'autopilot.appr.pvPace': '{n}/jour',
  'autopilot.appr.pvStart': 'Immédiatement',
  'autopilot.appr.pvWait': '+{d} jours',
  'autopilot.appr.pvSubject': 'Objet :',
  'autopilot.appr.pvAb': 'Variante A/B :',
  'autopilot.appr.pvLaunchReady':
    'Tout le contenu est validé — au démarrage, le premier e-mail part.',
  'autopilot.appr.pvLaunchWait':
    'Le démarrage se débloque une fois les trois validations ci-dessus en place.',
  'autopilot.appr.allDone':
    "Tout est validé — nous lançons ta campagne et te préviendrons dès qu'elle sera active.",
  'autopilot.appr.confirmAsk': 'Valider définitivement ?',
  'autopilot.appr.copy': 'Messages & séquence',
  'autopilot.appr.copyHint':
    'Tes e-mails, entièrement rédigés — tu vois de vrais exemples, pas des modèles.',
  'autopilot.appr.done': 'Validation enregistrée — avec horodatage et somme de contrôle.',
  'autopilot.appr.error': 'Échec de la validation — merci de réessayer.',
  'autopilot.appr.given': 'Validé le {date}',
  'autopilot.appr.hash': 'Somme de contrôle',
  'autopilot.appr.icp': 'Cible & segment',
  'autopilot.appr.icpHint': 'Qui ton moteur contacte — secteurs, régions, décideurs.',
  'autopilot.appr.intro':
    'Tu valides, nous exécutons. Chaque validation est documentée — tu gardes le contrôle sur la cible, le contenu et le lancement.',
  'autopilot.appr.launch': 'Lancement de la campagne',
  'autopilot.appr.launchHint': "Ta validation finale — le premier e-mail ne partira qu'après.",
  'autopilot.appr.locked': 'Se débloque dès que les autres validations sont données',
  'autopilot.appr.logIntro':
    'Chaque validation est enregistrée avec un horodatage ; le contenu validé est figé et ancré par une somme de contrôle.',
  'autopilot.appr.logTitle': 'Journal des validations',
  'autopilot.appr.pending': 'En attente de toi',
  'autopilot.appr.preparingShort': 'En préparation',
  'autopilot.appr.preparing':
    'Le contenu est en cours de préparation — tu seras prévenu dès que tu pourras le valider.',
  'autopilot.appr.playbook': 'Playbook de réponse',
  'autopilot.appr.playbookHint':
    'Comment nous répondons aux questions en ton nom, avant de te transmettre le contact.',
  'autopilot.appr.soon': 'Le contenu est en cours de préparation pour toi',
  'autopilot.appr.title': 'Tes validations',
  'autopilot.camp.approvedAt': 'Validée par toi le {date}',
  'autopilot.camp.approvedShort': 'Validée — démarrage à venir',
  'autopilot.camp.audience': 'Cible',
  'autopilot.camp.audienceN': '{n} entreprises dans le segment',
  'autopilot.camp.awaitApproval': 'En attente de ta validation de lancement',
  'autopilot.camp.back': 'Toutes les campagnes',
  'autopilot.camp.chip.paused': 'En pause',
  'autopilot.camp.chip.running': 'En cours',
  'autopilot.camp.chip.scheduled': 'Planifiée',
  'autopilot.camp.hideMail': 'Réduire',
  'autopilot.camp.nextSend': 'Prochain envoi {when}',
  'autopilot.camp.open': 'Voir',
  'autopilot.camp.pace': "jusqu'à {n} mails/jour via tes boîtes mail",
  'autopilot.camp.progress': '{done} sur {total} entreprises contactées',
  'autopilot.camp.queue': '{n} entreprises vérifiées en réserve',
  'autopilot.camp.readonly':
    "Tu veux modifier quelque chose ? Préviens ton interlocuteur — toute modification ne sera mise en ligne qu'après ta validation.",
  'autopilot.camp.runningSince': 'en cours depuis le {date}',
  'autopilot.camp.sReplies': '{n} réponses',
  'autopilot.camp.sSent': '{n} envoyés',
  'autopilot.camp.sectionRunning': 'En cours',
  'autopilot.camp.sending': 'Envoi',
  'autopilot.camp.sequence': 'La séquence',
  'autopilot.camp.sequenceHint':
    "Chaque mail est unique — l'engine remplit les {{variables}} individuellement pour chaque entreprise.",
  'autopilot.camp.showMail': 'Voir le mail',
  'autopilot.camp.startsAt': 'Démarre {when}',
  'autopilot.camp.stepStart': 'Début de la séquence',
  'autopilot.camp.stepWait': '+{n} jours après',
  'autopilot.camp.subject': 'Objet',
  'autopilot.contact.hint':
    "Ligne directe, pas de système de tickets. L'arrêt d'urgence se trouve sous Validations.",
  'autopilot.contact.title': 'Ton interlocuteur',
  'autopilot.contact.write': 'Écrire un message',
  'autopilot.end.testing': 'En cours de test : {label}',
  'autopilot.exp.empty':
    'Dès que ton moteur lance des hypothèses de test, tu verras ici ce qui est testé — et pourquoi.',
  'autopilot.exp.since': 'depuis le {date}',
  'autopilot.exp.title': 'Expériences',
  'autopilot.foot.details': 'Détails dans Technique',
  'autopilot.foot.quota': 'Quota {used}/{target}',
  'autopilot.health.amber': 'Sous surveillance',
  'autopilot.health.blacklistOk': 'Listes noires propres',
  'autopilot.health.bounce': 'Taux de rebond {n}%',
  'autopilot.health.green': 'Tous les systèmes au vert',
  'autopilot.health.red': "On s'en occupe",
  'autopilot.health.suppressed':
    '{n} désinscriptions respectées, bloquées sur toutes les campagnes',
  'autopilot.health.title': 'Santé du système',
  'autopilot.hist.campaigns': 'Terminées',
  'autopilot.hist.completed': 'terminé',
  'autopilot.hist.emptyHint':
    'Dès que ta première campagne sera lancée, les bilans de campagnes et les résultats des tests terminés apparaîtront ici.',
  'autopilot.hist.emptyTitle': "Aucun historique pour l'instant",
  'autopilot.hist.intro':
    "Ce qui est en cours, ce qui s'est terminé — et ce que ton moteur en a appris. Consulte et navigue ; le pilotage se fait via tes validations.",
  'autopilot.hist.ongoing': 'en cours',
  'autopilot.hist.running': 'en cours',
  'autopilot.hist.steps': '{n} étapes de séquence',
  'autopilot.hist.tests': 'Tests terminés',
  'autopilot.hist.tie': 'Égalité',
  'autopilot.hist.title': 'Campagnes',
  'autopilot.hist.vs': 'contre',
  'autopilot.ho.none': 'Aucune transmission en attente — le moteur travaille.',
  'autopilot.ho.title': 'Transmissions chaudes',
  'autopilot.infra.dns': 'Authentification e-mail configurée (SPF · DKIM · DMARC)',
  'autopilot.infra.domain': "Domaine d'envoi enregistré — à ton nom",
  'autopilot.infra.mailboxes': 'Boîtes mail configurées',
  'autopilot.infra.title': 'Ton infrastructure',
  'autopilot.infra.verify': "Domaine vérifié et activé pour l'envoi",
  'autopilot.infra.yourTask': 'Ta tâche',
  'autopilot.setup.title': 'Ton engine prend forme',
  'autopilot.setup.intro':
    'Ce que nous mettons en place pour toi en ce moment — chaque étape documentée.',
  'autopilot.setup.ev.domain_registered':
    "Domaine d'envoi {domain} enregistré — au nom de ton entreprise, tu en es le titulaire.",
  'autopilot.setup.ev.dns_shield':
    "Filet de sécurité DNS pour {domain} en place : authentification de l'expéditeur (SPF · DKIM · DMARC) et protection anti-usurpation actives.",
  'autopilot.setup.ev.redirect_live':
    '{domain} redirige désormais les visiteurs directement vers {target} — transparence totale pour chaque destinataire.',
  'autopilot.setup.ev.mailboxes_created':
    '{n} boîtes mail configurées sur {domain}, sécurisées et chiffrées.',
  'autopilot.setup.ev.warmup_started':
    "Réseau de chauffe lancé : {n} boîtes construisent leur réputation d'envoi jour après jour.",
  'autopilot.setup.ev.warmup_progress':
    'Chauffe : jour {day} sur {total} — {rate} % de placement en boîte de réception.',
  'autopilot.setup.ev.blacklist_clean':
    'Contrôle de réputation : {n} listes noires vérifiées — tout est propre.',
  'autopilot.kpi.contacted': 'Contactés',
  'autopilot.kpi.delivered': 'Délivrés',
  'autopilot.kpi.handovers': 'Transmissions',
  'autopilot.kpi.lockedHint': 'Les chiffres apparaîtront dès que ta campagne sera lancée.',
  'autopilot.kpi.modulePrice': 'Module : {price}/mois',
  'autopilot.kpi.replies': 'Réponses',
  'autopilot.kpi.won': 'Gagnés',
  'autopilot.kpi.wonValueLabel': 'Valeur des transactions gagnées',
  'autopilot.mb.empty': 'Tes boîtes mail sont en cours de configuration.',
  'autopilot.mb.hint':
    'Le warmup tourne en permanence — même en production, une base minimale maintient une bonne délivrabilité.',
  'autopilot.mb.perDay': '{n} mails/jour',
  'autopilot.mb.score': 'Délivrabilité',
  'autopilot.mb.st.connecting': 'connexion en cours',
  'autopilot.mb.st.ready': 'prêt',
  'autopilot.mb.st.sending': "actif · warmup d'entretien",
  'autopilot.mb.st.warmup': 'Warmup · Jour {d}/{total}',
  'autopilot.mb.title': 'Boîtes mail & Warmup',
  'autopilot.mb.count': '{active} sur {total} actifs',
  'autopilot.mb.scoreLabel': 'Score de délivrabilité',
  'autopilot.mode.autopilot': 'Autopilot',
  'autopilot.mode.lockedHint': 'Autopilot est un module complémentaire – en savoir plus',
  'autopilot.mode.search': 'Standard',
  'autopilot.nav.history': 'Campagnes',
  'autopilot.nav.overview': 'Tableau de bord',
  'autopilot.nav.replies': 'Kanban',
  'autopilot.nav.tech': 'Technique',
  'autopilot.notActive.hint': 'Si tu souhaites utiliser Autopilot, contacte-nous.',
  'autopilot.notActive.title': "Autopilot n'est pas actif pour ce compte",
  'autopilot.ov.activeTitle': 'Ton moteur est en action',
  'autopilot.ov.awaitCta': 'Voir les validations',
  'autopilot.ov.awaitHint': "Il ne manque plus que tes validations — ensuite nous lançons l'envoi.",
  'autopilot.ov.awaitTitle': 'Ton moteur est prêt à démarrer',
  'autopilot.ov.endedTitle': 'Autopilot terminé',
  'autopilot.ov.engineTitle': 'Ton moteur',
  'autopilot.ov.offerHint':
    'Dès que le contrat est finalisé, nous commençons la configuration de ton moteur.',
  'autopilot.ov.offerTitle': 'Ton Autopilot est en préparation',
  'autopilot.ov.pausedHint':
    "Rien n'est envoyé actuellement. Contacte ton interlocuteur pour reprendre.",
  'autopilot.ov.pausedTitle': 'Envoi en pause',
  'autopilot.ov.setupHint':
    "Le domaine, l'authentification et les boîtes mail sont en cours de configuration — entièrement de notre côté. Tu n'as rien à faire ; nous te contactons dès que tes premières validations sont prêtes.",
  'autopilot.ov.setupTitle': 'Nous construisons ton moteur',
  'autopilot.ov.warmupDay': 'Warmup · Jour {d} sur {total}',
  'autopilot.ov.warmupHint':
    'Tes boîtes mail sont chauffées progressivement pour que tes e-mails arrivent dans la boîte de réception — pas dans les spams. Pendant ce temps, tu peux traiter tes validations.',
  'autopilot.ov.warmupTitle': 'Warmup en cours',
  'autopilot.pause.hintContact':
    'Ton interlocuteur arrête les envois pour toi — écris-lui, cela prend effet immédiatement.',
  'autopilot.pause.action': "Mettre l'envoi en pause",
  'autopilot.pause.hint':
    "Arrête l'envoi immédiatement et complètement. Ton interlocuteur te contactera ensuite personnellement.",
  'autopilot.pause.title': "Arrêt d'urgence",
  'autopilot.pause.confirm': 'Vraiment arrêter ?',
  'autopilot.pause.done': 'Envoi en pause — ton interlocuteur te contactera personnellement.',
  'autopilot.pause.error': 'La mise en pause a échoué — contacte directement ton interlocuteur.',
  'autopilot.pause.pausedHint':
    "L'envoi est en pause. Ton interlocuteur te contactera personnellement avant toute reprise.",
  'autopilot.pulse.checked': "{n} vérifiés par l'IA",
  'autopilot.pulse.next': 'Prochain envoi {when}',
  'autopilot.pulse.queue': '{n} en réserve',
  'autopilot.pulse.quiet':
    "Pas encore d'envoi — l'engine est en cours de mise en place. Dès que ça démarre, tu verras ici le pouls quotidien.",
  'autopilot.pulse.researched': '{n} recherchés',
  'autopilot.pulse.sent': "{n} envoyés aujourd'hui",
  'autopilot.pulse.title': 'Le moteur en ce moment',
  'autopilot.quota.progress': '{used} sur ~{target} entreprises',
  'autopilot.quota.title': 'Quota ce mois-ci',
  'autopilot.rc.interested': 'Intéressé',
  'autopilot.rc.later': 'Plus tard',
  'autopilot.rc.noNeed': 'Pas de besoin',
  'autopilot.rc.ooo': 'Absence',
  'autopilot.rc.unsub': 'Désinscription',
  'autopilot.rcls.title': 'Réponses par catégorie',
  'autopilot.rep.actionFailed': "Échec de l'action — merci de réessayer.",
  'autopilot.rep.call': 'Appeler maintenant',
  'autopilot.rep.contacted': 'Marquer comme pris en charge',
  'autopilot.rep.contactedDone': 'Pris en charge le {date}',
  'autopilot.rep.contactedSet': 'Marqué comme pris en charge — merci, cela nous aide beaucoup.',
  'autopilot.rep.contactedShort': 'Pris en charge',
  'autopilot.rep.dealPlaceholder': 'Valeur de la transaction',
  'autopilot.rep.emptyHint':
    "Dès que ta campagne sera lancée, les réponses des entreprises contactées apparaîtront ici — avec l'historique complet et notre évaluation.",
  'autopilot.rep.emptyTitle': "Aucune réponse pour l'instant",
  'autopilot.rep.intro':
    "Chaque réponse arrive ici — classifiée et avec l'historique complet. On clarifie, toi tu passes les appels.",
  'autopilot.rep.lostPlaceholder': 'Raison (facultatif)',
  'autopilot.rep.noFit': 'Pas un fit',
  'autopilot.rep.noFitSet': 'Marqué comme « pas un fit » — ton moteur en tire les leçons.',
  'autopilot.rep.saveClose': 'Enregistrer',
  'autopilot.rep.title': 'Réponses',
  'autopilot.rep.viewThread': 'Voir le fil ({n})',
  'autopilot.rep.threadEmpty': 'Pas encore d’historique pour cette conversation.',
  'autopilot.rep.threadSent': 'Envoyé · {step}',
  'autopilot.rep.threadSentPlain': 'Envoyé par toi',
  'autopilot.rep.threadFoot': 'Envoyé en ton nom. Les modifications passent par ton interlocuteur.',
  'autopilot.rep.cls.interested': 'Intérêt',
  'autopilot.rep.cls.later': 'Plus tard',
  'autopilot.rep.cls.noNeed': 'Pas de besoin',
  'autopilot.rep.cls.referral': 'Autre interlocuteur',
  'autopilot.rep.cls.question': 'Question',
  'autopilot.rep.cls.outOfOffice': 'Absence',
  'autopilot.rep.cls.unsubscribed': 'Désabonnement',
  'autopilot.rep.wonNoValue': 'Gagné',
  'autopilot.rep.wonSet':
    'Gagné — excellent ! La valeur de la transaction est intégrée à ton bilan.',
  'autopilot.report.first':
    'Ton prochain rapport arrive le {date} — envoyés, délivrés, réponses, transmissions. Sans enjolivure.',
  'autopilot.report.title': 'Rapport mensuel',
  'autopilot.res.angles': "Angles d'approche",
  'autopilot.res.anglesHint': 'Avec quelle accroche on entame la conversation.',
  'autopilot.res.emptyHint':
    'Dès que ta campagne sera lancée et que les premières réponses arriveront, tu verras ici ce qui fonctionne et ce qui ne fonctionne pas.',
  'autopilot.res.emptyTitle': 'Pas encore de résonance',
  'autopilot.res.footnote':
    'Taux calculés à partir de 30 entreprises contactées — en dessous, un pourcentage relèverait du hasard.',
  'autopilot.res.intro':
    "D'où viennent les réponses — et ce qui ne suscite aucune réaction. Ton Engine mesure chaque prise de contact et en tire les conséquences.",
  'autopilot.res.learnedTitle': 'Ce que ton Engine en fait',
  'autopilot.res.segments': 'Segments',
  'autopilot.res.segmentsHint': 'Quels secteurs et rôles répondent.',
  'autopilot.res.subjects': "Objets d'e-mail",
  'autopilot.res.subjectsHint': 'Ce qui est ouvert et qui reçoit une réponse.',
  'autopilot.res.thin': 'données insuffisantes',
  'autopilot.res.title': 'Ce qui fonctionne',
  'autopilot.spark.empty': "Apparaît dès que l'envoi démarre.",
  'autopilot.spark.title': "Activité d'envoi (4 semaines)",
  'autopilot.stage.clarify': 'En clarification',
  'autopilot.stage.handover': 'Transféré',
  'autopilot.stage.lost': 'Perdu',
  'autopilot.stage.new': 'Nouveau',
  'autopilot.stage.won': 'Gagné',
  'autopilot.status.active': 'Actif',
  'autopilot.status.awaiting': 'En attente de validation',
  'autopilot.status.contract': 'Contrat signé',
  'autopilot.status.ended': 'Terminé',
  'autopilot.status.offer': 'En préparation',
  'autopilot.status.paused': 'En pause',
  'autopilot.status.setup': 'Configuration',
  'autopilot.status.warmup': 'Warmup',
  'autopilot.step.approvals': 'Validations',
  'autopilot.step.live': 'En direct',
  'autopilot.step.setup': 'Configuration',
  'autopilot.step.warmup': 'Warmup',
  'autopilot.talk.all': 'Tout voir',
  'autopilot.talk.empty':
    "Dès que ta campagne est en ligne, tu verras ici avec qui l'engine échange en ce moment.",
  'autopilot.talk.emptyLive':
    "Aucune conversation en cours pour l'instant — dès la prochaine réponse, l'entreprise apparaîtra ici.",
  'autopilot.talk.title': 'En cours de conversation',
  'autopilot.tasks.approvals': "{n} validations t'attendent",
  'autopilot.tasks.call1': 'Une transmission chaude attend ton appel',
  'autopilot.tasks.calls': '{n} transmissions chaudes attendent ton appel',
  'autopilot.tasks.none': 'Rien à faire — le moteur travaille pour toi.',
  'autopilot.tasks.title': 'Tes tâches',
  'autopilot.tech.allGreen': 'Tout est opérationnel',
  'autopilot.tech.auto': 'Fonctionne automatiquement',
  'autopilot.tech.autoHint':
    "Ces tâches de maintenance s'exécutent en arrière-plan — sans que tu n'aies jamais à lever le petit doigt.",
  'autopilot.tech.blacklists': 'Surveillance des blacklists',
  'autopilot.tech.clean': 'propre',
  'autopilot.tech.dmarcReports': 'Rapports agrégés DMARC actifs',
  'autopilot.tech.domains': "Domaines d'envoi",
  'autopilot.tech.integrations': 'Systèmes connectés',
  'autopilot.tech.intro':
    "Toute ton infrastructure d'envoi en un coup d'œil — domaines, authentification DNS, boîtes mail, monitoring. Nous mettons tout en place et veillons à ce que tout reste au vert ; tu n'as rien à faire.",
  'autopilot.tech.mailboxes': 'Boîtes mail & authentification',
  'autopilot.tech.nis2': 'Domaine confirmé',
  'autopilot.tech.owner': 'Propriétaire : toi',
  'autopilot.tech.pending':
    'Ton infrastructure est en cours de configuration — ta salle de contrôle complète apparaîtra bientôt ici.',
  'autopilot.tech.pipeline': 'Le pipeline IA',
  'autopilot.tech.pipelineHint':
    "Chaque e-mail passe par ces contrôles indépendants avant d'être prêt à être envoyé.",
  'autopilot.tech.placement': 'Dernier test de placement : {n}% en boîte de réception',
  'autopilot.tech.registrar': 'Registrar : {name}',
  'autopilot.tech.rep': 'Réputation {n}',
  'autopilot.tech.replyLogic': 'Intelligence des réponses',
  'autopilot.tech.reputation': 'Réputation & monitoring de délivrabilité',
  'autopilot.tech.ssl': 'TLS/SSL',
  'autopilot.tech.title': 'Technique & délivrabilité',
  'autopilot.tech.warmup': 'Warmup',
  'autopilot.warm.traffic.weekendShort': 'WE',
  'autopilot.warm.traffic.pauseShort': 'Pause',
  'autopilot.warm.traffic.weekend':
    'Week-end : le réseau de chauffe réduit son activité comme prévu',
  'autopilot.warm.traffic.pause': 'Jour de repos dans le réseau de chauffe',
  'autopilot.ov.hero.warmOffen':
    'Tes boîtes mail sont encore en chauffe (jour {d} sur {total}). Donne tes validations maintenant, nous démarrerons dès qu’elles seront prêtes.',
  'autopilot.ov.hero.warmFrei':
    'Tout est validé. Tes boîtes mail sont encore en chauffe (jour {d} sur {total}), puis le premier e-mail partira.',
  'autopilot.ov.hero.fertigOffen':
    'Tes boîtes mail sont prêtes. Il ne manque que tes validations pour démarrer.',
  'autopilot.ov.hero.fertigFrei':
    'Chauffe terminée et tout validé. Nous préparons le premier envoi.',
  'autopilot.ov.hero.startNachFreigabe': 'dès que tu auras donné tes validations',
  'autopilot.ov.hero.startInVorbereitung': 'en préparation',
  'autopilot.mb.st.fertig': 'Chauffe terminée',
  'autopilot.appr.zf.lead':
    'Nous contacterons chaque entreprise que tu n’exclus pas. La coche est facultative et nous aide à comprendre quelles entreprises tu préfères.',
  'autopilot.appr.zf.f.alle': 'Toutes {n}',
  'autopilot.appr.zf.f.dabei': 'Incluses {n}',
  'autopilot.appr.zf.f.raus': 'Exclues {n}',
  'autopilot.appr.zf.f.ohneKontakt': 'Sans contact {n}',
  'autopilot.camp.offenN': '{n} validations en attente : {liste}',
  'autopilot.camp.offen1': 'Une validation en attente : {liste}',
  'autopilot.appr.zf.neuTitle': 'Nouvelle depuis ta dernière visite',
  'autopilot.appr.zf.g.bekanntHinweis':
    '« On la connaît déjà » retire définitivement l’entreprise de tes suggestions, y compris pour les futures campagnes.',
  'autopilot.camp.offenDanach': ', puis {label}',
  'autopilot.ov.ring.bereit': 'prêtes',
  'autopilot.ov.hero.bereitOffen':
    'Prêt à lancer : les {n} boîtes ont un score de délivrabilité d’au moins {s}. Il ne manque que tes validations.',
  'autopilot.ov.hero.bereitFrei':
    'Prêt et validé. Les {n} boîtes ont au moins {s} de délivrabilité ; nous préparons le premier envoi.',
  'autopilot.ov.hero.teilOffen':
    '{bereit} boîtes sur {n} sont prêtes (délivrabilité à partir de {s}). Valide maintenant et nous démarrons dès qu’elles le sont toutes.',
  'autopilot.ov.hero.teilFrei':
    '{bereit} boîtes sur {n} sont prêtes (délivrabilité à partir de {s}). Nous démarrons dès qu’elles le sont toutes.',
  'autopilot.ov.hero.scoreRegel': 'Délivrabilité par boîte · prête à partir de {s}',
  'autopilot.mb.st.bereit': 'Prête à lancer',
  'autopilot.mb.st.bereitTeil': '{bereit} sur {n} prêtes',
  'autopilot.mb.st.mbBereit': 'prête · jour {d}/{total}',
  'autopilot.warm.regel':
    'Une boîte est prête à partir d’un score de délivrabilité de {s}. Les {total} jours sont un repère, pas la condition.',
  'autopilot.camp.vs.post': '{n} par courrier',
  'autopilot.camp.vs.geprueft': '{n} confirmées',
  'autopilot.camp.vs.ungeprueft': '{n} non confirmées',
  'autopilot.camp.vs.zust.ok': 'Adresse confirmée',
  'autopilot.camp.vs.zust.ungeprueft': 'Adresse non confirmée',
  'autopilot.camp.vs.erkl.geprueft':
    'Nous vérifions chaque adresse avant l’envoi. Confirmée signifie que le serveur l’a validée. Non confirmée indique souvent un catch-all, où le serveur répond pareil pour toutes les adresses.',
  'autopilot.camp.vs.absender': 'Expéditeur',
  'autopilot.camp.vs.takt': 'Cadence',
  'autopilot.camp.vs.taktWert': '{n} e-mails par jour',
  'autopilot.camp.vs.naechster': 'prochain envoi {when}',
  'autopilot.camp.vs.keinAbsender':
    'Aucune boîte d’envoi n’est encore associée à cette campagne. Nous la configurerons avant le lancement.',
  'autopilot.camp.vs.hint':
    'Voici comment part l’e-mail. Souligné en vert : issu de notre recherche. En pointillés : rempli par personne à l’envoi.',
  'autopilot.camp.vs.wartetTitel':
    'Entreprises sans adresse e-mail trouvée. Elles s’ajoutent automatiquement dès qu’un contact avec adresse est identifié.',
  'autopilot.camp.vs.empfaenger': 'Destinataires',
  'autopilot.camp.vs.vorschauFuer': 'Aperçu pour',
  'autopilot.camp.vs.an': 'À',
  'autopilot.camp.vs.platzhalter': 'rempli par personne à l’envoi',
  'autopilot.erkl.aria': 'Comment est-ce calculé ?',
  'autopilot.erkl.quelle': 'Source : {q}',
  'autopilot.warm.traffic.title': 'Trafic de chauffe de vos boîtes mail',
  'autopilot.warm.traffic.hint':
    'E-mails de chauffe sortants et enregistrés en boîte de réception pour toutes vos boîtes mail.',
  'autopilot.mb.place.hint':
    'E-mails de préchauffage arrivés en boîte de réception et en spam sur toutes tes boîtes.',
  'autopilot.ov.zu.sub': 'sur {n} e-mails de chauffe des 7 derniers jours',
  'autopilot.warm.scoreChart.title': 'Score de délivrabilité par boîte mail',
  'autopilot.warm.scoreChart.hint':
    'La bande couvre toutes les boîtes, la ligne suit la plus faible. Prêt à partir de {s}.',
  'autopilot.warm.scoreChart.perBox': 'par boîte mail',
  'autopilot.warm.scoreChart.perDomain': 'par domaine',
  'autopilot.warm.scoreChart.schwelle': 'prêt à partir de {s}',
  'autopilot.warm.scoreChart.xHinweis':
    'Chaque point correspond à un changement de score enregistré, avec le score actuel à droite.',
  'autopilot.warm.scoreChart.messpunkt': 'Point {n}',
  'autopilot.warm.chart.gesendet': 'Envoyés',
  'autopilot.warm.scoreChart.titleDomain': 'Score de délivrabilité par domaine',
  'autopilot.warm.scoreChart.hintDomain':
    'La bande couvre tes domaines, la ligne suit le plus faible. Une boîte est prête à partir de {s}.',
  'autopilot.warm.erkl.traffic':
    'Vous voyez ici les e-mails de chauffe du réseau lemwarm. Les chiffres incluent le trafic entrant du réseau et ne représentent pas les envois de campagnes.',
  'autopilot.warm.erkl.placement':
    'Les valeurs montrent où arrivent vos e-mails de chauffe, y compris ceux reçus du réseau. Le taux de réception est le nombre d’e-mails en boîte de réception divisé par la somme des e-mails en boîte de réception et en spam.',
  'autopilot.warm.erkl.tage':
    'Le nombre de jours est indicatif pour la chauffe ; la condition est un score de délivrabilité d’au moins {s} par boîte mail.',
  'autopilot.warm.traffic.nochKeineKampagne':
    'Il s’agit du trafic du réseau de chauffe, pas encore d’e-mails de campagnes.',
  'autopilot.warm.placement.vorwoche':
    'Taux de réception des 7 derniers jours enregistrés par rapport aux 7 jours précédents.',
  'autopilot.camp.vs.absenderKonto':
    'Ces boîtes appartiennent à ton compte. Laquelle envoie cette campagne est défini avant le lancement.',
  'autopilot.camp.vs.quellePruefung': 'vérification e-mail',
  'autopilot.appr.zf.unvollstaendig':
    'Nous affichons les entreprises les plus récentes jusqu’à la limite d’affichage. Les plus anciennes n’y sont pas.',
  'autopilot.appr.zf.ladeFehler':
    'Une partie de tes entreprises n’a pas pu être chargée. Recharge la page, nous réessayons.',
  'autopilot.warm.scoreChart.schwelleKurz': 'prêt',
  'autopilot.warm.scoreChart.alle': 'Toutes',
  'autopilot.warm.scoreChart.hintEines': 'Historique de {adresse}. Prêt à partir de {s}.',
  // LEA-505 — Ein-Klick-Nachkauf von Kontakt-Paketen (Bestätigungskarte + Checkout-Einwilligung)
  'refill.checkoutConsent':
    "Ta carte sera enregistrée pour de futurs réassorts en un clic. Elle n'est débitée que si tu confirmes explicitement un réassort au montant affiché — pas d'abonnement, pas de recharge automatique. Tu peux supprimer la carte à tout moment dans le portail client.",
  'refill.title': 'Racheter des contacts',
  'refill.subtitle': 'Avec ta carte enregistrée — sans repasser par le checkout.',
  'refill.choose': 'Choisir un pack',
  'refill.pack': '{n} contacts',
  'refill.net': '{amount} HT',
  'refill.total': 'Total',
  'refill.inclTax': 'dont {tax} de TVA',
  'refill.reverseCharge': 'Sans TVA — autoliquidation, la taxe est due par le preneur.',
  'refill.cardLabel': 'Payé avec {brand} •••• {last4}',
  'refill.cta': 'Payer {amount} maintenant',
  'refill.quoting': 'Calcul du montant …',
  'refill.paying': 'Paiement en cours …',
  'refill.terms': "Paiement unique, sans abonnement. Tes contacts n'expirent jamais.",
  // LEA-518 — first contact-pack purchase (Checkout) for reveal customers
  'packs.first.title': 'Acheter des contacts',
  'packs.first.subtitle': 'Choisis un pack, puis utilise-le pour débloquer des contacts.',
  'packs.first.balance': 'Contacts disponibles : {n}',
  'packs.first.popular': 'Populaire',
  'packs.first.cta': 'Continuer vers le paiement',
  'packs.first.redirecting': 'Redirection vers Stripe…',
  'packs.first.checkoutNote':
    "Tu paies en toute sécurité via Stripe à l'étape suivante, où tu vois le montant final TVA incluse.",
  'packs.first.error': "Le paiement n'a pas pu être lancé. Réessaie.",
  'packs.first.loadError': "Les packs n'ont pas pu être chargés pour le moment.",
  'packs.first.retry': 'Réessayer',
  'refill.success': '{n} contacts crédités. Nouveau solde : {balance}.',
  'refill.again': 'Acheter un autre pack',
  'refill.amountChanged': 'Le montant a changé. Merci de confirmer le nouveau montant.',
  'refill.inProgress': 'Un réassort est déjà en cours. Un instant …',
  'refill.processing':
    'Le paiement est encore en cours de traitement. Nous revérifions dans un instant.',
  'refill.failedDeclined': "Ta banque a refusé le paiement. Rien n'a été débité.",
  'refill.failedAuth': "La confirmation auprès de ta banque n'a pas abouti. Rien n'a été débité.",
  'refill.failed': "Le paiement n'a pas été effectué. Rien n'a été débité.",
  'refill.error': 'Cela n’a pas fonctionné. Réessaie dans un instant.',
  'refill.checking': 'Nous vérifions le statut de ton paiement …',
  'refill.unknown':
    "Nous n'avons pas encore pu confirmer le paiement. Vérifie ton solde avant de racheter.",
  'refill.retryQuote': 'Recharger le montant',
  'refill.checkStatus': 'Vérifier le paiement',

  'auth.register.errPwPolicy':
    'Mot de passe trop faible. Utilisez au moins 8 caractères avec majuscules, minuscules, un chiffre et un caractère spécial.',
  'auth.err.emailTaken': 'Cette adresse e-mail est déjà enregistrée. Connectez-vous.',
  'auth.err.rateLimited':
    'Trop de tentatives depuis cette connexion. Réessayez dans {minutes} minutes au plus tard.',
  'auth.err.rateLimitedLater': 'Trop de tentatives depuis cette connexion. Réessayez plus tard.',
  'auth.err.network': 'Impossible de joindre le serveur. Vérifiez votre connexion internet.',
  'auth.err.busy': 'Le serveur est très sollicité en ce moment. Réessayez dans un instant.',
  'auth.err.signupFailed': 'L’inscription a échoué. Réessayez dans un instant.',
  'auth.err.invalidInput': 'Vérifiez vos saisies.',
  'auth.err.turnstileFailed':
    'La vérification anti-robot a échoué ou a expiré. Rechargez la page et réessayez.',
  'auth.err.turnstileBlocked':
    'La vérification de sécurité n’a pas pu s’exécuter. Un bloqueur de publicités ou de traqueurs peut l’empêcher : autorisez challenges.cloudflare.com pour cette page ou essayez un autre navigateur.',
  'auth.err.popupBlocked':
    'La fenêtre de connexion a été bloquée. Autorisez les pop-ups pour ce site et réessayez.',
  'auth.err.popupClosed':
    'La fenêtre de connexion a été fermée avant la fin de l’authentification.',
  'auth.err.otherProvider':
    'Un compte existe déjà avec cet e-mail. Connectez-vous avec {provider}.',
  'auth.err.otherMethod':
    'Un compte existe déjà avec cet e-mail. Connectez-vous comme lors de votre inscription (Google, Microsoft ou e-mail et mot de passe).',
  'auth.err.providerPassword': 'votre e-mail et votre mot de passe',
  'auth.err.firstName': 'Saisissez votre prénom.',
  'auth.err.lastName': 'Saisissez votre nom.',
  'auth.err.pwLong': 'Le mot de passe est trop long.',
  'auth.err.oauthFailed':
    'La connexion avec le fournisseur d’identité a échoué. Veuillez réessayer.',
  'auth.err.noEmailFromProvider':
    'Nous n’avons pas reçu d’adresse e-mail de votre fournisseur. Veuillez utiliser un autre mode de connexion.',
  'auth.err.ssoUnavailable':
    'La connexion avec Google ou Microsoft est temporairement indisponible. Veuillez utiliser votre e-mail et votre mot de passe.',
  'auth.err.accountGone': 'Ce compte a été supprimé ou désactivé.',
  'auth.err.sessionFailed': 'Impossible de créer la session. Veuillez réessayer.',
  'auth.register.next.prism':
    'Étape suivante : décrivez votre cible et découvrez de vraies entreprises. Vous ne payez que lorsque vous débloquez des leads.',
  'auth.register.next.noCard':
    'Après l’inscription, vous pouvez commencer tout de suite. Aucun moyen de paiement requis.',
  'auth.register.next.trial':
    'Étape suivante : choisissez un forfait et testez pendant 3 jours. Carte requise, 0 € aujourd’hui ; le forfait continue ensuite, sauf résiliation avant la fin de l’essai.',
  'auth.register.next.plan':
    'Étape suivante : choisissez un forfait. Le paiement par carte est dû immédiatement.',
  'auth.register.busyHint': 'Votre compte est en cours de création. Cela prend quelques secondes.',
  'auth.login.legalSso':
    'Nouveau ici ? Se connecter avec Google ou Microsoft crée automatiquement un compte et vous acceptez nos {terms}. Vous trouverez des informations sur vos données dans notre {privacy}.',
  'auth.r19.form.pw.title': 'Exigences du mot de passe',
  'auth.r19.form.pw.len': 'Au moins 8 caractères',
  'auth.r19.form.pw.case': 'Majuscules et minuscules',
  'auth.r19.form.pw.digit': 'Un chiffre',
  'auth.r19.form.pw.special': 'Un caractère spécial',
  'auth.r19.form.pw.met': 'rempli',
  'auth.r19.form.pw.open': 'à remplir',
  'auth.r19.chat.greeting':
    'Posez votre question ici. Si vous indiquez votre adresse e-mail, nous pourrons aussi vous répondre plus tard.',
  'auth.r19.chat.failed': 'Le chat ne peut pas s’ouvrir pour le moment. Écrivez-nous plutôt à',

  'prism.abandon.fit': 'Les entreprises ne correspondent pas',
  'prism.abandon.fitQ': 'Quelles entreprises attendais-tu ?',
  'prism.abandon.freeText': 'Ou dis-le-nous en une phrase…',
  'prism.abandon.later': 'Je regarderai plus tard',
  'prism.abandon.price': 'Le prix',
  'prism.abandon.q': "Petite question : qu'est-ce qui te retient ?",
  'prism.abandon.send': 'Envoyer',
  'prism.abandon.skip': 'Passer',
  'prism.abandon.thanks': 'Merci — ça nous aide vraiment.',
  'prism.checkout.autoNote':
    'Passe automatiquement à l’abonnement Starter (250 crédits/mois) si tu ne résilies pas dans les 3 jours d’essai.',
  // Prism-Umsatzpaket (16.10.2026): Abo-Satz, Entscheider vor dem Kauf, Hinweise.
  'prism.abo.line':
    '49 € aujourd’hui · dès le jour 4 : 290 €/mois · résiliable chaque mois en un clic',
  'prism.abo.afterDelivery':
    'Chaque semaine ~{n} nouvelles entreprises. Pour chacune, on cherche le décideur, et tu ne paies que si on le trouve.',
  'prism.abo.afterCredits':
    'Ensuite, {credits} crédits chaque mois pour de nouvelles entreprises et de nouveaux contacts.',
  'prism.teaser.tag':
    'Décideur offert en aperçu',
  'prism.teaser.running':
    'Nous cherchons le décideur chez {company} …',
  'prism.teaser.foundShort':
    'Décideur trouvé : {name}',
  'prism.teaser.noneShort':
    'Aucun décideur avec preuve trouvé',
  'prism.teaser.failedShort':
    'Recherche impossible pour le moment',
  'prism.teaser.open':
    'Voir',
  'prism.teaser.close':
    'Replier',
  'prism.teaser.role':
    'Fonction',
  'prism.teaser.source':
    'Preuve',
  'prism.teaser.email':
    'E-mail',
  'prism.teaser.src.impressum':
    'Mentions légales de {domain}',
  'prism.teaser.src.handelsregister':
    'Registre du commerce',
  'prism.teaser.src.website':
    'Site de {domain}',
  'prism.teaser.mail.verified':
    'vérifié auprès du serveur mail',
  'prism.teaser.mail.probable':
    'très probablement valide',
  'prism.teaser.mail.found':
    'tel qu’indiqué sur leur site',
  'prism.teaser.mail.none':
    'aucun e-mail personnel trouvé',
  'prism.teaser.foundNote':
    'C’est ainsi que nous recherchons chacune de tes {n} entreprises. Tu vois l’e-mail complet après le déblocage, et le téléphone quand il est disponible.',
  'prism.teaser.noneBody':
    'Pour {company}, nous n’avons trouvé aucun décideur avec preuve (mentions légales, registre du commerce ou site de l’entreprise). Plutôt que d’inventer, nous préférons ne rien afficher.',
  'prism.teaser.noneNote':
    'Après le déblocage, un crédit ne compte que si nous trouvons un contact.',
  'prism.teaser.failedBody':
    'La recherche n’a pas abouti pour le moment. Après le déblocage, elle tourne pour les {n} entreprises.',
  'prism.teaser.cta':
    'Débloquer les {n}',
  'prism.cardHint.body':
    'Nous recherchons le décideur chez {company} après le déblocage : nom et fonction, plus e-mail ou téléphone quand ils sont publics.',
  'prism.cardHint.example':
    'Tu vois un exemple plus haut chez {top}.',
  'prism.cardHint.cta':
    'Débloquer',
  'prism.website.skip':
    'Continuer sans site',
  'prism.website.issue.own_product':
    'C’est notre site, pas le tien. Indique ici le site de ta propre entreprise pour que nous comprenions ce que tu vends.',
  'prism.website.issue.ai_chat':
    'C’est un lien vers un chat IA. Il nous faut le site de ta propre entreprise, p. ex. « ton-entreprise.fr ».',
  'prism.website.issue.social':
    'Un profil sur les réseaux sociaux nous en dit trop peu sur ton offre. Tu as un site à toi ? Sinon, passe simplement cette étape.',
  'prism.website.issue.redirect':
    'C’est un lien court ou de redirection. Indique directement l’adresse de ton site, p. ex. « ton-entreprise.fr ».',
  'prism.notice.title':
    'Un mot sur les données',
  'prism.notice.local_b2c':
    'Les petits commerces pour particuliers (p. ex. coiffeurs ou snacks) n’affichent souvent en ligne que le téléphone et le gérant. Nous y trouvons moins souvent des e-mails vérifiés de décideurs que chez les entreprises qui vendent aux professionnels.',
  'prism.notice.outside_dach':
    'Nos données sont les plus complètes en Allemagne, en Autriche et en Suisse. Ailleurs, mentions légales et registre du commerce manquent souvent : nous y trouvons moins de décideurs.',
  'prism.notice.continue':
    'Tu peux quand même lancer la recherche.',
  // Gratis-Leads vor dem Kauf + Hinweise für die übrige Liste (16.10.2026).
  'prism.free.tag':
    'Tes {n} leads gratuits, utilisables tout de suite',
  'prism.free.tagRunning':
    'Nous cherchons tes {n} leads gratuits',
  'prism.free.tagOne':
    'Ton lead gratuit, utilisable tout de suite',
  'prism.free.tagNone':
    'Leads gratuits : aucun avec preuve cette fois',
  'prism.free.tagSlow':
    'Tes leads gratuits prennent un peu plus de temps',
  'prism.free.slowBody':
    'La recherche prend plus de temps que d’habitude. Nous afficherons tes leads gratuits ici dès qu’ils seront prêts, même si tu reviens plus tard.',
  'prism.free.running':
    'Nous cherchons les décideurs de tes meilleures entreprises … ({found} sur {n})',
  'prism.free.noneBody':
    'Pour tes meilleures entreprises, nous n’avons trouvé aucun décideur avec preuve et e-mail (mentions légales, registre du commerce ou site de l’entreprise). Plutôt que d’inventer, nous préférons ne rien afficher. Après le déblocage, un crédit ne compte que si nous trouvons un contact.',
  'prism.free.fewer':
    '{found} sur {n} ont pu être prouvés. Pour les autres entreprises du haut de liste, la preuve manquait : nous n’y affichons rien.',
  'prism.free.yours':
    'Copie-les ou exporte-les, ils sont à toi.',
  'prism.free.export':
    'Exporter en CSV',
  'prism.free.copy':
    'Copier',
  'prism.free.copied':
    'Copié',
  'prism.free.cta':
    'Débloquer les {n}',
  'prism.free.usedNote':
    'Les leads gratuits sont offerts une fois par compte et par entreprise. Tu vois ce décideur ici en aperçu.',
  'prism.free.csv.company':
    'Entreprise',
  'prism.free.csv.domain':
    'Domaine',
  'prism.free.csv.name':
    'Nom',
  'prism.free.csv.role':
    'Fonction',
  'prism.free.csv.email':
    'E-mail',
  'prism.free.csv.phone':
    'Téléphone',
  'prism.free.csv.source':
    'Preuve',
  'prism.pattern.first':
    'prénom',
  'prism.pattern.last':
    'nom',
  'prism.pattern.f':
    'p',
  'prism.hint.freeAbove':
    'Débloqué gratuitement, voir plus haut',
  'prism.hint.dmsOne':
    '1 décideur : {roles}',
  'prism.hint.dmsMany':
    '{count} décideurs : {roles}',
  'prism.hint.dmsNoRole':
    '{count} décideurs prouvés',
  'prism.hint.pattern':
    'Format d’e-mail repéré :',
  'prism.hint.src.impressum':
    'Mentions légales',
  'prism.hint.src.handelsregister':
    'Registre du commerce',
  'prism.hint.src.website':
    'Site web',
  'prism.hint.unlock':
    'Débloquer',
  'prism.hint.unlockSub':
    'le contact',
  'prism.freelead.tagTop': 'Ta meilleure entreprise',
  'prism.rail.label': 'Progression',
  'prism.rail.audience': 'Cible',
  'prism.rail.website': 'Site web',
  'prism.rail.refine': 'Affinage',
  'prism.rail.result': 'Résultat',
  'prism.rail.done': 'terminé',
  'prism.steps.earlier': '{n} étapes précédentes terminées',
  'prism.lead.evidenceTag': 'Sur leur site :',
  'prism.plan.termsStrong': 'Dès le jour 4 : 290 €/mois.',
  'prism.plan.termsBody':
    'Après les 3 jours d’essai, ton accès passe automatiquement à l’abonnement Starter (250 crédits/mois). Si tu résilies avant dans ton compte, tu ne paies que les 49 €.',
  'prism.rateLimited.body':
    'Tu as utilisé toutes tes recherches pour aujourd’hui. On reprend demain — tes informations restent enregistrées.',
  'prism.rateLimited.title': 'Limite quotidienne atteinte',
  'prism.results.queriesLabel': 'Nos recherches :',
  'prism.results.queriesMore': '+{count} autres',
  'prism.score.possible': 'Fit possible',
  'prism.target.errEmpty': 'Dis-nous d’abord qui tu veux atteindre — p. ex. « dentistes à Lyon ».',
  // LEA-595: Setup-Lieferungen freischalten (für jedes Offer).
  'ld.reveal.title': 'Contacts trouvés, encore verrouillés',
  'ld.reveal.hint':
    "Vous verrez le nom, l'e-mail et le téléphone après le déverrouillage. Un déverrouillage ouvre tous les contacts de cette entreprise.",
  'ld.reveal.cta': 'Déverrouiller les contacts',
  'ld.reveal.confirm':
    'Cela utilise 1 crédit. Vous verrez ensuite les contacts de cette entreprise en entier, et le plan de prospection ne coûte rien de plus.',
  'ld.reveal.confirmCta': 'Déverrouiller pour 1 crédit',
  'ld.reveal.busy': 'Déverrouillage…',
  'ld.reveal.done': 'Contacts déverrouillés, 1 crédit utilisé.',
  'ld.reveal.already': "Déjà déverrouillé, rien n'a été débité à nouveau.",
  'ld.reveal.notEligible':
    "Aucune personne de contact joignable : il n'y a rien à déverrouiller et rien n'est débité.",
  'ld.reveal.verificationPending':
    "Les contacts sont encore en cours de vérification. Réessayez dans une minute ; rien n'a été débité.",
  'ld.reveal.researchRunning':
    "La recherche de contacts est encore en cours. Vous pourrez déverrouiller dès qu'elle sera terminée.",
  'ld.reveal.failed':
    "Le déverrouillage n'a pas abouti. Réessayez ; vous n'êtes jamais débité deux fois.",
  'ld.reveal.noCredits': 'Il vous faut 1 crédit pour déverrouiller.',
  'ld.reveal.buyContacts': 'Votre solde est vide – vous pouvez racheter des contacts ici',
  'ld.reveal.planLocked': "Déverrouillez d'abord les contacts",
  'ld.reveal.planNoContact':
    'Aucune personne de contact joignable, donc pas de plan de prospection',
  'ld.contact.lockedEmailPhone': 'E-mail et téléphone après déverrouillage',
  'ld.contact.lockedEmail': 'E-mail après déverrouillage',
  'ld.contact.lockedPhone': 'Téléphone après déverrouillage',
  // Wöchentliche Lieferung, Etappe B (16.10.2026) — Kundenseite + Assistant.
  'delivery.card.title': 'Livraison hebdomadaire',
  'delivery.card.badgeNew': 'Nouveau',
  'delivery.card.forAudience': 'pour {name}',
  'delivery.card.amount': 'Chaque semaine ~{n} nouvelles entreprises. Pour chacune, on cherche le décideur, et tu ne paies que si on le trouve.',
  'delivery.card.credits': 'Jusqu’à {credits} crédits par livraison : 1 par entreprise, 1 par décideur trouvé',
  'delivery.card.switchLabel': 'Activer ou désactiver la livraison hebdomadaire',
  'delivery.card.on': 'Activée',
  'delivery.card.off': 'Désactivée',
  'delivery.card.offHint': 'Active-la et la première livraison démarre tout de suite.',
  'delivery.card.next.label': 'Prochaine livraison',
  'delivery.card.next.afterRating': 'dès que tu as évalué la livraison actuelle, au plus tard le {date}',
  'delivery.card.next.soon': 'démarre bientôt',
  'delivery.card.running': 'Livraison {no} en cours : {delivered} sur {target} entreprises',
  'delivery.card.runningConnect': 'Livraison {no} : {delivered} entreprises reçues, on cherche maintenant les décideurs',
  'delivery.card.lowCredits': 'Tu as {credits} crédits, une livraison complète en demande {need}.',
  'delivery.card.topUp': 'Recharger des crédits',
  'delivery.card.loadFailed': 'Impossible de charger la livraison.',
  'delivery.pause.out_of_credits.title': 'En pause : plus de crédits',
  'delivery.pause.out_of_credits.body': 'Avec de nouveaux crédits, la livraison reprend toute seule.',
  'delivery.pause.niche_exhausted.title': 'En pause : ta cible est épuisée',
  'delivery.pause.niche_exhausted.body': 'Nous ne trouvons plus de nouvelles entreprises ici. Élargis-la en un clic :',
  'delivery.pause.subscription_ended.title': 'En pause : ton abonnement est terminé',
  'delivery.pause.subscription_ended.body': 'Avec une offre active, la livraison continue.',
  'delivery.pause.subscription_ended.cta': 'Choisir une offre',
  'delivery.pause.subscription_paused.title': 'En pause : ton abonnement est suspendu',
  'delivery.pause.subscription_paused.body': 'Dès que ton abonnement reprend, la livraison continue.',
  'delivery.pause.payment_issue.title': 'En pause : paiement en attente',
  'delivery.pause.payment_issue.body': 'Mets à jour ton moyen de paiement et la livraison continue.',
  'delivery.pause.payment_issue.cta': 'Mettre à jour le paiement',
  'delivery.pause.other.title': 'En pause',
  'delivery.pause.other.body': 'Écris-nous un petit message et on regarde.',
  'delivery.expand.hint': 'Cela modifie ta cible, aussi pour tes recherches manuelles.',
  'delivery.pause.profile_missing.title': 'En pause : cette cible n’existe plus',
  'delivery.pause.profile_missing.body': 'Crée une nouvelle cible et active la livraison dessus.',
  'delivery.pause.profile_missing.cta': 'Créer une cible',
  'delivery.pause.not_self_service.title': 'En pause : notre équipe gère ton compte',
  'delivery.pause.not_self_service.body': 'Tu reçois tes entreprises via Autopilot.',
  'delivery.pause.account_closed.title': 'En pause : suppression demandée',
  'delivery.pause.account_closed.body': 'Nous ne livrons pas un compte en cours de suppression.',
  'delivery.pause.unsupported_model.title': 'En pause : non incluse dans ton offre',
  'delivery.pause.unsupported_model.body': 'La livraison fait partie de Basic, Starter et Growth.',
  'delivery.short.title': 'Dernière livraison : {delivered} sur {target} entreprises',
  'delivery.short.body': 'Ta cible ne donne pas plus pour le moment. Élargis-la en un clic :',
  'delivery.expand.loading': 'Vérification des suggestions …',
  'delivery.expand.none': 'Décris ta cible de façon plus large pour continuer.',
  'delivery.expand.edit': 'Modifier la cible',
  'delivery.expand.applied': 'Cible élargie. La prochaine livraison démarre bientôt.',
  'delivery.expand.opt.area': 'Élargir à tout {area} au lieu de {from} et lancer la livraison',
  'delivery.expand.opt.dach': 'Élargir à l’Allemagne, l’Autriche et la Suisse et lancer la livraison',
  'delivery.expand.opt.industry': 'Ajouter {industry} à ta cible et lancer la livraison',
  'delivery.expand.opt.size': 'Accepter toutes les tailles d’entreprise au lieu de {from} salariés et lancer la livraison',
  'delivery.toast.on': 'La livraison est activée. La première démarre bientôt.',
  'delivery.toast.off': 'La livraison est désactivée.',
  'delivery.toast.failed': 'Ça n’a pas marché. Réessaie.',
  'delivery.toast.planRequired': 'Pour la livraison, il te faut une offre active.',
  'delivery.history.title': 'Livraisons précédentes',
  'delivery.history.cycle': 'Livraison {no}',
  'delivery.history.companies': '{n} entreprises',
  'delivery.history.withContact': '{n} avec décideur',
  'delivery.history.acceptRate': '{pct} % pertinentes',
  'delivery.history.noRating': 'pas encore évaluée',
  'delivery.history.review': 'Évaluer maintenant ({n} en attente)',
  'delivery.history.show': 'Voir',
  'delivery.history.empty': 'Ta première livraison apparaîtra ici.',
  'delivery.history.more': 'Tout afficher',
  'delivery.history.less': 'Afficher moins',
  'delivery.filter.prefix': 'Filtré sur :',
  'delivery.notif.ready.title': 'Ta livraison est arrivée : {n} entreprises',
  'delivery.notif.ready.body': 'dont {connected} avec décideur, pour {name}. Évalue-les et la suivante arrive.',
  'delivery.notif.paused.out_of_credits.title': 'Livraison en pause : plus de crédits',
  'delivery.notif.paused.out_of_credits.body': 'Avec de nouveaux crédits, elle reprend toute seule.',
  'delivery.notif.paused.niche_exhausted.title': 'Livraison en pause : cible épuisée',
  'delivery.notif.paused.niche_exhausted.body': 'Élargis {name} en un clic pour continuer.',
  'agent.delivery.tool.status': 'Voir la livraison',
  'agent.delivery.tool.set': 'Livraison hebdomadaire',
  'agent.delivery.cost.enable': 'Jusqu’à {credits} crédits par livraison : chaque semaine ~{n} nouvelles entreprises, et pour chacune on cherche le décideur. Ce crédit, tu ne le paies que si on le trouve. Tu peux la désactiver à tout moment.',
};

export default fr;
